webpackJsonp([0],{

/***/ 1522:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.addToast = addToast;
exports.removeToast = removeToast;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var INITIAL_STATE = {
  toastNotifications: []
};

var ADD_TOAST = 'reducer/toasts/ADD_TOAST';
var REMOVE_TOAST = 'reducer/toasts/REMOVE_TOAST';

function toastsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case ADD_TOAST:
      return handleAddToast(state, payload);
    case REMOVE_TOAST:
      return handleRemoveToast(state, payload);
    default:
      return state;
  }
}

function handleAddToast(state, _ref) {
  var id = _ref.id,
      message = _ref.message,
      type = _ref.type;

  return _extends({}, state, {
    toastNotifications: [{ id: id, message: message, type: type }].concat(_toConsumableArray(state.toastNotifications))
  });
}

function handleRemoveToast(state, _ref2) {
  var id = _ref2.id;

  return _extends({}, state, {
    toastNotifications: state.toastNotifications.filter(function (toast) {
      return toast.id !== id;
    })
  });
}

// Action creators

function addToast(id, message, type) {
  return {
    type: ADD_TOAST,
    payload: {
      id: id,
      message: message,
      type: type
    }
  };
}

function removeToast(id) {
  return {
    type: REMOVE_TOAST,
    payload: {
      id: id
    }
  };
}

exports.default = toastsReducer;

/***/ }),

/***/ 1523:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getToastNotifications = getToastNotifications;
exports.generateToastNotificationId = generateToastNotificationId;
function getToastNotifications(state) {
  return getLocalState(state).toastNotifications;
}

function generateToastNotificationId() {
  return "" + Date.now();
}

function getLocalState(state) {
  return state.toasts;
}

/***/ }),

/***/ 1524:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(47);

var _reactRouter = __webpack_require__(49);

var _getFilteredDealerOrders = __webpack_require__(668);

var _getFilteredDealerOrders2 = _interopRequireDefault(_getFilteredDealerOrders);

var _dealers = __webpack_require__(352);

var _orders = __webpack_require__(238);

var _finalizedOrders = __webpack_require__(1228);

var _finalizedOrders2 = _interopRequireDefault(_finalizedOrders);

var _OrdersLayout = __webpack_require__(3406);

var _OrdersLayout2 = _interopRequireDefault(_OrdersLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapStateToProps = function mapStateToProps(state) {
  var dealer = state.dealer,
      chamaID = state.auth.chamaID;

  var order = state.orders.dict[state.orders.currentOrderId];
  var dealers = state.dealer.all;
  var notification = state.notifications.current;
  var isFetching = dealer.isFetching;
  var offset = state.time.offset;


  var orderCompareNewestOnTop = function orderCompareNewestOnTop(_ref, _ref2) {
    var currentTicketA = _ref.currentTicket;
    var currentTicketB = _ref2.currentTicket;

    // TODO: fix & enable
    // eslint-disable-next-line no-nested-ternary
    return currentTicketA.modificationTime > currentTicketB.modificationTime ? -1 : currentTicketA.modificationTime < currentTicketB.modificationTime ? 1 : 0;
  };

  var filteredOrders = (0, _getFilteredDealerOrders2.default)(state);

  var ordersFinalized = (0, _finalizedOrders2.default)(filteredOrders).sort(orderCompareNewestOnTop);

  return {
    dealers: dealers,
    order: order,
    ordersFinalized: ordersFinalized,
    notification: notification,
    offset: offset,
    isFetchingDealer: isFetching,
    ticketsFetched: state.orders.fetched,
    oldTerms: dealer.termsAndConditions,
    isDealerFetched: !!(dealers && dealers.length > 0),
    userId: chamaID
  };
};

var Orders = function (_Component) {
  _inherits(Orders, _Component);

  function Orders() {
    _classCallCheck(this, Orders);

    return _possibleConstructorReturn(this, (Orders.__proto__ || Object.getPrototypeOf(Orders)).apply(this, arguments));
  }

  _createClass(Orders, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.startFetchingTickets();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_OrdersLayout2.default, this.props);
    }
  }]);

  return Orders;
}(_react.Component);

Orders.propTypes = {
  startFetchingTickets: _propTypes2.default.func
};
Orders.defaultProps = {
  startFetchingTickets: Function.prototype
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, {
  startFetchingTickets: _orders.startFetchingTickets,
  assignTicketToCurrentUser: _orders.assignTicketToCurrentUser,
  unAssignTicketToCurrentUser: _orders.unAssignTicketToCurrentUser,
  fetchMoreFinalizedTickets: _orders.fetchMoreFinalizedTickets,
  dismissOrder: _orders.dismissOrder,
  cancelDelivery: _orders.cancelDelivery,
  toggleFilter: _dealers.toggleFilter,
  setCurrentOrder: _orders.setCurrentOrder
})(Orders));

/***/ }),

/***/ 1525:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _analytics = __webpack_require__(411);

var track = function track(eventName, properties) {
  try {
    (0, _analytics.track)(eventName, properties);
  } catch (e) {
    console.error(e);
  }
};

exports.default = track;

/***/ }),

/***/ 1526:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var START_FETCHING_DRIVERS = exports.START_FETCHING_DRIVERS = 'START_FETCHING_DRIVERS';
var FETCHING_DRIVERS_SUCCESS = exports.FETCHING_DRIVERS_SUCCESS = 'FETCHING_DRIVERS_SUCCESS';
var FETCHING_DRIVERS_ERROR = exports.FETCHING_DRIVERS_ERROR = 'FETCHING_DRIVERS_ERROR';

var startFetchingDrivers = function startFetchingDrivers() {
  return {
    type: START_FETCHING_DRIVERS
  };
};

var doneFetchingDrivers = function doneFetchingDrivers(drivers) {
  return {
    type: FETCHING_DRIVERS_SUCCESS,
    drivers: drivers
  };
};

var errorFetchingDrivers = function errorFetchingDrivers() {
  return {
    type: FETCHING_DRIVERS_ERROR
  };
};

var fetchDrivers = exports.fetchDrivers = function fetchDrivers(dealerId, lat, lon) {
  return function (dispatch, getState, _ref) {
    var api = _ref.api;

    dispatch(startFetchingDrivers());

    return api.fetchDrivers(dealerId, lat, lon).then(function (drivers) {
      return dispatch(doneFetchingDrivers(drivers));
    }).catch(function (e) {
      dispatch(errorFetchingDrivers());

      throw new Error(e);
    });
  };
};

/***/ }),

/***/ 1527:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.soundWarningDismissed = exports.soundFailed = exports.soundPlayed = exports.unmuteSound = exports.muteSound = exports.SOUND_WARNING_DISMISSED = exports.SOUND_PLAYBACK = exports.UNMUTE_ORDER_SOUND = exports.MUTE_ORDER_SOUND = undefined;

var _analytics = __webpack_require__(411);

var MUTE_ORDER_SOUND = exports.MUTE_ORDER_SOUND = 'MUTE_ORDER_SOUND';
var UNMUTE_ORDER_SOUND = exports.UNMUTE_ORDER_SOUND = 'UNMUTE_ORDER_SOUND';
var SOUND_PLAYBACK = exports.SOUND_PLAYBACK = 'Order_SoundPlayback_mdt';
var SOUND_WARNING_DISMISSED = exports.SOUND_WARNING_DISMISSED = 'Order_SoundWarningDismissed';

var muteSound = exports.muteSound = function muteSound() {
  return function (dispatch) {
    dispatch({
      type: MUTE_ORDER_SOUND
    });
  };
};

var unmuteSound = exports.unmuteSound = function unmuteSound() {
  return function (dispatch) {
    dispatch({
      type: UNMUTE_ORDER_SOUND
    });
  };
};

var soundPlayed = exports.soundPlayed = function soundPlayed() {
  return function (dispatch) {
    dispatch({
      type: _analytics.TYPE_TRACK,
      payload: {
        name: SOUND_PLAYBACK,
        properties: {
          isPlayed: true
        }
      }
    });
  };
};

var soundFailed = exports.soundFailed = function soundFailed(error) {
  return function (dispatch) {
    dispatch({
      type: _analytics.TYPE_TRACK,
      payload: {
        name: SOUND_PLAYBACK,
        properties: {
          isPlayed: false,
          error: error
        }
      }
    });
  };
};

var soundWarningDismissed = exports.soundWarningDismissed = function soundWarningDismissed() {
  return function (dispatch) {
    dispatch({
      type: _analytics.TYPE_TRACK,
      payload: {
        name: SOUND_WARNING_DISMISSED
      }
    });
  };
};

/***/ }),

/***/ 1528:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isOrderAssignedToUser = function isOrderAssignedToUser(uid, order) {
  return uid === (order && order.currentTicket && order.currentTicket.assignedToUserId);
};

exports.default = isOrderAssignedToUser;

/***/ }),

/***/ 1529:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var START_FETCHING_ORDER_EVENT_HISTORY = exports.START_FETCHING_ORDER_EVENT_HISTORY = 'START_FETCHING_ORDER_EVENT_HISTORY';
var SUCCESS_FETCHING_ORDER_EVENT_HISTORY = exports.SUCCESS_FETCHING_ORDER_EVENT_HISTORY = 'SUCCESS_FETCHING_ORDER_EVENT_HISTORY';
var ERROR_FETCHING_ORDER_EVENT_HISTORY = exports.ERROR_FETCHING_ORDER_EVENT_HISTORY = 'ERROR_FETCHING_ORDER_EVENT_HISTORY';

var fetchOrderEventHistory = exports.fetchOrderEventHistory = function fetchOrderEventHistory(dealerId, orderId) {
  return function (dispatch, getState, _ref) {
    var api = _ref.api;

    var success = function success(_ref2) {
      var statusHistory = _ref2.statusHistory;
      return dispatch({
        type: SUCCESS_FETCHING_ORDER_EVENT_HISTORY,
        dealerId: dealerId,
        orderId: orderId,
        eventHistory: statusHistory
      });
    };

    var error = function error() {
      return dispatch({
        type: ERROR_FETCHING_ORDER_EVENT_HISTORY,
        dealerId: dealerId,
        orderId: orderId
      });
    };

    dispatch({
      type: START_FETCHING_ORDER_EVENT_HISTORY,
      dealerId: dealerId,
      orderId: orderId
    });

    return api.fetchOrderEventHistory(dealerId, orderId).then(success).catch(error);
  };
};

/***/ }),

/***/ 1530:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var mui = __webpack_require__(65);
var SvgIcon = mui.SvgIcon;

var createClass = __webpack_require__(73);

var ContentContentCopy = createClass({
  displayName: 'ContentContentCopy',

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z' })
    );
  }

});

module.exports = ContentContentCopy;

/***/ }),

/***/ 1531:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOngoingOrdersDropdownValue = exports.getIncomingOrdersDropdownValue = undefined;

var _user = __webpack_require__(353);

var _reduxForm = __webpack_require__(207);

var ORDERS_INCOMING = '@ORDERS/INCOMING';
var ORDERS_ONGOING = '@ORDERS/ONGOING';

exports.default = _reduxForm.reducer.plugin({
  'admin/changeOpeningTimes': function adminChangeOpeningTimes(state, action) {
    switch (action.type) {
      case _user.LOGOUT:
        return undefined;
      default:
        return state;
    }
  },
  'admin/changeBottlePrice': function adminChangeBottlePrice(state, action) {
    switch (action.type) {
      case _user.LOGOUT:
        return undefined;
      default:
        return state;
    }
  }
});


var getIncomingOrdersDropdownValue = function getIncomingOrdersDropdownValue(state) {
  return state.form[ORDERS_INCOMING] ? state.form[ORDERS_INCOMING].values.orderType.value : null;
};

var getOngoingOrdersDropdownValue = function getOngoingOrdersDropdownValue(state) {
  return state.form[ORDERS_ONGOING] ? state.form[ORDERS_ONGOING].values.orderType.value : null;
};

exports.getIncomingOrdersDropdownValue = getIncomingOrdersDropdownValue;
exports.getOngoingOrdersDropdownValue = getOngoingOrdersDropdownValue;

/***/ }),

/***/ 1532:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentTime = exports.getTimeOffset = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _time = __webpack_require__(1533);

var initialState = {
  localTime: new Date().getTime(),
  offset: 0
};

var currentTime = function currentTime() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _time.SET_CURRENT_TIME:
      return _extends({}, state, {
        localTime: action.time
      });
    case _time.SET_SERVER_TIME_OFFSET:
      return _extends({}, state, {
        offset: action.offset
      });
    default:
      return state;
  }
};

var getTimeOffset = function getTimeOffset(state) {
  return state.time.offset;
};
var getCurrentTime = function getCurrentTime(state) {
  return new Date().getTime() + getTimeOffset(state);
};

exports.default = currentTime;
exports.getTimeOffset = getTimeOffset;
exports.getCurrentTime = getCurrentTime;

/***/ }),

/***/ 1533:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_CURRENT_TIME = exports.SET_CURRENT_TIME = 'SET_CURRENT_TIME';
var SET_SERVER_TIME_OFFSET = exports.SET_SERVER_TIME_OFFSET = 'SET_SERVER_TIME_OFFSET';

var setCurrentTime = function setCurrentTime(time) {
  return {
    type: SET_CURRENT_TIME,
    time: time
  };
};

var startTicker = exports.startTicker = function startTicker(dispatch) {
  var now = new Date().getTime();
  dispatch(setCurrentTime(now));
  // correct for skew
  var timeUntilNextSec = 1000 - now % 1000;
  setTimeout(function () {
    dispatch(startTicker);
  }, timeUntilNextSec);
};

var setServerTimeOffset = exports.setServerTimeOffset = function setServerTimeOffset(offset) {
  return {
    type: SET_SERVER_TIME_OFFSET,
    offset: offset
  };
};

/***/ }),

/***/ 1534:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(47);

var _reactRouter = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var requireAuthentication = function requireAuthentication(WrappedComponent) {
  var AuthenticatedComponent = function (_Component) {
    _inherits(AuthenticatedComponent, _Component);

    function AuthenticatedComponent() {
      _classCallCheck(this, AuthenticatedComponent);

      return _possibleConstructorReturn(this, (AuthenticatedComponent.__proto__ || Object.getPrototypeOf(AuthenticatedComponent)).apply(this, arguments));
    }

    _createClass(AuthenticatedComponent, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.checkAuth(this.props);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        this.checkAuth(nextProps);
      }
    }, {
      key: 'checkAuth',
      value: function checkAuth(props) {
        // NOTE: isFirebaseAuthenticated is undefined (e.g. undetermined) during app initialization
        if (props.shouldRedirect) {
          var pathname = props.location.pathname;
          // add next query parameter, unless it's the default target after logging in (which is '/')

          var redirectAfterLogin = pathname === '/' ? undefined : pathname;
          // the following code is wrapped in a setTimeout so that when logging out there is no
          // flash of a logout page when logging out.
          // @see src/actions/index.js:logoutWithoutFirebase()
          // When logoutWithoutFirebase is called the a hard reload/redirect happens, after a sign out
          // from firebase. The Firebase authentication stream is very fast however, so this forces a
          // (soft) redirect as well causing a flash of the login page to occur before the hard
          // reload...
          setTimeout(function () {
            props.router.replace({
              pathname: '/login',
              state: { next: redirectAfterLogin }
            });
          }, 100);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        if (this.props.shouldRender) {
          return _react2.default.createElement(WrappedComponent, this.props);
        }
        return null;
      }
    }]);

    return AuthenticatedComponent;
  }(_react.Component);

  // NOTE: state.firebase.authenticated can be 'undefined' which means the application
  // is still loading and the authentication state has not yet been determined.


  var mapStateToProps = function mapStateToProps(state) {
    return {
      // only render when we are guaranteed to be authenticated in both the API and Firebase
      shouldRender: state.auth.success,
      shouldRedirect: !state.auth.success
    };
  };

  return (0, _reactRedux.connect)(mapStateToProps)((0, _reactRouter.withRouter)(AuthenticatedComponent));
};

exports.default = requireAuthentication;

/***/ }),

/***/ 1535:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectors = exports.startListeningToFeatures = exports.initialState = exports.UPDATE_FEATURES_SUCCESS = exports.FETCH_FEATURES_SUCCESS = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.featuresFetchSuccess = featuresFetchSuccess;
exports.featuresUpdateSuccess = featuresUpdateSuccess;

var _splitio = __webpack_require__(3483);

var _splitio2 = _interopRequireDefault(_splitio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Types
var FETCH_FEATURES_SUCCESS = exports.FETCH_FEATURES_SUCCESS = 'chama/features/FETCH_FEATURES_SUCCESS';
var UPDATE_FEATURES_SUCCESS = exports.UPDATE_FEATURES_SUCCESS = 'chama/features/UPDATE_FEATURES_SUCCESS';

var initialState = exports.initialState = {
  featuresFetched: false,
  features: {}
};

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case FETCH_FEATURES_SUCCESS:
      return _extends({}, state, {
        featuresFetched: true,
        features: action.payload
      });
    case UPDATE_FEATURES_SUCCESS:
      return _extends({}, state, {
        features: action.payload
      });
    default:
      return state;
  }
}

// Action creators
function featuresFetchSuccess(features) {
  return { type: FETCH_FEATURES_SUCCESS, payload: features };
}
function featuresUpdateSuccess(features) {
  return { type: UPDATE_FEATURES_SUCCESS, payload: features };
}

var trackedTreatments = ['User_RestrictionAreas_Import_Frontend'];

// Side Effects
var startListeningToFeatures = exports.startListeningToFeatures = function startListeningToFeatures() {
  return function (dispatch, getState) {
    var _getState = getState(),
        uid = _getState.auth.uid;

    var client = _splitio2.default.client(uid, 'user');

    client.on(client.Event.SDK_READY, function () {
      var treatments = client.getTreatments(trackedTreatments);
      dispatch(featuresFetchSuccess(treatments));
    });
    client.on(client.Event.SDK_UPDATE, function () {
      var treatments = client.getTreatments(trackedTreatments);
      dispatch(featuresUpdateSuccess(treatments));
    });
  };
};

// Selectors
var selectors = exports.selectors = {
  isUnderToggle: function isUnderToggle(_ref, rules) {
    var features = _ref.features.features;

    return Object.entries(rules).every(isValueWithinRule, { features: features });
  },


  isRestrictionAreasImportEnabled: function isRestrictionAreasImportEnabled(_ref2) {
    var features = _ref2.features.features;
    return features.User_RestrictionAreas_Import_Frontend === 'on';
  }
};

//  if the feature is not on the rules, we treat it as valid
function isValueWithinRule(_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      possibilities = _ref4[1];

  var value = this.features[key];

  return value ? possibilities.includes(value) : true;
}

/***/ }),

/***/ 1536:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ENABLE_DEBUGGING = exports.ENABLE_DEBUGGING = 'ENABLE_DEBUGGING';
var DISABLE_DEBUGGING = exports.DISABLE_DEBUGGING = 'DISABLE_DEBUGGING';
var TOGGLE_FIREBASE_AUTH = exports.TOGGLE_FIREBASE_AUTH = 'TOGGLE_FIREBASE_AUTH';
var TOGGLE_FIREBASE_DB = exports.TOGGLE_FIREBASE_DB = 'TOGGLE_FIREBASE_DB';
var TOGGLE_API_JWT = exports.TOGGLE_API_JWT = 'TOGGLE_API_JWT';
var SET_LOCALE = exports.SET_LOCALE = 'SET_LOCALE';

var enableDebugging = exports.enableDebugging = function enableDebugging() {
  return {
    type: ENABLE_DEBUGGING
  };
};

var disableDebugging = exports.disableDebugging = function disableDebugging() {
  return {
    type: DISABLE_DEBUGGING
  };
};

var toggleFirebaseAuth = exports.toggleFirebaseAuth = function toggleFirebaseAuth() {
  return {
    type: TOGGLE_FIREBASE_AUTH
  };
};

var toggleFirebaseDb = exports.toggleFirebaseDb = function toggleFirebaseDb() {
  return {
    type: TOGGLE_FIREBASE_DB
  };
};

var toggleApiJwt = exports.toggleApiJwt = function toggleApiJwt() {
  return {
    type: TOGGLE_API_JWT
  };
};

var setLocale = exports.setLocale = function setLocale(locale) {
  return {
    type: SET_LOCALE,
    locale: locale
  };
};

/***/ }),

/***/ 1537:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var API_RETRY_SCHEDULED = exports.API_RETRY_SCHEDULED = 'API_RETRY_SCHEDULED';
var API_RETRY_SUCCEEDED = exports.API_RETRY_SUCCEEDED = 'API_RETRY_SUCCEEDED';

var apiRetryScheduled = exports.apiRetryScheduled = function apiRetryScheduled(ms) {
  return {
    type: API_RETRY_SCHEDULED,
    ms: ms
  };
};

var apiRetrySucceeded = exports.apiRetrySucceeded = function apiRetrySucceeded() {
  return {
    type: API_RETRY_SUCCEEDED
  };
};

/***/ }),

/***/ 1538:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FIREBASE_CONNECTED = exports.FIREBASE_CONNECTED = 'FIREBASE_CONNECTED';
var FIREBASE_DISCONNECTED = exports.FIREBASE_DISCONNECTED = 'FIREBASE_DISCONNECTED';
var FIREBASE_AUTHENTICATED = exports.FIREBASE_AUTHENTICATED = 'FIREBASE_AUTHENTICATED';
var FIREBASE_UNAUTHENTICATED = exports.FIREBASE_UNAUTHENTICATED = 'FIREBASE_UNAUTHENTICATED';

var firebaseConnected = exports.firebaseConnected = function firebaseConnected() {
  return {
    type: FIREBASE_CONNECTED
  };
};

var firebaseDisconnected = exports.firebaseDisconnected = function firebaseDisconnected() {
  return {
    type: FIREBASE_DISCONNECTED
  };
};

var firebaseAuthenticated = exports.firebaseAuthenticated = function firebaseAuthenticated(uid) {
  return {
    type: FIREBASE_AUTHENTICATED,
    uid: uid
  };
};

var firebaseUnAuthenticated = exports.firebaseUnAuthenticated = function firebaseUnAuthenticated() {
  return {
    type: FIREBASE_UNAUTHENTICATED
  };
};

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var firebaseApiKey = "__START_ENV_VAR__CHAMA_APP_FIREBASE_API_KEY__END_ENV_VAR__" || 'AIzaSyBWDZISIfHsZ-fNqfKV3szEThT_a3OmxJQ';
var firebaseAuthDomain = "__START_ENV_VAR__CHAMA_APP_FIREBASE_AUTH_DOMAIN__END_ENV_VAR__" || 'dl-master-dealertool.firebaseapp.com';
var firebaseDatabaseUrl = "__START_ENV_VAR__CHAMA_APP_FIREBASE_DATABASE_URL__END_ENV_VAR__" || 'https://dl-master-dealertool.firebaseio.com';
var sentryConfigUrl = "__START_ENV_VAR__CHAMA_APP_SENTRY_CONFIG_URL__END_ENV_VAR__" || 'https://a5540373b704455aaf0a7f3e40230477@sentry.io/1217650';
var apiHost = "__START_ENV_VAR__CHAMA_APP_API_HOST__END_ENV_VAR__" || 'dl-backoffice.chamapi.com/api';
var version = "__START_ENV_VAR__CHAMA_APP_VERSION__END_ENV_VAR__" || undefined;
var segmentApiKey = "__START_ENV_VAR__CHAMA_APP_SEGMENT_API_KEY__END_ENV_VAR__" || 'EocsAUcgiq96Eqy8YJENXdGgYwmQ30sW';
var splitioApiKey = "__START_ENV_VAR__CHAMA_APP_SPLIT_IO_API_KEY__END_ENV_VAR__";
var newMdtHost = "__START_ENV_VAR__CHAMA_APP_NEW_MDT_HOST__END_ENV_VAR__" || 'https://dl-sdt.web.app';

var config = {
  version: version,
  api: {
    dt: {
      host: apiHost,
      timeout: 60 * 1000 * 5,
      fetchTicketsDelay: 2000
    }
  },
  newMdtHost: newMdtHost,
  sentry: {
    configUrl: sentryConfigUrl
  },
  splitio: {
    apiKey: splitioApiKey
  },
  appInsights: {
    instrumentationKey: '24d829ba-5039-45c7-9dbc-09e1223a6534'
  },
  firebase: {
    apiKey: firebaseApiKey,
    authDomain: firebaseAuthDomain,
    databaseURL: firebaseDatabaseUrl
  },
  segment: {
    apiKey: segmentApiKey
  },
  termsAndConditions: {
    actedVersion: '2017-09-04',
    versionLimitDate: '2017-09-25',
    segmentedLimitDate: '2017-09-18'
  }
};

// This needs to be ES5 syntax because the 'bump version' bin file
// uses this module to know when to bump major versions.
module.exports = config;

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startFetchingDrivers = exports.cancelDelivery = exports.dismissOrder = exports.cancelOrder = exports.deliverOrder = exports.declineOrder = exports.startDelivery = exports.setCurrentOrder = exports.unAssignTicketToCurrentUser = exports.assignTicketToCurrentUser = exports.startFetchingTickets = exports.fetchMoreFinalizedTickets = exports.fetchOrderDetails = exports.fetchTicketsByQueue = exports.switchOrderQueueView = exports.UPDATE_ORDER_QUEUE = exports.PROCESSING_ORDER_ERROR = exports.START_PROCESSING_ORDER = exports.ORDER_ASSIGNMENT_DONE = exports.ORDER_ASSIGNMENT_LOADING = exports.SET_CURRENT_ORDER_ID = exports.ADD_OR_UPDATE_TICKETS = undefined;

var _executeTicketCommand = __webpack_require__(1225);

var _executeTicketCommand2 = _interopRequireDefault(_executeTicketCommand);

var _sentry = __webpack_require__(460);

var _sentry2 = _interopRequireDefault(_sentry);

var _config = __webpack_require__(167);

var _config2 = _interopRequireDefault(_config);

var _appInsights = __webpack_require__(461);

var _appInsights2 = _interopRequireDefault(_appInsights);

var _lodash = __webpack_require__(140);

var _lodash2 = _interopRequireDefault(_lodash);

var _apiDrivers = __webpack_require__(1526);

var _analyticsHandler = __webpack_require__(1525);

var _analyticsHandler2 = _interopRequireDefault(_analyticsHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var ADD_OR_UPDATE_TICKETS = exports.ADD_OR_UPDATE_TICKETS = 'ADD_OR_UPDATE_TICKETS';
var SET_CURRENT_ORDER_ID = exports.SET_CURRENT_ORDER_ID = 'SET_CURRENT_ORDER_ID';
var ORDER_ASSIGNMENT_LOADING = exports.ORDER_ASSIGNMENT_LOADING = 'ORDER_ASSIGNMENT_LOADING';
var ORDER_ASSIGNMENT_DONE = exports.ORDER_ASSIGNMENT_DONE = 'ORDER_ASSIGNMENT_DONE';
var START_PROCESSING_ORDER = exports.START_PROCESSING_ORDER = 'START_PROCESSING_ORDER';
var PROCESSING_ORDER_ERROR = exports.PROCESSING_ORDER_ERROR = 'PROCESSING_ORDER_ERROR';
var UPDATE_ORDER_QUEUE = exports.UPDATE_ORDER_QUEUE = 'UPDATE_ORDER_QUEUE';

var switchOrderQueueView = exports.switchOrderQueueView = function switchOrderQueueView(queue) {
  return function (dispatch) {
    clearTimeout(ticketsTimeout);
    dispatch(updateOrderQueue(queue));
    dispatch(fetchTicketsByQueue());
  };
};

var updateOrderQueue = function updateOrderQueue(queue) {
  return {
    type: UPDATE_ORDER_QUEUE,
    payload: { queue: queue }
  };
};

var ticketsTimeout = null;
var fetchTicketsByQueue = exports.fetchTicketsByQueue = function fetchTicketsByQueue() {
  return function (dispatch, getState, _ref) {
    var api = _ref.api;
    var fetchTicketsDelay = _config2.default.api.dt.fetchTicketsDelay;


    var queue = getState().orders.selectedOrderQueue;

    return api.fetchTicketsByQueue(queue).then(function (tickets) {
      dispatch(addOrUpdateTickets(tickets));
      ticketsTimeout = setTimeout(function () {
        return dispatch(fetchTicketsByQueue());
      }, fetchTicketsDelay);
    });
  };
};

var fetchOrderDetails = exports.fetchOrderDetails = function fetchOrderDetails(dealerId, orderId) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState, _ref3) {
      var api = _ref3.api;
      var details;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return api.fetchOrderDetails(dealerId, orderId);

            case 2:
              details = _context.sent;
              return _context.abrupt('return', details);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var addOrUpdateTickets = function addOrUpdateTickets(tickets) {
  return {
    type: ADD_OR_UPDATE_TICKETS,
    tickets: tickets
  };
};

var startProcessingOrder = function startProcessingOrder(orderId) {
  return {
    type: START_PROCESSING_ORDER,
    orderId: orderId
  };
};

var processingOrderError = function processingOrderError(orderId) {
  return {
    type: PROCESSING_ORDER_ERROR,
    orderId: orderId
  };
};

var startExecutingAssignment = function startExecutingAssignment() {
  return {
    type: ORDER_ASSIGNMENT_LOADING
  };
};

var doneExecutingAssignment = function doneExecutingAssignment() {
  return {
    type: ORDER_ASSIGNMENT_DONE
  };
};

var compareTimeNewestFirst = function compareTimeNewestFirst(a, b) {
  return a > b ? -1 : 1;
};

var fetchMoreFinalizedTickets = exports.fetchMoreFinalizedTickets = function fetchMoreFinalizedTickets() {
  return function (dispatch, getState, _ref4) {
    var api = _ref4.api;

    var ticketCreationTimes = (0, _lodash2.default)(getState().orders.dict).map(function (t) {
      return t.creationTime;
    }).sort(compareTimeNewestFirst);
    var oldestCreationTime = ticketCreationTimes[ticketCreationTimes.length - 1];

    return api.fetchTicketsBefore(oldestCreationTime).then(function (tickets) {
      dispatch(addOrUpdateTickets(tickets));
    });
  };
};

var fetchTickets = function fetchTickets(since) {
  return function (dispatch, getState, _ref5) {
    var api = _ref5.api;
    var fetchTicketsDelay = _config2.default.api.dt.fetchTicketsDelay;


    return api.fetchTicketsSince(since).then(function (tickets) {
      var nextSince = since;

      try {
        dispatch(addOrUpdateTickets(tickets));

        if (tickets.length) {
          var _getState = getState(),
              userId = _getState.user.loggedUser.uid;

          tickets.forEach(function (ticket) {
            var _ticket$data$order = ticket.data.order,
                orderId = _ticket$data$order.id,
                orderStatus = _ticket$data$order.status,
                ticketId = ticket.id;


            var data = {
              orderId: orderId,
              ticketId: ticketId,
              orderStatus: orderStatus,
              userId: userId
            };
            _appInsights2.default.trackEvent('mdt-order-update-received', data);
          });
          // set next since parameter to the newest known modification time,
          // minus a bit of slack (1 sec)
          // as sometimes the backend skips tickets
          // (most likely due to asynchronously delivered out-of-order
          // ticket events in the event bus). we want to be really sure to 'drain' each time segment
          // of tickets as we don't want to skip any.
          var newestModificationTime = tickets.map(function (t) {
            return t.modificationTime;
          }).sort(compareTimeNewestFirst)[0];
          var d = new Date(newestModificationTime);

          d.setSeconds(d.getSeconds() - 10);

          var newestModificationTimeMinusOneSec = d.toISOString();

          if (since === newestModificationTimeMinusOneSec) {
            nextSince = newestModificationTime;
          } else {
            nextSince = newestModificationTimeMinusOneSec;
          }
        }
      } catch (e) {
        _sentry2.default.captureException(e, { extra: { tickets: tickets } });
      } finally {
        setTimeout(function () {
          return dispatch(fetchTickets(nextSince));
        }, fetchTicketsDelay);
      }
    });
  };
};

var startFetchingTickets = exports.startFetchingTickets = function startFetchingTickets() {
  return function (dispatch) {
    dispatch(fetchTicketsByQueue());
  };
};

var getOrderWithTicketId = function getOrderWithTicketId(getState, ticketId) {
  var orderList = (0, _lodash2.default)(getState().orders.dict);
  return orderList.find(function (order) {
    return order.currentTicket.id === ticketId;
  });
};
var getETag = function getETag(getState, ticketId) {
  return getOrderWithTicketId(getState, ticketId).eTag;
};

var getTrackingData = function getTrackingData(getState, order, ticketId) {
  var _getState2 = getState(),
      _getState2$user = _getState2.user,
      username = _getState2$user.username,
      account = _getState2$user.account;

  var userId = username + '@' + account;
  var orderId = order.id,
      orderStatus = order.status;

  return { orderId: orderId, ticketId: ticketId, orderStatus: orderStatus, userId: userId };
};

var trackOrderChangeData = function trackOrderChangeData(eventName, getState, ticketId) {
  return function () {
    var _getState3 = getState(),
        _getState3$user = _getState3.user,
        username = _getState3$user.username,
        account = _getState3$user.account,
        dealerList = _getState3.dealer.all;

    var order = getOrderWithTicketId(getState, ticketId);
    var dealerId = order.dealerId,
        orderId = order.id,
        orderStatus = order.status;

    var userId = username + '@' + account;
    var isDealerActive = dealerList[dealerId].isActive;

    (0, _analyticsHandler2.default)(eventName, {
      location: 'OrderHandling',
      type: 'button',
      userId: userId,
      dealerId: dealerId,
      orderId: orderId,
      orderStatus: orderStatus,
      isDealerActive: isDealerActive,
      ticketId: ticketId
    });
  };
};

var assignTicketToCurrentUser = exports.assignTicketToCurrentUser = function assignTicketToCurrentUser(ticketId) {
  return function (dispatch, getState, _ref6) {
    var api = _ref6.api;

    var order = getOrderWithTicketId(getState, ticketId);
    var orderId = order.orderId;

    var trackingData = getTrackingData(getState, order, ticketId);

    dispatch(startExecutingAssignment());
    dispatch(startProcessingOrder(orderId));

    return (0, _executeTicketCommand2.default)(ticketId, function () {
      var _getOrderWithTicketId = getOrderWithTicketId(getState, ticketId),
          eTag = _getOrderWithTicketId.currentTicket.eTag;

      return api.assignTicketToCurrentUser(ticketId, eTag, trackingData).then(function () {
        return dispatch(doneExecutingAssignment());
      }).catch(function (e) {
        dispatch(doneExecutingAssignment());
        dispatch(processingOrderError(orderId));

        throw new Error(e);
      });
    });
  };
};

var unAssignTicketToCurrentUser = exports.unAssignTicketToCurrentUser = function unAssignTicketToCurrentUser(ticketId) {
  return function (dispatch, getState, _ref7) {
    var api = _ref7.api;

    var order = getOrderWithTicketId(getState, ticketId);
    var orderId = order.orderId;

    var trackingData = getTrackingData(getState, order, ticketId);

    dispatch(startExecutingAssignment());
    dispatch(startProcessingOrder(orderId));

    return (0, _executeTicketCommand2.default)(ticketId, function () {
      var _getOrderWithTicketId2 = getOrderWithTicketId(getState, ticketId),
          eTag = _getOrderWithTicketId2.currentTicket.eTag;

      return api.unAssignTicketToCurrentUser(ticketId, eTag, trackingData).then(function () {
        return dispatch(doneExecutingAssignment());
      }).catch(function (e) {
        dispatch(doneExecutingAssignment());
        dispatch(processingOrderError(orderId));

        throw new Error(e);
      });
    });
  };
};

var setCurrentOrder = exports.setCurrentOrder = function setCurrentOrder(id) {
  return function (dispatch) {
    dispatch({
      type: SET_CURRENT_ORDER_ID,
      currentOrderId: id
    });
  };
};

var startDelivery = exports.startDelivery = function startDelivery(ticketId, etaMinutes, etaWindow, driverId) {
  return function (dispatch, getState, _ref8) {
    var api = _ref8.api;

    var order = getOrderWithTicketId(getState, ticketId);
    var orderId = order.orderId;

    var trackingData = getTrackingData(getState, order, ticketId);

    dispatch(startProcessingOrder(orderId));

    return (0, _executeTicketCommand2.default)(ticketId, function () {
      return api.startDelivery(ticketId, getETag(getState, ticketId), etaMinutes, etaWindow, driverId, trackingData).then(trackOrderChangeData('Order Start Delivery', getState, ticketId)).catch(function (e) {
        dispatch(processingOrderError(orderId));
        throw new Error(e);
      });
    });
  };
};

var declineOrder = exports.declineOrder = function declineOrder(ticketId, reason, message) {
  return function (dispatch, getState, _ref9) {
    var api = _ref9.api;

    var order = getOrderWithTicketId(getState, ticketId);
    var orderId = order.orderId;

    var trackingData = getTrackingData(getState, order, ticketId);

    dispatch(startProcessingOrder(orderId));

    return (0, _executeTicketCommand2.default)(ticketId, function () {
      return api.declineOrder(ticketId, getETag(getState, ticketId), { reason: reason, message: message }, trackingData).then(trackOrderChangeData('Order Declined', getState, ticketId)).catch(function (e) {
        dispatch(processingOrderError(orderId));
        throw new Error(e);
      });
    });
  };
};

var deliverOrder = exports.deliverOrder = function deliverOrder(ticketId) {
  return function (dispatch, getState, _ref10) {
    var api = _ref10.api;

    var order = getOrderWithTicketId(getState, ticketId);
    var orderId = order.orderId;

    var trackingData = getTrackingData(getState, order, ticketId);

    dispatch(startProcessingOrder(orderId));

    return (0, _executeTicketCommand2.default)(ticketId, function () {
      return api.deliverOrder(ticketId, getETag(getState, ticketId), trackingData).then(trackOrderChangeData('Order Deliver', getState, ticketId)).catch(function (e) {
        dispatch(processingOrderError(orderId));
        throw new Error(e);
      });
    });
  };
};

var cancelOrder = exports.cancelOrder = function cancelOrder(ticketId, reason, message) {
  return function (dispatch, getState, _ref11) {
    var api = _ref11.api;

    var order = getOrderWithTicketId(getState, ticketId);
    var orderId = order.orderId;

    var trackingData = getTrackingData(getState, order, ticketId);

    dispatch(startProcessingOrder(orderId));

    return (0, _executeTicketCommand2.default)(ticketId, function () {
      return api.cancelOrder(ticketId, getETag(getState, ticketId), { reason: reason, message: message }, trackingData).then(trackOrderChangeData('Order Canceled', getState, ticketId)).catch(function (e) {
        dispatch(processingOrderError(orderId));
        throw new Error(e);
      });
    });
  };
};

var dismissOrder = exports.dismissOrder = function dismissOrder(ticketId, eTag) {
  return function (dispatch, getState, _ref12) {
    var api = _ref12.api;

    var _getOrderWithTicketId3 = getOrderWithTicketId(getState, ticketId),
        id = _getOrderWithTicketId3.id;

    dispatch(startProcessingOrder(id));

    return (0, _executeTicketCommand2.default)(ticketId, function () {
      return api.dismissOrder(ticketId, eTag).then(trackOrderChangeData('Order Dismissed', getState, ticketId)).catch(function (e) {
        dispatch(processingOrderError(id));
        throw new Error(e);
      });
    });
  };
};

var cancelDelivery = exports.cancelDelivery = function cancelDelivery(ticketId, eTag) {
  return function (dispatch, getState, _ref13) {
    var api = _ref13.api;

    var _getOrderWithTicketId4 = getOrderWithTicketId(getState, ticketId),
        id = _getOrderWithTicketId4.id;

    dispatch(startProcessingOrder(id));

    return (0, _executeTicketCommand2.default)(ticketId, function () {
      return api.cancelDelivery(ticketId, eTag).then(trackOrderChangeData('Order Cancel Delivery', getState, ticketId)).catch(function (e) {
        throw new Error(e);
      });
    });
  };
};

var startFetchingDrivers = exports.startFetchingDrivers = function startFetchingDrivers(ticketId) {
  return function (dispatch, getState) {
    var _getOrderWithTicketId5 = getOrderWithTicketId(getState, ticketId),
        dealerId = _getOrderWithTicketId5.dealerId,
        lat = _getOrderWithTicketId5.lat,
        lon = _getOrderWithTicketId5.lon;

    return dispatch((0, _apiDrivers.fetchDrivers)(dealerId, lat, lon));
  };
};

/***/ }),

/***/ 3390:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(460);

__webpack_require__(3391);

__webpack_require__(708);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(36);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(49);

var _reactHotLoader = __webpack_require__(3393);

var _MuiThemeProvider = __webpack_require__(977);

var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);

var _apiClient = __webpack_require__(3395);

var _apiClient2 = _interopRequireDefault(_apiClient);

var _ApiContext = __webpack_require__(3396);

var _RestrictionAreasGateway = __webpack_require__(3397);

var _RestrictionAreasGateway2 = _interopRequireDefault(_RestrictionAreasGateway);

var _ApplicationFacade = __webpack_require__(3400);

var _ApplicationFacade2 = _interopRequireDefault(_ApplicationFacade);

var _NotificationManager = __webpack_require__(3401);

var _NotificationManager2 = _interopRequireDefault(_NotificationManager);

var _NotificationManagerContext = __webpack_require__(3403);

var _Root = __webpack_require__(3404);

var _Root2 = _interopRequireDefault(_Root);

var _configureStore = __webpack_require__(3504);

var _configureStore2 = _interopRequireDefault(_configureStore);

var _FirebaseClient = __webpack_require__(3522);

var _FirebaseClient2 = _interopRequireDefault(_FirebaseClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var api = new _apiClient2.default(); /* eslint import/first: 0 */
/* eslint global-require: 0 */

// set up Sentry error reporting as soon as possible so that we
// catch as many errors as possible
// import 'react-hot-loader/patch';

var firebaseClient = new _FirebaseClient2.default();

var applicationFacade = new _ApplicationFacade2.default();

var store = (0, _configureStore2.default)({
  firebaseClient: firebaseClient,
  api: api,
  applicationFacade: applicationFacade
});

applicationFacade.gateways.restrictionAreaGateway = new _RestrictionAreasGateway2.default(api);
applicationFacade.notificationManager = new _NotificationManager2.default(store);
applicationFacade.history = _reactRouter.browserHistory;

var appRootNode = document.getElementById('root');

var renderApp = function renderApp(rootComponent) {
  var app = _react2.default.createElement(
    _reactHotLoader.AppContainer,
    { warnings: false },
    _react2.default.createElement(
      _ApiContext.ApiProvider,
      { api: api },
      _react2.default.createElement(
        _NotificationManagerContext.NotificationManagerProvider,
        { notificationManager: applicationFacade.notificationManager },
        _react2.default.createElement(
          _MuiThemeProvider2.default,
          null,
          rootComponent
        )
      )
    )
  );

  _reactDom2.default.render(app, appRootNode);
};

if (false) {
  module.hot.accept('./Root', function () {
    var NextRoot = require('./Root').default;

    renderApp(_react2.default.createElement(NextRoot, { store: store, history: _reactRouter.browserHistory }));
  });

  module.hot.accept('./reducer', function () {
    store.replaceReducer(require('./reducer').default);
  });
}

renderApp(_react2.default.createElement(_Root2.default, { store: store, history: _reactRouter.browserHistory }));

/***/ }),

/***/ 3391:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(3392);

__webpack_require__(463);

/***/ }),

/***/ 3392:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1305);
__webpack_require__(1357);
var path = __webpack_require__(130);

module.exports = path;


/***/ }),

/***/ 3393:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(3394);
} else if (process.env.NODE_ENV === 'test') {
  module.exports = require('./dist/react-hot-loader.production.min.js');
} else if (typeof window === 'undefined') {
  // this is just server environment
  module.exports = require('./dist/react-hot-loader.production.min.js');
} else if (!module.hot) {
  module.exports = require('./dist/react-hot-loader.production.min.js');
  module.exports.AppContainer.warnAboutHMRDisabled = true;
  module.exports.hot.shouldWrapWithAppContainer = true;
} else {
  var evalAllowed = false;
  var evalError = null;
  try {
    eval('evalAllowed = true');
  } catch (e) {
    // eval not allowed due to CSP
    evalError = e && e.message ? e.message : 'unknown reason';
  }

  // TODO: dont use eval to update methods. see #1273
  // RHL needs setPrototypeOf to operate Component inheritance, and eval to patch methods
  var jsFeaturesPresent = !!Object.setPrototypeOf;

  if (!jsFeaturesPresent || !evalAllowed) {
    // we are not in prod mode, but RHL could not be activated
    console.warn(
      'React-Hot-Loader is not supported in this environment:',
      [
        !jsFeaturesPresent && "some JS features are missing",
        !evalAllowed && "`eval` is not allowed(" + evalError + ")"
      ].join(','),
      '.'
    );
    module.exports = require('./dist/react-hot-loader.production.min.js');
  } else {
    module.exports = window.reactHotLoaderGlobal = require('./dist/react-hot-loader.development.js');
  }
}


/***/ }),

/***/ 3394:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(0));function AppContainer(e){return AppContainer.warnAboutHMRDisabled&&(AppContainer.warnAboutHMRDisabled=!0,console.error("React-Hot-Loader: misconfiguration detected, using production version in non-production environment."),console.error("React-Hot-Loader: Hot Module Replacement is not enabled.")),React.Children.only(e.children)}AppContainer.warnAboutHMRDisabled=!1;var hot=function e(){return e.shouldWrapWithAppContainer?function(e){return function(n){return React.createElement(AppContainer,null,React.createElement(e,n))}}:function(e){return e}};hot.shouldWrapWithAppContainer=!1;var areComponentsEqual=function(e,n){return e===n},setConfig=function(){},cold=function(e){return e},configureComponent=function(){};exports.AppContainer=AppContainer,exports.hot=hot,exports.areComponentsEqual=areComponentsEqual,exports.setConfig=setConfig,exports.cold=cold,exports.configureComponent=configureComponent;


/***/ }),

/***/ 3395:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(141);

var _lodash2 = _interopRequireDefault(_lodash);

var _retryPromise = __webpack_require__(1222);

var _retryPromise2 = _interopRequireDefault(_retryPromise);

var _timeoutPromise = __webpack_require__(1224);

var _timeoutPromise2 = _interopRequireDefault(_timeoutPromise);

var _appInsights = __webpack_require__(461);

var _appInsights2 = _interopRequireDefault(_appInsights);

var _config = __webpack_require__(167);

var _config2 = _interopRequireDefault(_config);

var _sentry = __webpack_require__(460);

var _sentry2 = _interopRequireDefault(_sentry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _config$api$dt = _config2.default.api.dt,
    host = _config$api$dt.host,
    timeout = _config$api$dt.timeout;

var urlWithPath = function urlWithPath(path) {
  return 'https://' + host + '/' + path;
};
var noResponseStatuses = [202, 204];

var addActionBreadCrumb = function addActionBreadCrumb(actionName) {
  _sentry2.default.captureBreadcrumb({
    message: 'Execute ' + actionName,
    category: 'action'
  });
};

var queryBuilder = function queryBuilder(params) {
  return (0, _lodash2.default)(params).map(function (key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
  }).join('&');
};

var fetchWithRetryAndTimeout = function fetchWithRetryAndTimeout(url, options, onRetryScheduled, onRetrySucceeded) {
  return (0, _retryPromise2.default)(function () {
    var fetchWithTimeout = (0, _timeoutPromise2.default)(fetch(url, options), timeout);
    return fetchWithTimeout.then(function (response) {
      // retry when there is a server error
      if (response.status >= 500 && response.status < 600) {
        // TODO: gold-plating: use specialised error to embed response so that the
        // retry promise always results in the response.
        throw new Error('Server error occurred, retrying');
      }
      return response;
    });
  }, onRetryScheduled, onRetrySucceeded);
};

var track = function track(trackingData, eventName) {
  _appInsights2.default.trackEvent(eventName, trackingData);
};

var ApiClient = function () {
  function ApiClient() {
    var _this = this;

    _classCallCheck(this, ApiClient);

    this.cacheBuster = new Date().getTime();

    this.fetchOrderPeriods = function (dealerId) {
      return _this.dealerApiFetch('dealersfinances/' + dealerId + '/periods')();
    };

    this.fetchMoreOrderPeriods = function (href) {
      // This is a temporary fix because we're setting different API hosts in deploy time
      var pureHostAddress = host.replace('/api', '').replace('/v25', '');

      return _this.dealerApiFetch('https://' + pureHostAddress + href, 'get', null, false, false)();
    };

    this.fetchMoreHistoryOrders = function (href) {
      // This is a temporary fix because we're setting different API hosts in deploy time
      var pureHostAddress = host.replace('/api', '').replace('/v25', '');

      return _this.dealerApiFetch('https://' + pureHostAddress + href, 'get', null, false, false)();
    };

    this.fetchOrderHistoryForPeriod = function (href) {
      // This is a temporary fix because we're setting different API hosts in deploy time
      var pureHostAddress = host.replace('/api', '').replace('/v25', '');

      return _this.dealerApiFetch('https://' + pureHostAddress + href, 'get', null, false, false)();
    };

    this.fetchHistoryOrderDetail = function (href) {
      // This is a temporary fix because we're setting different API hosts in deploy time
      var pureHostAddress = host.replace('/api', '').replace('/v25', '');

      return _this.dealerApiFetch('https://' + pureHostAddress + href, 'get', null, false, false)();
    };

    this.fetchSingleTicket = function (ticketId) {
      return _this.dealerApiFetch('tickets/' + ticketId)();
    };

    this.fetchOrderEventHistory = function (dealerId, orderId) {
      return _this.dealerApiFetch('dealersorders/' + dealerId + '/orders/' + orderId + '?loadHistory=true')();
    };

    this.assignTicketToCurrentUser = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ticketId, eTag, trackingData) {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                track(trackingData, 'mdt-order-assign-request-started');
                _context.next = 3;
                return _this.patchTicket(ticketId, {
                  eTag: eTag,
                  isAssignedToCurrentUser: true
                });

              case 3:
                result = _context.sent;

                track(trackingData, 'mdt-order-assign-request-ended');

                _sentry2.default.captureBreadcrumb({
                  message: 'Assign ticket',
                  category: 'action'
                });

                return _context.abrupt('return', result);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();

    this.unAssignTicketToCurrentUser = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ticketId, eTag, trackingData) {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                track(trackingData, 'mdt-order-unassign-request-started');
                _context2.next = 3;
                return _this.patchTicket(ticketId, {
                  eTag: eTag,
                  isAssignedToCurrentUser: false
                });

              case 3:
                result = _context2.sent;

                track(trackingData, 'mdt-order-unassign-request-ended');

                _sentry2.default.captureBreadcrumb({
                  message: 'Unassign ticket',
                  category: 'action'
                });

                return _context2.abrupt('return', result);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function (_x4, _x5, _x6) {
        return _ref2.apply(this, arguments);
      };
    }();

    this.startDelivery = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(ticketId, eTag, etaMinutes, etaWindowMinutes, driverId, trackingData) {
        var action, result;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                action = 'acceptOrder';

                addActionBreadCrumb(action);

                track(trackingData, 'mdt-order-accept-request-started');
                _context3.next = 5;
                return _this.patchTicket(ticketId, {
                  eTag: eTag,
                  execution: {
                    action: action,
                    parameters: {
                      etaMinutes: etaMinutes,
                      etaWindowMinutes: etaWindowMinutes,
                      driverId: driverId
                    }
                  }
                });

              case 5:
                result = _context3.sent;

                track(trackingData, 'mdt-order-accept-request-ended');

                return _context3.abrupt('return', result);

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this);
      }));

      return function (_x7, _x8, _x9, _x10, _x11, _x12) {
        return _ref3.apply(this, arguments);
      };
    }();

    this.declineOrder = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(ticketId, eTag, reason, trackingData) {
        var action, parameters, result;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                action = 'declineOrder';
                parameters = reason ? _extends({}, reason) : undefined;

                addActionBreadCrumb(action);

                track(trackingData, 'mdt-order-decline-request-started');
                _context4.next = 6;
                return _this.patchTicket(ticketId, {
                  eTag: eTag,
                  execution: { action: action, parameters: parameters }
                });

              case 6:
                result = _context4.sent;

                track(trackingData, 'mdt-order-decline-request-ended');

                return _context4.abrupt('return', result);

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this);
      }));

      return function (_x13, _x14, _x15, _x16) {
        return _ref4.apply(this, arguments);
      };
    }();

    this.deliverOrder = function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(ticketId, eTag, trackingData) {
        var action, result;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                action = 'deliverOrder';

                addActionBreadCrumb(action);

                track(trackingData, 'mdt-order-deliver-request-started');
                _context5.next = 5;
                return _this.patchTicket(ticketId, {
                  eTag: eTag,
                  execution: { action: action }
                });

              case 5:
                result = _context5.sent;

                track(trackingData, 'mdt-order-deliver-request-ended');

                return _context5.abrupt('return', result);

              case 8:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this);
      }));

      return function (_x17, _x18, _x19) {
        return _ref5.apply(this, arguments);
      };
    }();

    this.cancelOrder = function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(ticketId, eTag, reason, trackingData) {
        var action, parameters, result;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                action = 'cancelOrder';
                parameters = reason ? _extends({}, reason) : undefined;

                addActionBreadCrumb(action);

                track(trackingData, 'mdt-order-cancel-request-started');
                _context6.next = 6;
                return _this.patchTicket(ticketId, {
                  eTag: eTag,
                  execution: { action: action, parameters: parameters }
                });

              case 6:
                result = _context6.sent;

                track(trackingData, 'mdt-order-cancel-request-ended');

                return _context6.abrupt('return', result);

              case 9:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this);
      }));

      return function (_x20, _x21, _x22, _x23) {
        return _ref6.apply(this, arguments);
      };
    }();
  }

  _createClass(ApiClient, [{
    key: 'signIn',
    value: function signIn(account, username, password) {
      this.account = account;
      this.username = username;
      this.password = password;
    }
  }, {
    key: 'signInWithToken',
    value: function signInWithToken(getTokenCallback) {
      var _this2 = this;

      this.getTokenFunc = typeof getTokenCallback === 'function' ? getTokenCallback : _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt('return', getTokenCallback);

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this2);
      }));
    }
  }, {
    key: 'signOut',
    value: function signOut() {
      this.account = undefined;
      this.username = undefined;
      this.password = undefined;
    }
  }, {
    key: 'getRequestHeader',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(authWithApiKey) {
        var token, Authorization;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!authWithApiKey) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt('return', { Authorization: 'apikey ' + BACKEND_API_KEY });

              case 2:
                _context8.next = 4;
                return this.getTokenFunc();

              case 4:
                token = _context8.sent;
                Authorization = 'Bearer ' + token;
                return _context8.abrupt('return', {
                  Authorization: Authorization,
                  'Content-Type': 'application/json'
                });

              case 7:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getRequestHeader(_x24) {
        return _ref8.apply(this, arguments);
      }

      return getRequestHeader;
    }()
  }, {
    key: 'dealerApiFetch',
    value: function dealerApiFetch(path) {
      var requestMethod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
      var requestBody = arguments[2];

      var _this3 = this;

      var authWithApiKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var withPath = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

      var method = requestMethod.toUpperCase();
      var body = requestBody ? JSON.stringify(requestBody) : undefined;

      return function () {
        var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(responseHandler) {
          var headers;
          return regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.next = 2;
                  return _this3.getRequestHeader(authWithApiKey);

                case 2:
                  headers = _context9.sent;
                  return _context9.abrupt('return', fetchWithRetryAndTimeout(withPath ? urlWithPath(path) : path, { method: method, headers: headers, body: body }, _this3.onRetryScheduled, _this3.onRetrySucceeded).then(function (response) {
                    if (responseHandler) {
                      return responseHandler(response);
                    }

                    if (!response.ok) {
                      if (response.status >= 400 && response.status < 500) {
                        return Promise.reject(response);
                      }

                      var status = response.status,
                          statusText = response.statusText;

                      var errorMessage = '[' + method.toUpperCase() + ' ' + status + ' - ' + statusText + ']';

                      throw new Error(errorMessage);
                    }

                    if (noResponseStatuses.indexOf(response.status) !== -1) {
                      return Promise.resolve(response);
                    }

                    return response.json();
                  }));

                case 4:
                case 'end':
                  return _context9.stop();
              }
            }
          }, _callee9, _this3);
        }));

        return function (_x28) {
          return _ref9.apply(this, arguments);
        };
      }();
    }
  }, {
    key: 'fetchFile',
    value: function fetchFile(path) {
      var headers = this.getRequestHeader();

      return fetch(path, { method: 'get', headers: headers }).then(function (response) {
        if (!response.ok) {
          if (response.status >= 400 && response.status < 500) {
            return Promise.reject(response);
          }

          throw new Error('Failed to download file');
        }

        return response.blob();
      });
    }
  }, {
    key: 'patchTicket',
    value: function patchTicket(ticketId, body) {
      return this.dealerApiFetch('tickets/' + ticketId, 'PATCH', body)();
    }
  }, {
    key: 'fetchTicketsByQueue',
    value: function fetchTicketsByQueue(queue) {
      this.cacheBuster += 1;
      if (!queue) throw Error('api#fetchTicketsByCategory: missing "queue" property');

      return this.dealerApiFetch('tickets/get-by-queue/' + queue + '?_=' + this.cacheBuster)();
    }
  }, {
    key: 'fetchOrderDetails',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(dealerId, orderId) {
        var orderDetails;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (orderId) {
                  _context10.next = 2;
                  break;
                }

                throw Error('api#fetchOrderDetails: orderId is missing');

              case 2:
                if (dealerId) {
                  _context10.next = 4;
                  break;
                }

                throw Error('api#fetchOrderDetails: dealerId is missing');

              case 4:
                _context10.next = 6;
                return this.dealerApiFetch('orders/' + orderId + '?shopId=' + dealerId)();

              case 6:
                orderDetails = _context10.sent;
                return _context10.abrupt('return', orderDetails);

              case 8:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function fetchOrderDetails(_x29, _x30) {
        return _ref10.apply(this, arguments);
      }

      return fetchOrderDetails;
    }()

    // @since based on modificationTime

  }, {
    key: 'fetchTicketsSince',
    value: function fetchTicketsSince(since) {
      this.cacheBuster += 1;
      return this.dealerApiFetch('tickets/?_=' + this.cacheBuster + (since ? '&since=' + since : ''))(function (response) {
        if (response.status === 401) {
          // TODO: i18n
          throw new Error('Wrong account, username or password');
        }
      });
    }

    // @before based on creationTime

  }, {
    key: 'fetchTicketsBefore',
    value: function fetchTicketsBefore(before) {
      this.cacheBuster += 1;
      return this.dealerApiFetch('tickets/?_=' + this.cacheBuster + (before ? '&before=' + before : ''))(function (response) {
        if (response.status === 401) {
          // TODO: i18n
          throw new Error('Wrong account, username or password');
        }
      });
    }
  }, {
    key: 'dismissOrder',
    value: function dismissOrder(ticketId, eTag) {
      var action = 'dismissOrder';

      addActionBreadCrumb(action);

      return this.patchTicket(ticketId, {
        eTag: eTag,
        execution: { action: action }
      });
    }
  }, {
    key: 'cancelDelivery',
    value: function cancelDelivery(ticketId, eTag) {
      var action = 'cancelDelivery';

      addActionBreadCrumb(action);

      return this.patchTicket(ticketId, {
        eTag: eTag,
        execution: { action: action }
      });
    }
  }, {
    key: 'updateDealerData',
    value: function updateDealerData(dealerId, updatedData) {
      _sentry2.default.captureBreadcrumb({
        message: 'Update dealer data',
        category: 'action',
        data: updatedData
      });

      return this.dealerApiFetch('dealersadmin/' + dealerId, 'PATCH', updatedData)();
    }
  }, {
    key: 'updateSeveralDealersData',
    value: function updateSeveralDealersData(dealerList, updatedData) {
      var _this4 = this;

      var mapMeaningfulSentryInfo = function mapMeaningfulSentryInfo(dealer) {
        return {
          id: dealer.id,
          name: dealer.name,
          termsAndConditions: dealer.termsAndConditions
        };
      };
      var mapPromiseList = function mapPromiseList(dealer) {
        return _this4.updateDealerData(dealer.id, updatedData);
      };

      _sentry2.default.captureBreadcrumb({
        message: 'Update several dealers data',
        category: 'action',
        data: {
          updatedData: updatedData,
          dealerList: dealerList.map(mapMeaningfulSentryInfo)
        }
      });

      return Promise.all(dealerList.map(mapPromiseList));
    }
  }, {
    key: 'onRetryScheduled',
    value: function onRetryScheduled(callback) {
      this.onRetryScheduled = callback;
    }
  }, {
    key: 'onRetrySucceeded',
    value: function onRetrySucceeded(callback) {
      this.onRetrySucceeded = callback;
    }
  }, {
    key: 'getUserKind',
    value: function getUserKind() {
      return this.dealerApiFetch('dealersadmin/auth', 'post')();
    }
  }, {
    key: 'getNearbyDealers',
    value: function getNearbyDealers(lat, lon) {
      return this.dealerApiFetch('dealers?lat=' + lat + '&lon=' + lon, 'get')();
    }
  }, {
    key: 'downloadInvoice',
    value: function downloadInvoice(dealerId, periodTimestamp) {
      var path = urlWithPath('dealersfinances/' + dealerId + '/invoice?periodReference=' + periodTimestamp);

      return this.fetchFile(path);
    }
  }, {
    key: 'downloadPaymentSlip',
    value: function downloadPaymentSlip(dealerId, periodTimestamp) {
      var path = urlWithPath('dealersfinances/' + dealerId + '/boleto?periodReference=' + periodTimestamp);

      return this.fetchFile(path);
    }
  }, {
    key: 'getNotaFiscalLink',
    value: function getNotaFiscalLink(dealerId, periodTimestamp) {
      return this.dealerApiFetch('dealersfinances/' + dealerId + '/notafiscal?periodReference=' + periodTimestamp)();
    }
  }, {
    key: 'fetchDrivers',
    value: function fetchDrivers(dealerId, lat, lon) {
      _sentry2.default.captureBreadcrumb({
        message: 'Fetch drivers',
        category: 'action'
      });

      if (!lat) throw Error('Error: Lat is required');
      if (!lon) throw Error('Error: Lon is required');

      var queryString = '?' + queryBuilder({ lat: lat, lon: lon });

      return this.dealerApiFetch(urlWithPath('drivers/' + dealerId + '/relative-to-location' + queryString))(function (res) {
        if (res.status === 401 || res.status === 403) {
          throw new Error('Error: Incorrect dealerId.');
        }
      });
    }
  }, {
    key: 'enrichToken',
    value: function enrichToken() {
      return this.dealerApiFetch('authentication/sign-in', 'POST')();
    }
  }, {
    key: 'getPermissions',
    value: function getPermissions() {
      return this.dealerApiFetch('authentication/permissions-matrix', 'get')();
    }

    // Temp

  }, {
    key: 'testPermission',
    value: function testPermission() {
      return this.dealerApiFetch('authentication/requires-full-access-permission')();
    }
  }]);

  return ApiClient;
}();

exports.default = ApiClient;

/***/ }),

/***/ 3396:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withApiContext = exports.ApiProvider = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ApiContext = (0, _react.createContext)(null);

var ApiProvider = exports.ApiProvider = function ApiProvider(_ref) {
  var api = _ref.api,
      children = _ref.children;

  if (!api) {
    throw Error('API Client must be provided');
  }
  return _react2.default.createElement(
    ApiContext.Provider,
    { value: api },
    children
  );
};

ApiProvider.propTypes = {
  api: _propTypes2.default.object.isRequired,
  children: _propTypes2.default.node.isRequired
};

var withApiContext = exports.withApiContext = function withApiContext(mapApiToProps) {
  return function (InnerComponent) {
    return function (componentProps) {
      return _react2.default.createElement(
        ApiContext.Consumer,
        null,
        function (apiClient) {
          var apiProps = mapApiToProps(apiClient);
          return _react2.default.createElement(InnerComponent, _extends({}, apiProps, componentProps));
        }
      );
    };
  };
};

/***/ }),

/***/ 3397:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImportGoogleMyMapsErrors = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RestrictionArea = __webpack_require__(3398);

var _RestrictionArea2 = _interopRequireDefault(_RestrictionArea);

var _RestrictionAreaDaySpecification = __webpack_require__(3399);

var _RestrictionAreaDaySpecification2 = _interopRequireDefault(_RestrictionAreaDaySpecification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ImportGoogleMyMapsErrors = exports.ImportGoogleMyMapsErrors = Object.freeze({
  none: 'none',
  unknown: 'unknown',
  urlNotValid: 'urlNotValid',
  mapShapeNotValid: 'mapShapeNotValid',
  restrictionAreaNotFound: 'restrictionAreaNotFound',
  notAllowed: 'notAllowed'
});

var IMPORT_GOOGLE_MY_MAPS_API_ERROR_CODES_MAPPING = {
  unknown: ImportGoogleMyMapsErrors.unknown,
  urlNotValid: ImportGoogleMyMapsErrors.urlNotValid,
  mapShapeNotValid: ImportGoogleMyMapsErrors.mapShapeNotValid,
  restrictionAreaNotFound: ImportGoogleMyMapsErrors.restrictionAreaNotFound,
  notAllowed: ImportGoogleMyMapsErrors.notAllowed
};

var IMPORT_GOOGLE_MY_MAPS_ERROR = {
  hasError: true,
  error: 'unknown',
  errorCode: ImportGoogleMyMapsErrors.unknown,
  restrictionArea: null
};

var RestrictionAreasGateway = function () {
  function RestrictionAreasGateway(api) {
    _classCallCheck(this, RestrictionAreasGateway);

    this.apiRef = null;

    this.apiRef = api;
  }

  _createClass(RestrictionAreasGateway, [{
    key: 'importGoogleMyMapsLink',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
        var dealerId = _ref2.dealerId,
            restrictionAreaId = _ref2.restrictionAreaId,
            mapUrl = _ref2.mapUrl;
        var result, hasError, isErrorCodeMapped, errorCode;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (dealerId) {
                  _context.next = 2;
                  break;
                }

                throw new Error('api.importGoogleMyMapsLink should get a dealerId');

              case 2:
                if (restrictionAreaId) {
                  _context.next = 4;
                  break;
                }

                throw new Error('api.importGoogleMyMapsLink should get a restrictionAreaId');

              case 4:
                if (mapUrl) {
                  _context.next = 6;
                  break;
                }

                throw new Error('api.importGoogleMyMapsLink should get a mapUrl');

              case 6:
                _context.prev = 6;
                _context.next = 9;
                return this.apiRef.dealerApiFetch('dealers/' + dealerId + '/restrictionArea/' + restrictionAreaId + '/update-map-link', 'PATCH', { mapUrl: mapUrl, restrictionAreaId: restrictionAreaId })(function (response) {
                  return response.json();
                });

              case 9:
                result = _context.sent;
                hasError = result.hasError;
                isErrorCodeMapped = hasError || !!IMPORT_GOOGLE_MY_MAPS_API_ERROR_CODES_MAPPING[result.errorCode];


                if (!isErrorCodeMapped) {
                  //  eslint-ignore-next-line no-console
                  console.log('api.importGoogleMyMapsLink does not recognize "' + result.errorCode + '" as a known error');
                }

                errorCode = hasError ? IMPORT_GOOGLE_MY_MAPS_API_ERROR_CODES_MAPPING[result.errorCode] || ImportGoogleMyMapsErrors.unknown : ImportGoogleMyMapsErrors.none;
                return _context.abrupt('return', _extends({}, result, {
                  restrictionArea: result.restrictionArea ? convertToRestrictionArea.call({ dealerId: dealerId }, result.restrictionArea) : null,
                  errorCode: errorCode
                }));

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](6);
                return _context.abrupt('return', _extends({}, IMPORT_GOOGLE_MY_MAPS_ERROR));

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 17]]);
      }));

      function importGoogleMyMapsLink(_x) {
        return _ref.apply(this, arguments);
      }

      return importGoogleMyMapsLink;
    }()
  }, {
    key: 'getRestrictionAreas',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dealerId) {
        var responseBody, restrictionAreasData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (dealerId) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return', []);

              case 2:
                _context2.next = 4;
                return this.apiRef.dealerApiFetch('/dealers/' + dealerId + '/restrictionArea')();

              case 4:
                responseBody = _context2.sent;
                restrictionAreasData = responseBody.restrictionAreas;

                if (Array.isArray(restrictionAreasData)) {
                  _context2.next = 8;
                  break;
                }

                throw new Error('RestrictionAreas is not an array');

              case 8:
                return _context2.abrupt('return', restrictionAreasData.map(convertToRestrictionArea, { dealerId: dealerId }));

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getRestrictionAreas(_x2) {
        return _ref3.apply(this, arguments);
      }

      return getRestrictionAreas;
    }()
  }, {
    key: 'createRestictionArea',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dealerId) {
        var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var geoJson = _ref5.geoJson,
            displayName = _ref5.displayName,
            data = _objectWithoutProperties(_ref5, ['geoJson', 'displayName']);

        var body;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (dealerId) {
                  _context3.next = 2;
                  break;
                }

                throw new Error('RestrictionArea should have a dealerId');

              case 2:
                if (geoJson) {
                  _context3.next = 4;
                  break;
                }

                throw new Error('RestrictionArea should have a geoJson');

              case 4:
                if (displayName) {
                  _context3.next = 6;
                  break;
                }

                throw new Error('RestrictionArea should have a displayName');

              case 6:
                body = _extends({}, data, {
                  dealerId: dealerId,
                  displayName: displayName,
                  geoJson: normalizeGeoJson(geoJson)
                });
                _context3.next = 9;
                return this.apiRef.dealerApiFetch('/dealers/' + dealerId + '/restrictionarea', 'POST', body)();

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function createRestictionArea(_x3) {
        return _ref4.apply(this, arguments);
      }

      return createRestictionArea;
    }()
  }, {
    key: 'updateMap',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dealerId) {
        var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            id = _ref7.id,
            geoJson = _ref7.geoJson;

        var editURL, body;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (dealerId) {
                  _context4.next = 2;
                  break;
                }

                throw new Error('RestrictionArea should have a dealerId');

              case 2:
                if (id) {
                  _context4.next = 4;
                  break;
                }

                throw new Error('RestrictionArea should have an id');

              case 4:
                if (geoJson) {
                  _context4.next = 6;
                  break;
                }

                throw new Error('RestrictionArea should have a geoJson');

              case 6:
                editURL = '/dealers/' + dealerId + '/restrictionarea/' + id + '/updateMap';
                body = {
                  dealerId: dealerId,
                  restrictionAreaId: id,
                  geoJson: normalizeGeoJson(geoJson)
                };
                _context4.next = 10;
                return this.apiRef.dealerApiFetch(editURL, 'PATCH', body)();

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateMap(_x5) {
        return _ref6.apply(this, arguments);
      }

      return updateMap;
    }()
  }, {
    key: 'deleteRestictionArea',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dealerId, areaId) {
        var deleteURL;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (dealerId) {
                  _context5.next = 2;
                  break;
                }

                throw new Error('The dealerId should have been provided');

              case 2:
                if (areaId) {
                  _context5.next = 4;
                  break;
                }

                throw new Error('The id of the area should have been provided');

              case 4:
                deleteURL = '/dealers/' + dealerId + '/restrictionarea/' + areaId + '/delete';
                _context5.next = 7;
                return this.apiRef.dealerApiFetch(deleteURL, 'DELETE')();

              case 7:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function deleteRestictionArea(_x7, _x8) {
        return _ref8.apply(this, arguments);
      }

      return deleteRestictionArea;
    }()
  }]);

  return RestrictionAreasGateway;
}();

exports.default = RestrictionAreasGateway;


function normalizeGeoJson(original) {
  var features = original.features;


  var polygons = features.filter(isPolygon);

  return JSON.stringify(_extends({}, original, { features: polygons }));
}

function isPolygon(_ref9) {
  var type = _ref9.geometry.type;

  return type === 'Polygon';
}

function convertToRestrictionArea(restrictionAreaData) {
  var id = restrictionAreaData.id,
      name = restrictionAreaData.name,
      _restrictionAreaData$ = restrictionAreaData.displayName,
      displayName = _restrictionAreaData$ === undefined ? name : _restrictionAreaData$,
      _restrictionAreaData$2 = restrictionAreaData.dealerId,
      dealerId = _restrictionAreaData$2 === undefined ? this.dealerId : _restrictionAreaData$2,
      geoJson = restrictionAreaData.geoJson,
      mapUrl = restrictionAreaData.mapUrl;

  console.log('data', restrictionAreaData);
  if (typeof id !== 'string' || !id) {
    throw new Error('Incorrect RestrictionArea.id');
  }
  if (typeof displayName !== 'string' || !displayName) {
    throw new Error('Incorrect RestrictionArea.displayName');
  }
  if (typeof dealerId !== 'string' || !dealerId) {
    throw new Error('Incorrect RestrictionArea.dealerId');
  }
  if (geoJson === undefined) {
    throw new Error('Incorrect RestrictionArea.geoJson');
  }
  if (mapUrl && typeof mapUrl !== 'string') {
    throw new Error('Incorrect RestrictionArea.mapUrl');
  }
  console.log('parsing geo json 1');
  var parsedGeoJson = void 0;
  try {
    parsedGeoJson = JSON.parse(geoJson);
  } catch (e) {
    console.log('parsing geo json');
    throw new Error('Incorrect RestrictionArea.geoJson ' + e.message);
  }

  var model = new _RestrictionArea2.default({
    id: id,
    displayName: displayName,
    dealerId: dealerId,
    geoJson: parsedGeoJson,
    mapUrl: mapUrl
  });
  console.log('model', model);
  return model;
}

/***/ }),

/***/ 3398:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable react/static-property-placement */
var RestrictionArea = function RestrictionArea(restrictionAreaData) {
  _classCallCheck(this, RestrictionArea);

  this.id = null;
  this.displayName = null;
  this.dealerId = null;
  this.geoJson = null;
  this.mapUrl = null;

  if (typeof restrictionAreaData.id !== 'string') {
    throw new Error('RestrictionArea: incorrect id');
  }
  if (typeof restrictionAreaData.displayName !== 'string') {
    throw new Error('RestrictionArea: incorrect displayName');
  }
  if (typeof restrictionAreaData.dealerId !== 'string') {
    throw new Error('RestrictionArea: incorrect dealerId');
  }

  if (!restrictionAreaData.geoJson) {
    throw new Error('RestrictionArea: incorrect geoJson');
  }

  Object.assign(this, restrictionAreaData);
};

exports.default = RestrictionArea;

/***/ }),

/***/ 3399:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TYPE = {
  UNRESTRICTED: 'Unrestricted',
  TIME_RESTRICTED: 'TimeRestricted'
};

var DAY_OF_WEEK = {
  MONDAY: 'monday',
  TUESDAY: 'tuesday',
  WEDNESDAY: 'wednesday',
  THURSDAY: 'thursday',
  FRIDAY: 'friday',
  SATURDAY: 'saturday',
  SUNDAY: 'sunday'
};

var RestrictionAreaDaySpecification = function RestrictionAreaDaySpecification(data) {
  _classCallCheck(this, RestrictionAreaDaySpecification);

  this.dayOfTheWeek = null;
  this.type = null;
  this.from = null;
  this.to = null;

  if (!Object.values(DAY_OF_WEEK).includes(data.dayOfTheWeek)) {
    throw new Error('RestrictionAreaDaySpecification: incorrect dayOfTheWeek ' + data.dayOfTheWeek);
  }
  if (!Object.values(TYPE).includes(data.type)) {
    throw new Error('RestrictionAreaDaySpecification: incorrect type ' + data.type);
  }

  if (data.type === TYPE.TIME_RESTRICTED) {
    if (typeof data.from !== 'string') {
      throw new Error('RestrictionArea: incorrect from');
    }
    if (typeof data.to !== 'string') {
      throw new Error('RestrictionArea: incorrect to');
    }
  }

  Object.assign(this, data);
};

RestrictionAreaDaySpecification.TYPE = TYPE;
RestrictionAreaDaySpecification.DAY_OF_WEEK = DAY_OF_WEEK;
exports.default = RestrictionAreaDaySpecification;

/***/ }),

/***/ 3400:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApplicationFacade = function ApplicationFacade() {
  _classCallCheck(this, ApplicationFacade);

  this.gateways = {};
  this.notificationManager = null;
  this.history = null;
};

exports.default = ApplicationFacade;

/***/ }),

/***/ 3401:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toasts = __webpack_require__(3402);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NotificationManager = function () {
  function NotificationManager(store) {
    _classCallCheck(this, NotificationManager);

    this.store = store;
  }

  _createClass(NotificationManager, [{
    key: 'notify',
    value: function notify(message) {
      this.store.dispatch((0, _toasts.showToast)(message));
    }
  }, {
    key: 'success',
    value: function success(message) {
      this.store.dispatch((0, _toasts.showToast)(message));
    }
  }, {
    key: 'error',
    value: function error(message) {
      this.store.dispatch((0, _toasts.showToast)(message, { type: 'cancel' }));
    }
  }]);

  return NotificationManager;
}();

exports.default = NotificationManager;

/***/ }),

/***/ 3402:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showToast = showToast;

var _toasts = __webpack_require__(1522);

var _toastsSelectors = __webpack_require__(1523);

var DEFAULT_TIMEOUT = 3000;

// eslint-disable-next-line import/prefer-default-export
function showToast(message) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      timeout = _ref.timeout;

  return function (dispatch, getState) {
    var id = (0, _toastsSelectors.generateToastNotificationId)(getState());
    dispatch((0, _toasts.addToast)(id, message, type));
    setTimeout(function () {
      return dispatch((0, _toasts.removeToast)(id));
    }, timeout || DEFAULT_TIMEOUT);
  };
}

/***/ }),

/***/ 3403:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.NotificationManagerProvider = NotificationManagerProvider;
exports.withNotificationManager = withNotificationManager;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationManagerContext = (0, _react.createContext)(null);

function NotificationManagerProvider(_ref) {
  var notificationManager = _ref.notificationManager,
      children = _ref.children;

  return _react2.default.createElement(
    NotificationManagerContext.Provider,
    { value: notificationManager },
    children
  );
}

function withNotificationManager(component) {
  var Component = component;
  return function (props) {
    return _react2.default.createElement(
      NotificationManagerContext.Consumer,
      null,
      function (notificationManager) {
        return _react2.default.createElement(Component, _extends({}, props, { notificationManager: notificationManager }));
      }
    );
  };
}

NotificationManagerProvider.propTypes = {
  notificationManager: _propTypes2.default.object.isRequired,
  children: _propTypes2.default.node.isRequired
};

/***/ }),

/***/ 3404:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(47);

var _reactIntl = __webpack_require__(16);

var _reactRouter = __webpack_require__(49);

var _Orders = __webpack_require__(1524);

var _Orders2 = _interopRequireDefault(_Orders);

var _requireAuthentication = __webpack_require__(1534);

var _requireAuthentication2 = _interopRequireDefault(_requireAuthentication);

var _NotFoundPage = __webpack_require__(3481);

var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);

var _App = __webpack_require__(3482);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var context = __webpack_require__(3491);
var modulesRoutes = context.keys().map(function (module) {
  return context(module).default;
});

var propTypes = {
  store: _propTypes2.default.object.isRequired,
  history: _propTypes2.default.object.isRequired
};

var Root = function Root(_ref) {
  var store = _ref.store,
      history = _ref.history;

  var modules = modulesRoutes.filter(Boolean).map(addArrayKeyForReact);

  return _react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.createElement(
      _reactRouter.Router,
      { key: Math.random(), history: history },
      _react2.default.createElement(
        _reactRouter.Route,
        { path: '/', component: _App2.default },
        modules,
        _react2.default.createElement(_reactRouter.IndexRoute, {
          components: { content: (0, _requireAuthentication2.default)(_Orders2.default) },
          title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'orders', defaultMessage: 'Orders' })
        }),
        _react2.default.createElement(_reactRouter.Route, { path: '*', components: { content: _NotFoundPage2.default } })
      )
    )
  );
};

function addArrayKeyForReact(module) {
  var key = module.key,
      path = module.props.path;


  return _extends({}, module, {
    key: key || path
  });
}

Root.propTypes = propTypes;

exports.default = Root;

/***/ }),

/***/ 3405:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DAYS = Object.freeze(['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday', 'holiday']);

var DEFAULT_WORK_TIME = {
  open: '08:00:00',
  close: '20:00:00'
};

/**
 * Validate the time in the following format: HH:MM:SS, with mandatory leading 0
 */
var timeRegex = RegExp(/^([0-1]\d|2[0-3]):([0-5]\d):([0-5]\d)$/);

var OpeningTimes = function () {
  _createClass(OpeningTimes, [{
    key: 'areDaysValid',
    value: function areDaysValid() {
      return Object.values(this).some(isDayInvalid);
    }
  }]);

  function OpeningTimes() {
    var _this = this;

    var openingTimes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, OpeningTimes);

    this.monday = null;
    this.tuesday = null;
    this.wednesday = null;
    this.thursday = null;
    this.friday = null;
    this.saturday = null;
    this.sunday = null;
    this.holiday = null;

    DAYS.forEach(function (day) {
      if (openingTimes && openingTimes[day]) {
        _this[day] = _extends({}, openingTimes[day], { isOpen: true });
      } else {
        _this[day] = _extends({}, DEFAULT_WORK_TIME, { isOpen: false });
      }
    });

    Object.defineProperty(this, 'hasInvalidTimeError', {
      value: this.areDaysValid(),
      enumerable: false
    });
  }

  return OpeningTimes;
}();

exports.default = OpeningTimes;


function isDayInvalid(_ref) {
  var open = _ref.open,
      close = _ref.close;

  return !timeRegex.test(open) || !timeRegex.test(close);
}

/***/ }),

/***/ 3406:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTransitionGroup = __webpack_require__(126);

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

var _Spinner = __webpack_require__(125);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _PageContainer = __webpack_require__(3407);

var _PageContainer2 = _interopRequireDefault(_PageContainer);

var _NotificationBar = __webpack_require__(1056);

var _NotificationBar2 = _interopRequireDefault(_NotificationBar);

var _ConnectivitySnackBar = __webpack_require__(3418);

var _ConnectivitySnackBar2 = _interopRequireDefault(_ConnectivitySnackBar);

var _MdtStatus = __webpack_require__(3419);

var _MdtStatus2 = _interopRequireDefault(_MdtStatus);

var _OrderDetails = __webpack_require__(3420);

var _OrderDetails2 = _interopRequireDefault(_OrderDetails);

var _RightPanel = __webpack_require__(3445);

var _RightPanel2 = _interopRequireDefault(_RightPanel);

var _OrderPanel = __webpack_require__(3448);

var _OrderPanel2 = _interopRequireDefault(_OrderPanel);

var _OrdersTabs = __webpack_require__(3478);

var _OrdersTabs2 = _interopRequireDefault(_OrdersTabs);

__webpack_require__(3480);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var notificationBarStyle = {
  top: '10px'
};

var OrdersLayout = function (_Component) {
  _inherits(OrdersLayout, _Component);

  function OrdersLayout(props) {
    _classCallCheck(this, OrdersLayout);

    var _this = _possibleConstructorReturn(this, (OrdersLayout.__proto__ || Object.getPrototypeOf(OrdersLayout)).call(this, props));

    _this.onNotificationOpen = function () {
      _this.setState({ isNotificationClosed: false });
    };

    _this.onNotificationClose = function () {
      _this.setState({ isNotificationClosed: true });
    };

    _this.handleRef = function (refName) {
      return function (ref) {
        _this[refName] = ref;
      };
    };

    _this.renderPageLoading = function () {
      var ticketsFetched = _this.props.ticketsFetched;


      if (!ticketsFetched) {
        return _react2.default.createElement(
          'div',
          { className: 'OrdersLayout__page_loading_wrapper' },
          _react2.default.createElement(
            _Spinner2.default,
            null,
            'Carregando'
          )
        );
      }

      return null;
    };

    _this.renderRighPanelContent = function () {
      var order = _this.props.order;


      if (order) {
        return _react2.default.createElement(_OrderDetails2.default, null);
      }

      return null;
    };

    _this.renderContent = function () {
      // when showing ticket details hide ticketlist when the screen is too small
      var _this$props = _this.props,
          dealers = _this$props.dealers,
          order = _this$props.order,
          ordersFinalized = _this$props.ordersFinalized,
          fetchMoreFinalizedTickets = _this$props.fetchMoreFinalizedTickets,
          ticketsFetched = _this$props.ticketsFetched,
          offset = _this$props.offset,
          setCurrentOrder = _this$props.setCurrentOrder,
          userId = _this$props.userId,
          dismissOrder = _this$props.dismissOrder,
          cancelDelivery = _this$props.cancelDelivery;


      if (!ticketsFetched) {
        return null;
      }

      var contentClass = (0, _classnames2.default)('OrdersLayout', { 'has-order_selected': !!order });

      return _react2.default.createElement(
        'section',
        { className: contentClass },
        _react2.default.createElement(
          'div',
          { className: 'OrdersLayout__col' },
          _react2.default.createElement(_OrderPanel2.default, {
            dealers: dealers,
            activeOrder: order,
            ordersFinalized: ordersFinalized,
            fetchMoreFinalizedTickets: fetchMoreFinalizedTickets,
            dismissOrder: dismissOrder,
            cancelDelivery: cancelDelivery,
            offset: offset,
            setCurrentOrder: setCurrentOrder,
            userId: userId
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'OrdersLayout__col' },
          _react2.default.createElement(
            'div',
            { className: 'OrdersLayout__order_details_wrapper' },
            _react2.default.createElement(
              _RightPanel2.default,
              null,
              _this.renderRighPanelContent()
            )
          )
        )
      );
    };

    _this.wasModalDismissed = false;

    /* eslint-disable react/no-unused-state */
    /** TODO: Verify if notification is being used externally through refs */
    _this.state = {
      isNotificationClosed: true
    };
    return _this;
  }

  _createClass(OrdersLayout, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var currentNotification = this.props.notification;
      var newNotification = newProps.notification;

      if (currentNotification.id !== newNotification.id) {
        var message = newNotification.message,
            error = newNotification.error;


        this.notificationBar.notify(message, error);
        this.onNotificationOpen();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _PageContainer2.default,
        { title: _react2.default.createElement(_OrdersTabs2.default, null), subheader: _MdtStatus2.default },
        _react2.default.createElement(_ConnectivitySnackBar2.default, null),
        _react2.default.createElement(_NotificationBar2.default, {
          ref: this.handleRef('notificationBar'),
          style: notificationBarStyle,
          onClose: this.onNotificationClose
        }),
        this.renderContent(),
        _react2.default.createElement(
          _reactTransitionGroup.CSSTransitionGroup,
          {
            transitionName: 'CSSTG-fade',
            transitionEnterTimeout: 375,
            transitionLeaveTimeout: 300
          },
          this.renderPageLoading()
        )
      );
    }
  }]);

  return OrdersLayout;
}(_react.Component);

OrdersLayout.propTypes = {
  dealers: _propTypes2.default.object.isRequired,
  order: _propTypes2.default.object,
  ordersFinalized: _propTypes2.default.array.isRequired,
  fetchMoreFinalizedTickets: _propTypes2.default.func.isRequired,
  ticketsFetched: _propTypes2.default.bool.isRequired,
  offset: _propTypes2.default.number.isRequired,
  setCurrentOrder: _propTypes2.default.func.isRequired,
  userId: _propTypes2.default.string.isRequired,
  dismissOrder: _propTypes2.default.func.isRequired,
  cancelDelivery: _propTypes2.default.func.isRequired,
  notification: _propTypes2.default.object.isRequired
};

OrdersLayout.defaultProps = {
  order: null
};

exports.default = OrdersLayout;

/***/ }),

/***/ 3407:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(47);

var _reactRouter = __webpack_require__(49);

var _PageContainerLayout = __webpack_require__(3408);

var _PageContainerLayout2 = _interopRequireDefault(_PageContainerLayout);

var _getSirenEnabled = __webpack_require__(3416);

var _getSirenEnabled2 = _interopRequireDefault(_getSirenEnabled);

var _getSirenIntervalOfFive = __webpack_require__(3417);

var _getSirenIntervalOfFive2 = _interopRequireDefault(_getSirenIntervalOfFive);

var _orderSound = __webpack_require__(1527);

var _user = __webpack_require__(353);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageContainer = function PageContainer(props) {
  return _react2.default.createElement(_PageContainerLayout2.default, props);
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _state$orderSound = state.orderSound,
      isSoundMuted = _state$orderSound.isSoundMuted,
      hasUserInteractedWithPage = _state$orderSound.hasUserInteractedWithPage,
      userDisplayName = state.auth.userDisplayName;


  return {
    name: userDisplayName,
    isSoundMuted: isSoundMuted,
    isSoundEnabled: (0, _getSirenEnabled2.default)(state),
    soundIntervalOfFive: (0, _getSirenIntervalOfFive2.default)(state, ownProps),
    hasUserInteractedWithPage: hasUserInteractedWithPage,
    withOldHeader: ownProps.withOldHeader,
    withFullWidth: ownProps.withFullWidth,
    withSidebar: ownProps.withSidebar
  };
};
var actions = { logout: _user.logout, muteSound: _orderSound.muteSound, unmuteSound: _orderSound.unmuteSound, soundWarningDismissed: _orderSound.soundWarningDismissed, soundPlayed: _orderSound.soundPlayed, soundFailed: _orderSound.soundFailed };
exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, actions)(PageContainer));

/***/ }),

/***/ 3408:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _reactRouter = __webpack_require__(49);

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

var _uiComponents = __webpack_require__(369);

var _utils = __webpack_require__(1079);

var _PageSidebar = __webpack_require__(3409);

var _PageSidebar2 = _interopRequireDefault(_PageSidebar);

__webpack_require__(3415);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = _extends({}, _utils.intlPropTypes, _utils.routerPropTypes, {
  logout: _propTypes2.default.func.isRequired,
  isSoundEnabled: _propTypes2.default.bool.isRequired,
  soundIntervalOfFive: _propTypes2.default.bool.isRequired,
  name: _propTypes2.default.string.isRequired,
  muteSound: _propTypes2.default.func.isRequired,
  unmuteSound: _propTypes2.default.func.isRequired,
  isSoundMuted: _propTypes2.default.bool.isRequired,
  subheader: _propTypes2.default.func,
  children: _propTypes2.default.node,
  hasUserInteractedWithPage: _propTypes2.default.bool.isRequired,
  withOldHeader: _propTypes2.default.bool,
  withFullWidth: _propTypes2.default.bool,
  withSidebar: _propTypes2.default.bool
});

var defaultProps = {
  subheader: null,
  children: null,
  withOldHeader: true,
  withFullWidth: false,
  withSidebar: true
};

var PageContainerLayout = function (_Component) {
  _inherits(PageContainerLayout, _Component);

  function PageContainerLayout(props) {
    _classCallCheck(this, PageContainerLayout);

    var _this = _possibleConstructorReturn(this, (PageContainerLayout.__proto__ || Object.getPrototypeOf(PageContainerLayout)).call(this, props));

    _this.showLogouModal = function () {
      _this.modal.show();
    };

    _this.handleRef = function (refName) {
      return function (ref) {
        _this[refName] = ref;
      };
    };

    _this.expandSidebar = function () {
      _this.setState({
        isSidebarExpanded: true
      });
    };

    _this.retractSidebar = function () {
      _this.setState({
        isSidebarExpanded: false
      });
    };

    _this.handleLogout = function () {
      _this.props.router.push('/logout');
    };

    _this.onSoundClick = function () {
      var isSoundMuted = _this.props.isSoundMuted;


      if (isSoundMuted) {
        _this.props.unmuteSound();
      } else {
        _this.props.muteSound();
      }
    };

    _this.state = {
      isSidebarExpanded: false
    };
    return _this;
  }

  _createClass(PageContainerLayout, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          logout = _props.logout,
          isSoundEnabled = _props.isSoundEnabled,
          soundIntervalOfFive = _props.soundIntervalOfFive,
          subheader = _props.subheader,
          children = _props.children,
          name = _props.name,
          title = _props.title,
          isSoundMuted = _props.isSoundMuted,
          formatMessage = _props.intl.formatMessage,
          routes = _props.routes,
          soundWarningDismissed = _props.soundWarningDismissed,
          soundFailed = _props.soundFailed,
          soundPlayed = _props.soundPlayed,
          hasUserInteractedWithPage = _props.hasUserInteractedWithPage,
          router = _props.router,
          location = _props.location,
          withOldHeader = _props.withOldHeader,
          withFullWidth = _props.withFullWidth,
          withSidebar = _props.withSidebar;
      var isSidebarExpanded = this.state.isSidebarExpanded;

      var pageContainerClass = (0, _classnames2.default)('PageContainer', {
        'is-sidebar_expanded': isSidebarExpanded
      });
      var currentRoute = routes[routes.length - 1];

      return _react2.default.createElement(
        'div',
        { className: pageContainerClass },
        _react2.default.createElement(
          'div',
          { className: 'PageContainer__content' },
          withSidebar && _react2.default.createElement(_PageSidebar2.default, {
            onExpandSidebar: this.expandSidebar,
            onRetractSidebar: this.retractSidebar,
            isSidebarExpanded: isSidebarExpanded,
            username: name,
            onLogout: this.handleLogout,
            isSoundMuted: isSoundMuted,
            onSoundClick: this.onSoundClick,
            formatMessage: formatMessage,
            currentPath: location.pathname
          }),
          _react2.default.createElement(
            'div',
            {
              className: (0, _classnames2.default)('PageContainer__main_wrapper', {
                'PageContainer__main_wrapper--without-sidebar': !withSidebar
              })
            },
            withOldHeader && _react2.default.createElement(_uiComponents.Header, {
              isDark: true,
              subheader: subheader,
              title: title || currentRoute && currentRoute.title
            }),
            _react2.default.createElement(
              'main',
              { className: (0, _classnames2.default)({ u__container: !withFullWidth }) },
              children
            )
          )
        ),
        _react2.default.createElement(
          _uiComponents.Modal,
          {
            onConfirm: logout,
            ref: this.handleRef('modal'),
            size: 'x-small',
            title: formatMessage({
              id: 'logout_confirm_sure',
              defaultMessage: 'Are you sure you want to sign out?'
            }),
            cancelButtonText: formatMessage({
              id: 'logout_confirm_cancel',
              defaultMessage: 'No'
            }),
            confirmButtonText: formatMessage({
              id: 'logout_confirm_logout',
              defaultMessage: 'Sign out'
            })
          },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'logout_confirm_description',
            defaultMessage: 'You will continue to appear opened or closed according to the opening and closing times'
          })
        ),
        !hasUserInteractedWithPage && _react2.default.createElement(_uiComponents.OrderSoundNotification, {
          hasUserInteractedWithPage: hasUserInteractedWithPage,
          onSoundWarningDismissed: soundWarningDismissed
        }),
        _react2.default.createElement(_uiComponents.OrderSoundPlayer, {
          loopInterval: soundIntervalOfFive ? 5000 : 1000,
          isSoundEnabled: isSoundEnabled,
          onSoundFailed: soundFailed,
          onSoundPlayed: soundPlayed
        })
      );
    }
  }]);

  return PageContainerLayout;
}(_react.Component);

PageContainerLayout.propTypes = propTypes;
PageContainerLayout.defaultProps = defaultProps;

var componentWithRouter = (0, _reactRouter.withRouter)(PageContainerLayout);
var componentWithIntl = (0, _reactIntl.injectIntl)(componentWithRouter);

exports.default = componentWithIntl;

/***/ }),

/***/ 3409:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PageSidebar = __webpack_require__(3410);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PageSidebar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 3410:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _config = __webpack_require__(167);

var _config2 = _interopRequireDefault(_config);

var _uiComponents = __webpack_require__(369);

var _icon_menuItemOrders = __webpack_require__(3411);

var _icon_menuItemOrders2 = _interopRequireDefault(_icon_menuItemOrders);

var _icon_menuItemSearch = __webpack_require__(3412);

var _icon_menuItemSearch2 = _interopRequireDefault(_icon_menuItemSearch);

var _mdtLogo = __webpack_require__(3413);

var _mdtLogo2 = _interopRequireDefault(_mdtLogo);

__webpack_require__(3414);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PageSidebar(_ref) {
  var onExpandSidebar = _ref.onExpandSidebar,
      onRetractSidebar = _ref.onRetractSidebar,
      isSidebarExpanded = _ref.isSidebarExpanded,
      username = _ref.username,
      onLogout = _ref.onLogout,
      isSoundMuted = _ref.isSoundMuted,
      onSoundClick = _ref.onSoundClick,
      formatMessage = _ref.formatMessage,
      currentPath = _ref.currentPath;

  var isActive = function isActive(urlToMatch) {
    return currentPath === urlToMatch;
  };
  var isOrders = function isOrders() {
    return isActive('/orders') || isActive('/') && currentPath.length === 1;
  };

  var links = [{
    key: 'orders-link',
    to: '/',
    isActive: isOrders(),
    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'orders', defaultMessage: 'Orders' }),
    icon: _react2.default.createElement('img', { src: _icon_menuItemOrders2.default, alt: 'orders icon' })
  }, {
    key: 'new-dealers-page',
    to: _config2.default.newMdtHost + '/revendedores',
    isExternal: true,
    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dealers.search' }),
    icon: _react2.default.createElement('img', { src: _icon_menuItemSearch2.default, alt: 'menu stores icon' })
  }].filter(function (link) {
    return !link.disabled;
  });

  return _react2.default.createElement(
    'div',
    {
      className: 'PageContainer__sidebar_wrapper',
      onMouseEnter: onExpandSidebar,
      onMouseLeave: onRetractSidebar
    },
    _react2.default.createElement(_uiComponents.SideBar, {
      links: links,
      isSideBarExpanded: isSidebarExpanded,
      username: username,
      logout: onLogout,
      isSoundMuted: isSoundMuted,
      onSoundClick: onSoundClick,
      logo: _mdtLogo2.default,
      canMuteIndefinitely: true,
      isDark: true,
      welcomeMessage: formatMessage({ id: 'menu_welcome', defaultMessage: 'Welcome,' }),
      logoutTooltipText: formatMessage({
        id: 'logout_confirm_logout',
        defaultMessage: 'Logout'
      }),
      sirenTooltipText: formatMessage({
        id: 'alert_sound',
        defaultMessage: 'Alert sound'
      })
    })
  );
}

PageSidebar.propTypes = {
  onExpandSidebar: _propTypes2.default.func.isRequired,
  onRetractSidebar: _propTypes2.default.func.isRequired,
  isSidebarExpanded: _propTypes2.default.bool.isRequired,
  username: _propTypes2.default.string.isRequired,
  onLogout: _propTypes2.default.func.isRequired,
  isSoundMuted: _propTypes2.default.bool.isRequired,
  onSoundClick: _propTypes2.default.func.isRequired,
  formatMessage: _propTypes2.default.func.isRequired,
  currentPath: _propTypes2.default.string.isRequired
};

exports.default = _react2.default.memo(PageSidebar);

/***/ }),

/***/ 3411:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 3412:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU4ICg4NDY2MykgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+aWNvbl9tZW51LWl0ZW0tc2VhcmNoPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9Ii0tLS00LjEtVHJhY2tpbmciIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJHcm91cC0xNCIgZmlsbD0iIzk5QTNDOCI+CiAgICAgICAgICAgIDxnIGlkPSJJY29uL1NpbXBsZS9BY2NvdW50L1NlYXJjaCI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMjEuNDcxMjI0MiwyMC44Njc5OTg4IEMyMS4zOTI2NTc2LDIxLjE2MjU3MTYgMjEuMTYyNTc2MSwyMS4zOTI2NTA0IDIwLjg2Nzk5OTksMjEuNDcxMjE2MSBDMjAuNTczNDIzNywyMS41NDk3ODE4IDIwLjI1OTMyMiwyMS40NjQ4NDA3IDIwLjA0NTA1OTIsMjEuMjQ5MDg3MyBMMTUuNjg4NjA1OCwxNi44OTI2NDg5IEMxMi4zNDAzMzM1LDE5LjYwMDQ1ODIgNy40NTgzNTM1NiwxOS4yMTM4Njk0IDQuNTc3OTk1MiwxNi4wMTI4MzQzIEMxLjY5NzYzNjg0LDEyLjgxMTc5OTIgMS44MjY2NzgyOCw3LjkxNjI5NDEzIDQuODcxNjczMDIsNC44NzE0NDI3NCBDNy45MTY2Njc3NSwxLjgyNjU5MTM1IDEyLjgxMjIzNDcsMS42OTc3MjQ1MyAxNi4wMTMyMDU1LDQuNTc4MTYyMzQgQzE5LjIxNDE3NjIsNy40NTg2MDAxNSAxOS42MDA1OTY5LDEyLjM0MDUzNjYgMTYuODkyNjM3NCwxNS42ODg2NzQgTDIxLjI0ODgzMTgsMjAuMDQ0ODA2NyBDMjEuNDY0OTI5MywyMC4yNTk2MjU3IDIxLjU0OTc1MzYsMjAuNTczNTY1NiAyMS40NzEyMjQyLDIwLjg2Nzk5ODggWiBNMTcuMSwxMC42MDAwOTUgQzE3LjEsNy45NzExMjg2MyAxNS41MTYzNDg4LDUuNjAxMDI3MjYgMTMuMDg3NTAwNSw0LjU5NDk2NTU5IEMxMC42NTg2NTIyLDMuNTg4OTAzOTIgNy44NjI5MjY5Niw0LjE0NTAwODYgNi4wMDM5NjczMiw2LjAwMzk2ODg2IEM0LjE0NTAwNzY5LDcuODYyOTI5MTEgMy41ODg5MDM5NCwxMC42NTg2NTQ1IDQuNTk0OTY2NDIsMTMuMDg3NTAyNSBDNS42MDEwMTIxMiwxNS41MTYzMDk5IDcuOTcxMDUxNzMsMTcuMSAxMC41OTk5NjU2LDE3LjEgQzE0LjE4ODE2MjIsMTcuMDk1ODYxIDE3LjA5NTkzMzMsMTQuMTg4MDQ1MSAxNy4xLDEwLjYwMDA5NSBaIiBpZD0i8J+OqC1JY29uLWNvbG9yIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ 3413:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 3414:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3415:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3416:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(659);

var _lodash2 = _interopRequireDefault(_lodash);

var _status = __webpack_require__(53);

var _getFilteredDealerOrders = __webpack_require__(668);

var _getFilteredDealerOrders2 = _interopRequireDefault(_getFilteredDealerOrders);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSirenEnabled = function getSirenEnabled(state) {
  var orders = (0, _getFilteredDealerOrders2.default)(state);
  var isSoundMuted = state.orderSound.isSoundMuted;


  return !isSoundMuted && (0, _lodash2.default)(orders, function (_ref) {
    var currentTicket = _ref.currentTicket;

    var isTicketIncomingOrder = currentTicket.queue === _status.QUEUE_INCOMING;
    var isTicketOpened = currentTicket.status === _status.STATUS_OPEN;

    return isTicketIncomingOrder && isTicketOpened;
  });
};

exports.default = getSirenEnabled;

/***/ }),

/***/ 3417:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getSirenIntervalOfFive = function getSirenIntervalOfFive(state) {
  var currentOrderId = state.orders.currentOrderId;


  return !!currentOrderId;
};

exports.default = getSirenIntervalOfFive;

/***/ }),

/***/ 3418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(47);

var _ConnectivitySnackBarLayout = __webpack_require__(997);

var _ConnectivitySnackBarLayout2 = _interopRequireDefault(_ConnectivitySnackBarLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
  var apiConnectivity = _ref.apiConnectivity,
      firebase = _ref.firebase;

  var apiDisconnected = !apiConnectivity.connected;
  var firebaseOfflineAfter = firebase.connectedAtLeastOnce ? // if we have connected to Firebase previously we will show a disconnected
  // warning after 1100 ms. Firebase client ping the Firebase server every
  // second, thus setting this to 1100 will guarantee at least two consecutive
  // pings have failed
  1100 : // when we have not connected to Firebase yet (e.g. on initial load) we show
  // disconnected after 1500 ms
  5000;
  var timeSincePreviousFirebaseConnectionStatusChange = Date.now() - firebase.previousConnectionStatusChangeAt;
  var firebaseDisconnectedTooLong = !firebase.connected && timeSincePreviousFirebaseConnectionStatusChange > firebaseOfflineAfter;

  return {
    disconnected: apiDisconnected || firebaseDisconnectedTooLong
  };
};

var ConnectivitySnackBar = function ConnectivitySnackBar(props) {
  return _react2.default.createElement(_ConnectivitySnackBarLayout2.default, props);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ConnectivitySnackBar);

/***/ }),

/***/ 3419:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(140);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(659);

var _lodash4 = _interopRequireDefault(_lodash3);

var _reactRedux = __webpack_require__(47);

var _status = __webpack_require__(53);

var _dealers = __webpack_require__(352);

var _MdtStatusLayout = __webpack_require__(1055);

var _MdtStatusLayout2 = _interopRequireDefault(_MdtStatusLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdtStatus = function MdtStatus(props) {
  return _react2.default.createElement(_MdtStatusLayout2.default, props);
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$dealer = state.dealer,
      all = _state$dealer.all,
      filteredAll = _state$dealer.filteredAll,
      filters = _state$dealer.filters,
      numberOfBuckets = _state$dealer.numberOfBuckets;

  var dealerList = (0, _lodash2.default)(all);
  var isHolidayMode = (0, _lodash4.default)(dealerList, function (dealer) {
    return dealer.isOpenedMode === _status.SHOP_OPENED_MODE_HOLIDAY;
  });

  return {
    filteredDealersList: (0, _lodash2.default)(filteredAll),
    filters: filters,
    numberOfBuckets: numberOfBuckets,
    isHolidayMode: isHolidayMode
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, { toggleFilter: _dealers.toggleFilter })(MdtStatus);

/***/ }),

/***/ 3420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _reactRedux = __webpack_require__(47);

var _reactRouter = __webpack_require__(49);

var _lodash = __webpack_require__(141);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(140);

var _lodash4 = _interopRequireDefault(_lodash3);

var _isOrderAssignedToUser = __webpack_require__(1528);

var _isOrderAssignedToUser2 = _interopRequireDefault(_isOrderAssignedToUser);

var _status = __webpack_require__(53);

var _orderEventHistory = __webpack_require__(1529);

var _dealers = __webpack_require__(352);

var _orders = __webpack_require__(238);

var _OrderDetailsLayout = __webpack_require__(3421);

var _OrderDetailsLayout2 = _interopRequireDefault(_OrderDetailsLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  setCurrentOrder: _propTypes2.default.func.isRequired,
  fetchOrderEventHistory: _propTypes2.default.func.isRequired,
  fetchOrderDetails: _propTypes2.default.func.isRequired,
  dealer: _propTypes2.default.object,
  order: _propTypes2.default.object
};

var defaultProps = {
  order: undefined,
  dealer: {}
};

var unassignTicketToCurrentUserIfRequired = function unassignTicketToCurrentUserIfRequired(props) {
  var id = props.order.currentTicket.id;


  props.unAssignTicketToCurrentUser(id);
};

var OrderDetails = function (_Component) {
  _inherits(OrderDetails, _Component);

  function OrderDetails() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrderDetails);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderDetails.__proto__ || Object.getPrototypeOf(OrderDetails)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isFetchingOrderDetails: true,
      error: null,
      orderDetails: null
    }, _this.onCloseDetailsBtnClick = function () {
      var _this$props = _this.props,
          isAssignedToCurrentUser = _this$props.isAssignedToCurrentUser,
          queue = _this$props.order.currentTicket.queue;


      if (isAssignedToCurrentUser && queue !== _status.QUEUE_FINALIZED) {
        unassignTicketToCurrentUserIfRequired(_this.props);
      }

      _this.closeDetails();
    }, _this.closeDetails = function () {
      return _this.props.setCurrentOrder(null);
    }, _this.fetchEventHistory = function () {
      var _this$props2 = _this.props,
          id = _this$props2.dealer.id,
          order = _this$props2.order;


      return _this.props.fetchOrderEventHistory(id, order.id);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OrderDetails, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props$order = this.props.order,
          id = _props$order.id,
          dealerId = _props$order.dealerId;


      this.fetchOrderDetails(dealerId, id);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var _props = this.props,
          router = _props.router,
          routes = _props.routes;


      var routerLeaveHook = router.setRouteLeaveHook(routes[1], function () {
        var _props2 = _this2.props,
            isAssignedToCurrentUser = _props2.isAssignedToCurrentUser,
            queue = _props2.order.currentTicket.queue;


        if (isAssignedToCurrentUser && queue !== _status.QUEUE_FINALIZED) {
          unassignTicketToCurrentUserIfRequired(_this2.props);
          routerLeaveHook();
        }

        _this2.closeDetails();

        return true;
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var nextOrder = nextProps.order;
      var prevOrder = this.props.order;

      if (prevOrder && nextOrder) {
        var orderChanged = prevOrder.id !== nextOrder.id;
        var isAssignedToCurrentUser = this.props.isAssignedToCurrentUser;


        if (orderChanged) {
          this.fetchOrderDetails(nextOrder.dealerId, nextOrder.id);
        }

        if (orderChanged && isAssignedToCurrentUser) {
          // User changed order by clicking another one
          unassignTicketToCurrentUserIfRequired(this.props);
        }
      }
    }
  }, {
    key: 'fetchOrderDetails',
    value: function fetchOrderDetails(dealerId, orderId) {
      var _this3 = this;

      var fetchOrderDetails = this.props.fetchOrderDetails;


      this.setState({ isFetchingOrderDetails: true }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var orderDetails;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetchOrderDetails(dealerId, orderId);

              case 3:
                orderDetails = _context.sent;

                _this3.setState({
                  isFetchingOrderDetails: false,
                  orderDetails: orderDetails
                });
                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);
                _this3.setState({
                  error: _context.t0,
                  isFetchingOrderDetails: false
                });

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 7]]);
      })));
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          isFetchingOrderDetails = _state.isFetchingOrderDetails,
          orderDetails = _state.orderDetails,
          error = _state.error;


      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        error && _react2.default.createElement(
          'b',
          null,
          JSON.stringify(error)
        ),
        _react2.default.createElement(_OrderDetailsLayout2.default, _extends({}, this.props, {
          orderDetails: orderDetails,
          isFetchingOrderDetails: isFetchingOrderDetails,
          onCloseDetailsBtnClick: this.onCloseDetailsBtnClick,
          closeDetails: this.closeDetails,
          fetchEventHistory: this.fetchEventHistory
        }))
      );
    }
  }]);

  return OrderDetails;
}(_react.Component);

OrderDetails.propTypes = propTypes;
OrderDetails.defaultProps = defaultProps;

var mapStateToProps = function mapStateToProps(state) {
  var dealer = state.dealer,
      orders = state.orders,
      chamaID = state.auth.chamaID,
      orderEventHistory = state.orderEventHistory;
  var currentOrderId = orders.currentOrderId,
      beingProcessedOrderIds = orders.beingProcessedOrderIds;

  var order = orders.dict[currentOrderId];
  var isOrderBeingProcessed = beingProcessedOrderIds.indexOf(order.id) !== -1;

  var currentUser = chamaID;

  if (!order) {
    // forcing a falsey value
    return {
      order: null
    };
  }

  var dealerOrder = dealer.all[order.dealerId];
  var reduceNumberOfDealers = function reduceNumberOfDealers(accum, dealerId) {
    var hasId = !!dealer.all[dealerId].id;

    if (hasId) {
      return accum + 1;
    }

    return accum;
  };
  var isLoadingCommand = orders.isExecutingCommand;
  var isLoadingAssignment = orders.isExecutingAssignment;
  var displayDealerName = (0, _lodash2.default)(dealer.all).reduce(reduceNumberOfDealers, 0) > 1;
  var nearbyDealersList = (0, _lodash4.default)(dealer.nearby.dict).map(function (nearbyDealer) {
    var dealerInDealersAdmin = dealer.all[nearbyDealer.id];

    if (dealerInDealersAdmin) {
      return _extends({}, nearbyDealer, {
        isActive: dealerInDealersAdmin.isActive
      });
    }

    return nearbyDealer;
  });

  return {
    order: order,
    displayDealerName: displayDealerName,
    isLoadingCommand: isLoadingCommand,
    isLoadingAssignment: isLoadingAssignment,
    dealer: dealerOrder,
    nearbyDealersList: nearbyDealersList,
    isOrderBeingProcessed: isOrderBeingProcessed,
    currentUser: currentUser,
    isAssignedToCurrentUser: (0, _isOrderAssignedToUser2.default)(currentUser, order),
    eventHistory: orderEventHistory.orders[order.id],
    isFetchingEventHistory: orderEventHistory.isFetching
  };
};

var mapDispatchToProps = {
  unAssignTicketToCurrentUser: _orders.unAssignTicketToCurrentUser,
  assignTicketToCurrentUser: _orders.assignTicketToCurrentUser,
  startDelivery: _orders.startDelivery,
  declineOrder: _orders.declineOrder,
  deliverOrder: _orders.deliverOrder,
  cancelOrder: _orders.cancelOrder,
  dismissOrder: _orders.dismissOrder,
  cancelDelivery: _orders.cancelDelivery,
  getNearbyDealers: _dealers.getNearbyDealers,
  setCurrentOrder: _orders.setCurrentOrder,
  fetchOrderEventHistory: _orderEventHistory.fetchOrderEventHistory,
  fetchOrderDetails: _orders.fetchOrderDetails
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(OrderDetails)));

/***/ }),

/***/ 3421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(49);

var _reactIntl = __webpack_require__(16);

var _moment = __webpack_require__(3);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

var _clipboard = __webpack_require__(626);

var _clipboard2 = _interopRequireDefault(_clipboard);

var _lodash = __webpack_require__(584);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactTransitionGroup = __webpack_require__(126);

var _person = __webpack_require__(1052);

var _person2 = _interopRequireDefault(_person);

var _place = __webpack_require__(1053);

var _place2 = _interopRequireDefault(_place);

var _cancel = __webpack_require__(552);

var _cancel2 = _interopRequireDefault(_cancel);

var _warning = __webpack_require__(998);

var _warning2 = _interopRequireDefault(_warning);

var _store = __webpack_require__(3422);

var _store2 = _interopRequireDefault(_store);

var _cardGiftcard = __webpack_require__(409);

var _cardGiftcard2 = _interopRequireDefault(_cardGiftcard);

var _csIcon = __webpack_require__(3423);

var _csIcon2 = _interopRequireDefault(_csIcon);

var _checkCircle = __webpack_require__(1060);

var _checkCircle2 = _interopRequireDefault(_checkCircle);

var _contentCopy = __webpack_require__(1530);

var _contentCopy2 = _interopRequireDefault(_contentCopy);

var _appInsights = __webpack_require__(461);

var _appInsights2 = _interopRequireDefault(_appInsights);

var _config = __webpack_require__(167);

var _config2 = _interopRequireDefault(_config);

var _formatPhone = __webpack_require__(590);

var _formatPhone2 = _interopRequireDefault(_formatPhone);

var _cancellationReasons = __webpack_require__(1227);

var _cancellationReasons2 = _interopRequireDefault(_cancellationReasons);

var _deliveryStatus = __webpack_require__(3424);

var _deliveryStatus2 = _interopRequireDefault(_deliveryStatus);

var _currency = __webpack_require__(153);

var _orderValues = __webpack_require__(585);

var _status = __webpack_require__(53);

var _payments = __webpack_require__(3425);

var _windowWatcher = __webpack_require__(1078);

var _windowWatcher2 = _interopRequireDefault(_windowWatcher);

var _MapThumbBtn = __webpack_require__(581);

var _MapThumbBtn2 = _interopRequireDefault(_MapThumbBtn);

var _Tooltip = __webpack_require__(221);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _Spinner = __webpack_require__(125);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _Button = __webpack_require__(127);

var _Button2 = _interopRequireDefault(_Button);

var _Switch = __webpack_require__(1073);

var _Switch2 = _interopRequireDefault(_Switch);

var _Modal = __webpack_require__(178);

var _Modal2 = _interopRequireDefault(_Modal);

var _OrderPriceOverview = __webpack_require__(583);

var _OrderPriceOverview2 = _interopRequireDefault(_OrderPriceOverview);

var _IconTextInfo = __webpack_require__(582);

var _IconTextInfo2 = _interopRequireDefault(_IconTextInfo);

var _eyeBlue = __webpack_require__(3426);

var _eyeBlue2 = _interopRequireDefault(_eyeBlue);

var _TimeTextLine = __webpack_require__(1074);

var _TimeTextLine2 = _interopRequireDefault(_TimeTextLine);

var _ActionButtons = __webpack_require__(946);

var _ActionButtons2 = _interopRequireDefault(_ActionButtons);

var _EtaSwitch = __webpack_require__(1049);

var _EtaSwitch2 = _interopRequireDefault(_EtaSwitch);

var _Dealer = __webpack_require__(669);

var _Dealer2 = _interopRequireDefault(_Dealer);

var _MdtModals = __webpack_require__(3427);

var _MdtModals2 = _interopRequireDefault(_MdtModals);

var _EventHistory = __webpack_require__(3433);

var _EventHistory2 = _interopRequireDefault(_EventHistory);

__webpack_require__(3444);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = _extends({}, _reactRouter.propTypes, {
  order: _propTypes2.default.object,
  orderDetails: _propTypes2.default.object,
  isLoadingCommand: _propTypes2.default.bool.isRequired,
  displayDealerName: _propTypes2.default.bool.isRequired,
  isFetchingEventHistory: _propTypes2.default.bool.isRequired,
  isOrderBeingProcessed: _propTypes2.default.bool.isRequired,
  getNearbyDealers: _propTypes2.default.func.isRequired,
  fetchEventHistory: _propTypes2.default.func.isRequired,
  nearbyDealersList: _propTypes2.default.array.isRequired,
  eventHistory: _propTypes2.default.array,
  isFetchingOrderDetails: _propTypes2.default.bool.isRequired
});

var defaultProps = {
  order: undefined,
  eventHistory: [],
  orderDetails: undefined
};

var ETAS = [{ value: '15', window: '15', label: 'até 15 min' }, { value: '30', window: '15', label: '15 - 30 min' }, { value: '45', window: '15', label: '30 - 45 min' }, { value: '60', window: '15', label: '45 - 60 min' }];

var formatPhone = _formatPhone2.default['pt-BR'];

var OrderDetailsLayout = function (_Component) {
  _inherits(OrderDetailsLayout, _Component);

  function OrderDetailsLayout(props) {
    _classCallCheck(this, OrderDetailsLayout);

    var _this = _possibleConstructorReturn(this, (OrderDetailsLayout.__proto__ || Object.getPrototypeOf(OrderDetailsLayout)).call(this, props));

    _this.measureOffsetTop = function (isFixed) {
      var _this$component$getBo = _this.component.getBoundingClientRect(),
          top = _this$component$getBo.top;

      if (isFixed && !_this.fixedOffsetTop) {
        _this.fixedOffsetTop = top;
      } else if (!_this.normalOffsetTop) {
        _this.normalOffsetTop = top;
      }
    };

    _this.getOffsetTop = function (isFixed) {
      if (isFixed) {
        return _this.fixedOffsetTop;
      }

      return _this.normalOffsetTop;
    };

    _this.changeContentHeightIfNeeded = function (windowHeight, offsetTop) {
      var spacing = 20;

      if (windowHeight - offsetTop <= _this.componentHeight) {
        _this.content.style.height = windowHeight - offsetTop - spacing + 'px';
      } else {
        _this.content.style.height = 'auto';
      }
    };

    _this.handleRef = function (refName) {
      return function (ref) {
        _this[refName] = ref;
      };
    };

    _this.close = function () {
      return _this.props.closeDetails();
    };

    _this.startDelivery = function (e) {
      e.preventDefault();
      _this.track('mdt-order-accept-button-pressed');
      _this.props.startDelivery(_this.ticket.id, _this.state.eta, _this.state.etaWindow);
    };

    _this.declineOrder = function (reason, message) {
      _this.track('mdt-order-decline-button-pressed');
      _this.props.declineOrder(_this.ticket.id, reason, message);
    };

    _this.deliverOrder = function (e) {
      e.preventDefault();
      _this.track('mdt-order-deliver-button-pressed');
      _this.props.deliverOrder(_this.ticket.id);
    };

    _this.cancelOrder = function (reason, message) {
      _this.track('mdt-order-cancel-button-pressed');
      _this.props.cancelOrder(_this.ticket.id, reason, message);
    };

    _this.dismissCancelNewOrder = function (e) {
      var _this$ticket = _this.ticket,
          id = _this$ticket.id,
          eTag = _this$ticket.eTag;


      e.preventDefault();

      _this.props.dismissOrder(id, eTag);
    };

    _this.dismissCancelDeliverOrder = function (e) {
      var _this$ticket2 = _this.ticket,
          id = _this$ticket2.id,
          eTag = _this$ticket2.eTag;


      e.preventDefault();

      _this.props.cancelDelivery(id, eTag);
    };

    _this.toggleTicketControl = function () {
      var _this$props = _this.props,
          unAssignTicketToCurrentUser = _this$props.unAssignTicketToCurrentUser,
          isAssignedToCurrentUser = _this$props.isAssignedToCurrentUser;
      var id = _this.ticket.id;


      if (isAssignedToCurrentUser) {
        unAssignTicketToCurrentUser(id);
      } else {
        _this.takeControlModal.show();
      }
    };

    _this.displayText = function (text, entity) {
      var formatMessage = _this.props.intl.formatMessage;


      if (!text || text && text.length === 0) {
        var i18nEntity = (0, _lodash2.default)(formatMessage({
          id: entity,
          defaultMessage: entity
        }));

        var uninformedI18n = formatMessage({
          id: 'not_available',
          defaultMessage: 'not available'
        });

        return i18nEntity + ' ' + uninformedI18n;
      }

      return text;
    };

    _this.onETAChange = function (etaIndex) {
      var _ETAS$etaIndex = ETAS[etaIndex],
          value = _ETAS$etaIndex.value,
          window = _ETAS$etaIndex.window;


      _this.setState({
        eta: value,
        etaWindow: window
      });
    };

    _this.openReallocationModal = function () {
      var _this$props$order = _this.props.order,
          lat = _this$props$order.lat,
          lon = _this$props$order.lon;

      var doneLoading = function doneLoading() {
        _this.reallocationModal.show();
        _this.setState({ loadingNearbyDealers: false });
      };

      _this.setState({ loadingNearbyDealers: true });

      _this.props.getNearbyDealers(lat, lon).then(doneLoading);
    };

    _this.renderConsumerDeliveredStatus = function () {
      var consumerDelivered = _this.props.order.consumerDelivered;


      if (consumerDelivered) {
        return _react2.default.createElement(
          'div',
          { className: 'OrderDetailsLayout__row' },
          _react2.default.createElement(
            'div',
            { className: 'OrderDetailsLayout__consumer_delivered OrderDetailsLayout__col OrderDetailsLayout__col--centered' },
            _react2.default.createElement(
              _IconTextInfo2.default,
              { Icon: _checkCircle2.default, iconFullOpacity: true },
              _react2.default.createElement(
                'strong',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'order_details_consumer_delivered_status',
                  defaultMessage: 'This order was flagged as delivered by the consumer'
                })
              )
            )
          )
        );
      }

      return null;
    };

    _this.renderActionTimeContent = function () {
      var _this$props2 = _this.props,
          isAssignedToCurrentUser = _this$props2.isAssignedToCurrentUser,
          _this$props2$order = _this$props2.order,
          eta = _this$props2$order.eta,
          etaWindowMinutes = _this$props2$order.etaWindowMinutes,
          isLoadingAssignment = _this$props2.isLoadingAssignment;
      var status = _this.ticket.status;


      if (status === _status.STATUS_DONE) {
        if (_this.isCancelledByDealer || _this.isCancelledByCustomer) {
          return _react2.default.createElement(
            'div',
            { className: 'OrderDetailsLayout__text_line' },
            _react2.default.createElement(
              _TimeTextLine2.default,
              { time: _this.ticket.modificationTime },
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'cancelled_at', defaultMessage: 'Cancelled at' })
            )
          );
        }

        return _react2.default.createElement(
          'div',
          { className: 'OrderDetailsLayout__text_line' },
          _react2.default.createElement(
            _TimeTextLine2.default,
            { time: _this.ticket.modificationTime },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'delivered_confirmed_at', defaultMessage: 'Delivery confirmed at' })
          )
        );
      }

      if (_this.isNewOrder) {
        var selectedEta = _this.state.eta;

        return isAssignedToCurrentUser && _react2.default.createElement(_EtaSwitch2.default, {
          etaList: ETAS,
          currentEta: selectedEta,
          enabled: isAssignedToCurrentUser || isLoadingAssignment,
          onEtaChange: _this.onETAChange
        });
      }

      if (_this.isDeliverOrder) {
        if (etaWindowMinutes && etaWindowMinutes > 0) {
          var windowEta = (0, _moment2.default)(eta).subtract(etaWindowMinutes, 'minutes');

          return _react2.default.createElement(
            'div',
            { className: 'OrderDetailsLayout__text_line' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'strong',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'delivery_etasetto',
                  defaultMessage: 'Estimated time of arrival'
                })
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_reactIntl.FormattedDate, { value: new Date(eta), year: 'numeric', month: 'long', day: '2-digit' }),
              '\xA0',
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'between', defaultMessage: 'between' }),
              '\xA0',
              (0, _moment2.default)(windowEta).format('HH:mm'),
              '\xA0',
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'and', defaultMessage: 'and' }),
              '\xA0',
              (0, _moment2.default)(eta).format('HH:mm')
            )
          );
        }

        return _react2.default.createElement(
          'div',
          { className: 'OrderDetailsLayout__text_line' },
          _react2.default.createElement(
            _TimeTextLine2.default,
            { time: eta },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'delivery_etasetto', defaultMessage: 'Estimated time of arrival' })
          )
        );
      }

      return null;
    };

    _this.renderHeader = function () {
      var displayDealerName = _this.props.displayDealerName;


      if (displayDealerName) {
        var dealer = _this.props.dealer;


        return _react2.default.createElement(
          'div',
          { className: 'OrderDetailsLayout__panel OrderDetailsLayout__panel--shop_name' },
          _react2.default.createElement(
            'div',
            { className: 'OrderDetailsLayout__row' },
            _react2.default.createElement(
              'div',
              { className: 'OrderDetailsLayout__col OrderDetailsLayout__col--centered' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_store2.default, { className: 'OrderDetailsLayout__icon' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'OrderDetailsLayout__text' },
                _react2.default.createElement(
                  'strong',
                  null,
                  dealer.name
                ),
                _react2.default.createElement(
                  'a',
                  {
                    href: _config2.default.newMdtHost + '/revendedores/' + _Dealer2.default.getMainShopIdFromSubshopId(dealer.id) + '/detalhes',
                    className: 'OrderDetailsLayout__dealer-link',
                    rel: 'noopener noreferrer',
                    target: '_blank'
                  },
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'order_history.see_details' })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'OrderDetails__col OrderDetails__col--buttons' },
              _react2.default.createElement(
                _Button2.default,
                {
                  variant: 'secondary',
                  onClick: _this.openReallocationModal,
                  isLoading: _this.state.loadingNearbyDealers
                },
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'reallocate', defaultMessage: 'REALLOCATE' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'OrderDetails__col OrderDetailsLayout__col--centered' },
              _this.renderCloseDetailsBtn()
            )
          )
        );
      }

      return null;
    };

    _this.renderCloseDetailsBtn = function () {
      var formatMessage = _this.props.intl.formatMessage;

      var title = formatMessage({
        id: 'close_window',
        defaultMessage: 'Close window'
      });

      return _react2.default.createElement(
        _Tooltip2.default,
        { position: 'left', title: title },
        _react2.default.createElement(_cancel2.default, {
          role: 'button',
          onClick: _this.props.onCloseDetailsBtnClick,
          className: 'OrderDetailsLayout__close_btn'
        })
      );
    };

    _this.onOrderDetailsMouseEnter = function () {
      var clipboardButtons = document.querySelectorAll('.clipboard-button');

      _this.clipboard = new _clipboard2.default(clipboardButtons);

      _this.setState({ isOrderDetailsOptionsOpen: true });
    };

    _this.onOrderDetailsMouseLeave = function () {
      if (_this.clipboard) {
        _this.clipboard.destroy();
      }

      _this.setState({ isOrderDetailsOptionsOpen: false });
    };

    _this.renderOrderDetailsCopyButton = function () {
      // eslint-disable-next-line no-unused-vars
      var isOrderDetailsOptionsOpen = _this.state.isOrderDetailsOptionsOpen;
      var _this$props3 = _this.props,
          order = _this$props3.order,
          dealer = _this$props3.dealer,
          serviceArea = _this$props3.orderDetails.serviceArea,
          formatMessage = _this$props3.intl.formatMessage;


      var addressIntl = formatMessage({
        id: 'order_details.customer.address',
        defaultMessage: 'Address'
      });
      var addressExtraIntl = formatMessage({
        id: 'order_details.customer.address_extra',
        defaultMessage: 'Address extra'
      });
      var remarkIntl = formatMessage({
        id: 'order_details.customer.remark',
        defaultMessage: 'Remark'
      });

      var totalIntl = formatMessage({
        id: 'order_details.table.order_total',
        defaultMessage: 'Total'
      });
      var paymentIntl = formatMessage({
        id: 'order_details.table.payment',
        defaultMessage: 'Payment'
      });
      var paymentTypeIntl = function paymentTypeIntl(type) {
        return formatMessage({
          id: 'order_details.payment_method.' + type,
          defaultMessage: order.paymentType
        });
      };
      var copyBtnTooltip = formatMessage({
        id: 'order_details.copy_order_details',
        defaultMessage: 'Copy order details'
      });
      var orderProducts = order.products.map(function (pr) {
        return pr.quantity + ' ' + pr.properties.brand + ' ' + pr.properties.type;
      });
      var orderProductsString = orderProducts.join('\n');
      var orderTotal = (0, _orderValues.getOrderTotal)(order, true);

      var phoneNumber = formatPhone(dealer.phone.replace(/^\+55 */, ''));

      var serviceAreaMessage = serviceArea && serviceArea.serviceAreaName ? formatMessage({ id: 'serviceareas.area-name' }) + ': ' + serviceArea.serviceAreaName + '\n' : '';

      var orderDetailsText = dealer.name + ' (' + dealer.id + ')\n' + ('' + serviceAreaMessage) + (formatMessage({ id: 'phone_number' }) + ': ' + phoneNumber + ' \n') + '\n' + (formatMessage({ id: 'client' }) + ': ' + (order.customerName || '-') + '\n') + (addressIntl + ': ' + (order.address || '-') + '\n') + (addressExtraIntl + ': ' + (order.addressRemark || '-') + '\n') + (remarkIntl + ': ' + (order.customerRemark || '-') + ' \n') + '\n' + ((orderProductsString || '-') + '\n') + (totalIntl + ': R$' + (orderTotal || '-') + '\n') + ('*' + paymentIntl + ': ' + paymentTypeIntl(order.paymentType) + '* ');

      switch (order.paymentType) {
        case _payments.CASH:
          {
            if (order.isChangeNeeded) {
              var rest = order.changeAmount - (0, _orderValues.getOrderTotal)(order, true);
              var changeForIntl = ' - *' + formatMessage({ id: 'change_for' }) + ' ' + ((0, _currency.formatPrice)(order.changeAmount) + ' (' + (0, _currency.formatPrice)(rest) + ')*');

              orderDetailsText += changeForIntl;
            }
            break;
          }
        case _payments.CREDIT:
        case _payments.DEBIT:
          {
            orderDetailsText += ' - *' + formatMessage({
              id: 'order_details.payment_method.bring_card_machine'
            }) + '*';
            break;
          }
        // eslint-disable-next-line no-empty
        default:
          {}
      }

      return _react2.default.createElement(
        'div',
        { key: 'OrderDetailsCopyButton', className: 'OrderDetails__copy_details' },
        _react2.default.createElement(
          _Tooltip2.default,
          { position: 'left', offset: '-60', title: copyBtnTooltip },
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'OrderDetails__copy_details_btn clipboard-button',
              'data-clipboard-text': orderDetailsText
            },
            _react2.default.createElement(_contentCopy2.default, { className: 'OrderDetails__copy_details_btn_icon' })
          )
        )
      );
    };

    _this.renderDealerInfo = function () {
      var _this$props4 = _this.props,
          dealer = _this$props4.dealer,
          formatMessage = _this$props4.intl.formatMessage,
          serviceArea = _this$props4.orderDetails.serviceArea;


      if (dealer) {
        var phone = dealer.phone;

        var phoneNumber = formatPhone(phone.replace(/^\+55 */, ''));

        var phoneClipboardText = phone.replace(/^\+55 */, '').replace(/([()])/g, '').replace(/-/g, '');

        return _react2.default.createElement(
          'div',
          { className: 'OrderDetailsLayout__row' },
          _react2.default.createElement(
            _IconTextInfo2.default,
            { Icon: _store2.default },
            _react2.default.createElement(
              'span',
              null,
              dealer.name,
              ' ',
              _react2.default.createElement(
                'span',
                { className: 'OrderSnippet__dealer_id' },
                '(',
                dealer.id,
                ')'
              )
            ),
            serviceArea && serviceArea.serviceAreaName && _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'serviceareas.area-name' }),
              ': ',
              serviceArea.serviceAreaName,
              _react2.default.createElement(
                'span',
                { className: 'OrderSnippet__dealer_id' },
                ' (',
                serviceArea.serviceAreaId,
                ')'
              )
            ),
            _react2.default.createElement(
              'a',
              {
                className: 'OrderDetailsLayout__dealer-link clipboard-button',
                rel: 'noopener noreferrer',
                'data-clipboard-text': phoneClipboardText
              },
              _react2.default.createElement(
                _Tooltip2.default,
                {
                  position: 'left',
                  offset: '-60',
                  title: formatMessage({ id: 'order_details.copy_dealer_phone' })
                },
                _react2.default.createElement(
                  'span',
                  null,
                  phoneNumber
                )
              )
            )
          )
        );
      }

      return null;
    };

    _this.renderCustomerInfo = function () {
      var order = _this.props.order;
      var phone = order.phone,
          customerName = order.customerName;

      var phoneNumber = formatPhone(phone.replace(/^\+55 */, ''));
      var name = _this.displayText(customerName, 'name');
      var elementWithPhone = _react2.default.createElement(
        'div',
        { className: 'OrderDetailsLayout__row' },
        _react2.default.createElement(
          _IconTextInfo2.default,
          { Icon: _person2.default },
          _react2.default.createElement(
            'span',
            null,
            name
          ),
          _react2.default.createElement(
            'div',
            null,
            phoneNumber
          )
        )
      );

      return elementWithPhone;
    };

    _this.renderAdditionalInfo = function () {
      var order = _this.props.order;
      var address = order.address,
          customerRemark = order.customerRemark,
          addressRemark = order.addressRemark;


      return _react2.default.createElement(
        'div',
        { className: 'OrderDetailsLayout__row' },
        _react2.default.createElement(
          _IconTextInfo2.default,
          { Icon: _place2.default },
          _react2.default.createElement(
            'div',
            null,
            address
          ),
          _react2.default.createElement(
            'div',
            null,
            addressRemark
          ),
          _react2.default.createElement(
            'div',
            null,
            customerRemark
          )
        )
      );
    };

    _this.renderCancelWarningText = function () {
      var status = _this.props.order.status;


      if (_this.isCancelledByCustomer) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'cancelled_by_customer', defaultMessage: 'Cancelled by the customer' });
      }

      if (status === _status.ORDER_STATUS_DEALER_DECLINED) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'declined_by_dealer', defaultMessage: 'Declined by the dealer' });
      }

      return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'cancelled_by_dealer', defaultMessage: 'Cancelled by the dealer' });
    };

    _this.unifyCancellation = function () {
      var _this$props$order2 = _this.props.order,
          consumerCancellationInfo = _this$props$order2.consumerCancellationInfo,
          dealerCancellationInfo = _this$props$order2.dealerCancellationInfo;


      return consumerCancellationInfo || dealerCancellationInfo;
    };

    _this.getSortedEventList = function () {
      var eventHistory = _this.props.eventHistory;

      var newerFirst = function newerFirst(eventA, eventB) {
        return eventA.creationTime > eventB.creationTime;
      };

      return eventHistory.sort(newerFirst);
    };

    _this.renderCancellationWarning = function () {
      var _this$props$order3 = _this.props.order,
          consumerCancellationInfo = _this$props$order3.consumerCancellationInfo,
          dealerCancellationInfo = _this$props$order3.dealerCancellationInfo;

      var cancellationInfo = consumerCancellationInfo || dealerCancellationInfo;
      var isCancelled = _this.isCancelledByCustomer || _this.isCancelledByDealer;

      if (isCancelled) {
        var reasonMsg = cancellationInfo && _cancellationReasons2.default[cancellationInfo.reason];
        var getCancellationMessage = function getCancellationMessage() {
          if (reasonMsg) {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'cancellation_reason_code_' + cancellationInfo.reason,
              defaultMessage: reasonMsg
            });
          }

          return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'default_cancellation_reason', defaultMessage: 'Unknown' });
        };

        return _react2.default.createElement(
          'div',
          { className: 'OrderDetailsLayout__cancellation_warning' },
          _react2.default.createElement(
            'div',
            { className: 'OrderDetailsLayout__row' },
            _react2.default.createElement(
              'div',
              { className: 'OrderDetailsLayout__cancellation_warning_icon' },
              _react2.default.createElement(_warning2.default, { className: 'OrderDetailsLayout__icon OrderDetailsLayout__icon--warning' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'OrderDetailsLayout__col OrderDetailsLayout__col--centered' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'strong',
                    null,
                    _this.renderCancelWarningText()
                  ),
                  cancellationInfo && _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      ':'
                    ),
                    '\xA0',
                    _react2.default.createElement(
                      'span',
                      { className: 'OrderDetailsLayout__cancellation_reason' },
                      getCancellationMessage()
                    )
                  )
                ),
                cancellationInfo && cancellationInfo.message && _react2.default.createElement(
                  'div',
                  { className: 'OrderDetailsLayout__cancellation_reason_msg' },
                  _react2.default.createElement(
                    'div',
                    null,
                    '"' + cancellationInfo.message + '"'
                  )
                )
              )
            )
          )
        );
      }

      return null;
    };

    _this.renderVoucherContent = function () {
      var voucher = _this.props.order.voucher;


      if (voucher && !_this.isCancelNewOrder) {
        return _react2.default.createElement(
          'div',
          { className: 'OrderDetailsLayout__row' },
          _react2.default.createElement(
            'div',
            { className: 'OrderDetailsLayout__voucher OrderDetailsLayout__col OrderDetailsLayout__col--centered' },
            _react2.default.createElement(
              _IconTextInfo2.default,
              { Icon: _cardGiftcard2.default, iconFullOpacity: true },
              _react2.default.createElement(
                'strong',
                { className: 'HistoryOrderDetails__voucher_text' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'order_details_voucher_message',
                  defaultMessage: 'Discount code used. Chama will pay you back.'
                })
              )
            )
          )
        );
      }

      return null;
    };

    _this.renderAcceptedByCustomerService = function () {
      var acceptedByCustomerService = _this.props.order.acceptedByCustomerService;


      if (acceptedByCustomerService) {
        return _react2.default.createElement(
          'div',
          { className: 'OrderDetailsLayout__row' },
          _react2.default.createElement(
            'div',
            { className: 'OrderDetailsLayout__accepted_by_cs OrderDetailsLayout__col OrderDetailsLayout__col--centered' },
            _react2.default.createElement(
              _IconTextInfo2.default,
              { Icon: _csIcon2.default, iconFullOpacity: true },
              _react2.default.createElement(
                'strong',
                { className: 'HistoryOrderDetails__accepted_by_cs_text' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'orders.cs_processed_message',
                  defaultMessage: 'This order has been processed by customer service'
                })
              )
            )
          )
        );
      }

      return null;
    };

    _this.renderMap = function () {
      var _this$props5 = _this.props,
          order = _this$props5.order,
          dealer = _this$props5.dealer;


      if (dealer) {
        var markers = [{ lat: order.lat, lng: order.lon }, { lat: dealer.lat, lng: dealer.lon, type: 'chama' }];

        return _react2.default.createElement(
          'div',
          { className: 'OrderDetailsLayout__map_btn_wrapper' },
          _react2.default.createElement(_MapThumbBtn2.default, { orderLat: order.lat, orderLon: order.lon, markers: markers })
        );
      }

      return null;
    };

    _this.renderSwitchLabel = function () {
      var isAssignedToCurrentUser = _this.props.isAssignedToCurrentUser;


      if (!isAssignedToCurrentUser) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'take_over_order', defaultMessage: 'Take control over this order' });
      }

      return _react2.default.createElement('span', null);
    };

    _this.renderFooterContent = function () {
      var _this$props6 = _this.props,
          _this$props6$order = _this$props6.order,
          queue = _this$props6$order.currentTicket.queue,
          paymentType = _this$props6$order.paymentType,
          isLoadingAssignment = _this$props6.isLoadingAssignment,
          isLoadingCommand = _this$props6.isLoadingCommand;
      var _this$props7 = _this.props,
          isAssignedToCurrentUser = _this$props7.isAssignedToCurrentUser,
          isFetchingEventHistory = _this$props7.isFetchingEventHistory,
          isOrderBeingProcessed = _this$props7.isOrderBeingProcessed;

      var onOrderEventHistoryModalClick = function onOrderEventHistoryModalClick() {
        if (isFetchingEventHistory) {
          return false;
        }

        return _this.props.fetchEventHistory().then(function () {
          return _this.eventHistoryModal.show();
        }).catch(function (e) {
          throw new Error(e);
        });
      };

      var OrderEventHistoryModalButton = function OrderEventHistoryModalButton() {
        var buttonClass = (0, _classnames2.default)('OrderDetailsLayout__event_history_btn u__normalize_button', {
          'OrderDetailsLayout__event_history_btn--loading': isFetchingEventHistory
        });

        return _react2.default.createElement(
          'button',
          { type: 'button', className: buttonClass, onClick: onOrderEventHistoryModalClick },
          _react2.default.createElement('img', { src: _eyeBlue2.default, alt: 'eye' }),
          _react2.default.createElement(
            'strong',
            { className: 'OrderDetailsLayout__event_history_btn_text' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'see_history', defaultMessage: 'See history' })
          )
        );
      };

      var renderActionButtons = function renderActionButtons() {
        if (isAssignedToCurrentUser) {
          var order = _this.props.order;

          return _react2.default.createElement(_ActionButtons2.default, {
            isLoadingCommand: isLoadingCommand,
            isLoadingAssignment: isLoadingAssignment,
            startDelivery: _this.startDelivery,
            declineOrder: _this.declineOrder,
            deliverOrder: _this.deliverOrder,
            cancelOrder: _this.cancelOrder,
            dismissCancelNewOrder: _this.dismissCancelNewOrder,
            dismissCancelDeliverOrder: _this.dismissCancelDeliverOrder,
            type: _this.ticket.type,
            status: _this.ticket.status,
            assignedToUserId: _this.ticket.assignedToUserId,
            isAssignedToCurrentUser: isAssignedToCurrentUser,
            isBeingProcessed: isOrderBeingProcessed,
            order: order
          });
        }

        return _react2.default.createElement(OrderEventHistoryModalButton, null);
      };

      if (queue !== _status.QUEUE_FINALIZED && !(paymentType === 'inAppPayment' && queue === _status.QUEUE_BEING_DELIVERED)) {
        return _react2.default.createElement(
          'div',
          { className: 'OrderDetailsLayout__action_btns_wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'OrderDetailsLayout__switch_wrapper' },
            _react2.default.createElement(_Switch2.default, {
              onToggle: _this.toggleTicketControl,
              toggled: isAssignedToCurrentUser,
              isLoading: isLoadingAssignment || isOrderBeingProcessed,
              label: _this.renderSwitchLabel()
            })
          ),
          renderActionButtons()
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'OrderDetailsLayout__event_history_btn_wrapper' },
        _react2.default.createElement(OrderEventHistoryModalButton, null)
      );
    };

    _this.track = function (eventName) {
      var _this$props8 = _this.props,
          _this$props8$order = _this$props8.order,
          orderId = _this$props8$order.id,
          orderStatus = _this$props8$order.status,
          ticketId = _this$props8$order.currentTicket.id,
          userId = _this$props8.currentUser;

      var data = { orderId: orderId, orderStatus: orderStatus, ticketId: ticketId, userId: userId };
      _appInsights2.default.trackEvent(eventName, data);
    };

    _this.confirmTakeOver = function () {
      _this.props.assignTicketToCurrentUser(_this.ticket.id);
    };

    _this.state = {
      eta: '60',
      etaWindow: '15',
      loadingNearbyDealers: false,
      isOrderDetailsOptionsOpen: false
    };
    return _this;
  }

  _createClass(OrderDetailsLayout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          windowHeight = _props.windowHeight,
          isFixed = _props.isFixed;

      this.componentHeight = this.component.offsetHeight;

      this.measureOffsetTop(isFixed);

      var offsetTop = this.getOffsetTop(isFixed);

      this.changeContentHeightIfNeeded(windowHeight, offsetTop);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var windowHeight = nextProps.windowHeight,
          isFixed = nextProps.isFixed;

      var currentOrderTicket = this.props.order.currentTicket;
      var newOrderTicket = nextProps.order.currentTicket;
      var hasQueueChanged = currentOrderTicket.queue !== newOrderTicket.queue;
      var isSameOrder = this.props.order.id === nextProps.order.id;

      if (isFixed !== this.props.isFixed) {
        this.measureOffsetTop(isFixed);

        var offsetTop = this.getOffsetTop(isFixed);

        this.changeContentHeightIfNeeded(windowHeight, offsetTop);
      }

      if (windowHeight !== this.props.windowHeight) {
        var _offsetTop = this.getOffsetTop(isFixed);
        this.changeContentHeightIfNeeded(windowHeight, _offsetTop);
      }

      if (currentOrderTicket && newOrderTicket && hasQueueChanged && isSameOrder) {
        this.close();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          order = _props2.order,
          displayDealerName = _props2.displayDealerName,
          formatMessage = _props2.intl.formatMessage,
          dealer = _props2.dealer,
          isAssignedToCurrentUser = _props2.isAssignedToCurrentUser,
          isFetchingOrderDetails = _props2.isFetchingOrderDetails,
          orderDetails = _props2.orderDetails;
      var creationTime = order.creationTime,
          delivery = order.delivery;

      var componentClass = (0, _classnames2.default)('OrderDetailsLayout', {
        'OrderDetailsLayout--incoming': this.ticket.queue === _status.QUEUE_INCOMING,
        'OrderDetailsLayout--being_delivered': this.ticket.queue === _status.QUEUE_BEING_DELIVERED,
        'OrderDetailsLayout--cancelled': this.isCancelledByCustomer || this.isCancelledByDealer,
        'OrderDetailsLayout--chama_controlled': this.ticket.queue !== _status.QUEUE_FINALIZED && isAssignedToCurrentUser
      });
      var logModalTitle = formatMessage({
        id: 'order_event_history',
        defaultMessage: 'Order event history'
      });
      var driverStatusClass = (0, _classnames2.default)('OrderDetailsLayout__driver_status', {
        'OrderDetailsLayout__driver_status--warn': delivery && delivery.status === 'pending',
        'OrderDetailsLayout__driver_status--danger': delivery && delivery.status === 'rejected',
        'OrderDetailsLayout__driver_status--ok': delivery && delivery.status === 'delivered'
      });

      if (!dealer || isFetchingOrderDetails) {
        return _react2.default.createElement(
          'div',
          { className: componentClass, ref: this.handleRef('component') },
          _react2.default.createElement(
            'div',
            { ref: this.handleRef('content'), className: 'OrderDetailsLayout__content' },
            _react2.default.createElement(
              'div',
              { className: 'OrderDetailsLayout__spinner_wrapper' },
              _react2.default.createElement(
                _Spinner2.default,
                { fill: true },
                'Carregando'
              )
            )
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { className: componentClass, ref: this.handleRef('component') },
        _react2.default.createElement(
          'div',
          { ref: this.handleRef('content'), className: 'OrderDetailsLayout__content' },
          this.renderHeader(),
          dealer && _react2.default.createElement(_MdtModals2.default, {
            handleRef: this.handleRef,
            formatMessage: formatMessage,
            nearbyDealersList: this.props.nearbyDealersList,
            dealer: this.props.dealer,
            onTakeOverConfirm: this.confirmTakeOver
          }),
          _react2.default.createElement(
            'div',
            { className: 'OrderDetailsLayout__panel OrderDetailsLayout__panel--body' },
            _react2.default.createElement(
              'div',
              { className: 'OrderDetailsLayout__row' },
              _react2.default.createElement(
                'div',
                {
                  className: 'OrderDetailsLayout__col OrderDetailsLayout__col--main_info',
                  onMouseEnter: this.onOrderDetailsMouseEnter,
                  onMouseLeave: this.onOrderDetailsMouseLeave
                },
                _react2.default.createElement(
                  _reactTransitionGroup.CSSTransitionGroup,
                  {
                    transitionName: 'OrderDetails-copy-button-transition',
                    transitionEnterTimeout: 300,
                    transitionLeaveTimeout: 200
                  },
                  this.renderOrderDetailsCopyButton()
                ),
                this.renderCancellationWarning(),
                this.renderDealerInfo(),
                this.renderCustomerInfo(),
                this.renderAdditionalInfo()
              ),
              _react2.default.createElement(
                'div',
                { className: 'OrderDetailsLayout__col OrderDetailsLayout__col--map' },
                !displayDealerName && _react2.default.createElement(
                  'div',
                  null,
                  this.renderCloseDetailsBtn()
                ),
                this.renderMap()
              )
            ),
            this.renderVoucherContent(),
            this.renderAcceptedByCustomerService(),
            this.renderConsumerDeliveredStatus(),
            _react2.default.createElement(
              'div',
              { className: 'OrderDetailsLayout__table_wrapper' },
              _react2.default.createElement(_OrderPriceOverview2.default, { order: order, orderDetails: orderDetails })
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'OrderDetailsLayout__row OrderDetailsLayout__row--time_action_wrapper' },
                _react2.default.createElement(
                  'div',
                  { className: 'OrderDetailsLayout__col' },
                  _react2.default.createElement(
                    'div',
                    { className: 'OrderDetailsLayout__time_info_wrapper' },
                    _react2.default.createElement(
                      'div',
                      { className: 'OrderDetailsLayout__col' },
                      _react2.default.createElement(
                        'div',
                        { className: 'OrderDetailsLayout__text_line' },
                        _react2.default.createElement(
                          _TimeTextLine2.default,
                          { time: creationTime },
                          _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'delivery_timeoforder',
                            defaultMessage: 'Time of ordering'
                          })
                        )
                      )
                    ),
                    delivery && _react2.default.createElement(
                      _react2.default.Fragment,
                      null,
                      _react2.default.createElement(
                        'div',
                        { className: 'OrderDetailsLayout__col' },
                        _react2.default.createElement(
                          'div',
                          null,
                          _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                              'strong',
                              null,
                              _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'order_details.driver',
                                defaultMessage: 'Driver:'
                              })
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            null,
                            delivery.driver && delivery.driver.name
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'OrderDetailsLayout__col' },
                        _react2.default.createElement(
                          'div',
                          null,
                          _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                              'strong',
                              null,
                              'Status:'
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: driverStatusClass },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                              id: 'delivery_status.' + delivery.status,
                              defaultMessage: _deliveryStatus2.default[delivery.status]
                            })
                          )
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'OrderDetailsLayout__col' },
                      this.renderActionTimeContent()
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'OrderDetailsLayout__panel OrderDetailsLayout__panel--footer' },
            this.renderFooterContent()
          )
        ),
        _react2.default.createElement(
          _Modal2.default,
          {
            title: logModalTitle,
            ref: this.handleRef('eventHistoryModal'),
            confirmButtonText: 'OK',
            hideOnConfirm: true
          },
          _react2.default.createElement(_EventHistory2.default, { eventList: this.getSortedEventList() })
        )
      );
    }
  }, {
    key: 'ticket',
    get: function get() {
      var order = this.props.order;


      return order && order.currentTicket;
    }
  }, {
    key: 'isCancelledByCustomer',
    get: function get() {
      var type = this.ticket.type;


      return type === _status.TYPE_CANCEL_NEW_ORDER || type === _status.TYPE_CANCEL_DELIVER_ORDER;
    }
  }, {
    key: 'isCancelledByDealer',
    get: function get() {
      var status = this.props.order.status;


      return status === _status.ORDER_STATUS_DEALER_CANCELLED || status === _status.ORDER_STATUS_DEALER_DECLINED;
    }
  }, {
    key: 'isCancelNewOrder',
    get: function get() {
      return this.ticket.type === _status.TYPE_CANCEL_NEW_ORDER;
    }
  }, {
    key: 'isDeliverOrder',
    get: function get() {
      return this.ticket.type === _status.TYPE_DELIVER_ORDER;
    }
  }, {
    key: 'isNewOrder',
    get: function get() {
      return this.ticket.type === _status.TYPE_NEW_ORDER;
    }
  }]);

  return OrderDetailsLayout;
}(_react.Component);

OrderDetailsLayout.propTypes = propTypes;
OrderDetailsLayout.defaultProps = defaultProps;

var withIntlComponent = (0, _reactIntl.injectIntl)((0, _windowWatcher2.default)(OrderDetailsLayout));

exports.default = (0, _reactRouter.withRouter)(withIntlComponent);

/***/ }),

/***/ 3422:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var mui = __webpack_require__(65);
var SvgIcon = mui.SvgIcon;

var createClass = __webpack_require__(73);

var ActionStore = createClass({
  displayName: 'ActionStore',

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z' })
    );
  }

});

module.exports = ActionStore;

/***/ }),

/***/ 3423:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(77);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(72);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default; // https://github.com/mui-org/material-ui/blob/v1-beta/packages/material-ui-icons/tpl/SvgIcon.js


var CSIcon = function CSIcon(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _react2.default.createElement('path', { d: 'M0 9v7c0 1.66 1.34 3 3 3h3v-8H2V9c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1H9v2h6c1.66 0 3-1.34 3-3V9A9 9 0 0 0 0 9z' })
  );
};

CSIcon = (0, _pure2.default)(CSIcon);
CSIcon.muiName = 'SvgIcon';

exports.default = CSIcon;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),

/***/ 3424:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  pending: 'Pending',
  accepted: 'Accepted',
  onGoing: 'Ongoing',
  rejected: 'Rejected',
  delivered: 'Delivered'
};

/***/ }),

/***/ 3425:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEBIT = exports.DEBIT = 'debit';
var CREDIT = exports.CREDIT = 'credit';
var CASH = exports.CASH = 'cash';
var IN_APP_PAYMENT = exports.IN_APP_PAYMENT = 'inAppPayment';

/***/ }),

/***/ 3426:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDI2IDE2Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjMTQ4RjlGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij4KICAgICAgICA8cGF0aCBkPSJNMjQuNSA4cy01LjE0OCA2LjUtMTEuNSA2LjVTMS41IDggMS41IDggNi42NDggMS41IDEzIDEuNSAyNC41IDggMjQuNSA4eiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xNyA4YTQgNCAwIDEgMS04IDAgNCA0IDAgMCAxIDggMHoiLz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ 3427:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Modal = __webpack_require__(178);

var _Modal2 = _interopRequireDefault(_Modal);

var _DealersNearbyList = __webpack_require__(3428);

var _DealersNearbyList2 = _interopRequireDefault(_DealersNearbyList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  nearbyDealersList: _propTypes2.default.array.isRequired,
  formatMessage: _propTypes2.default.func.isRequired,
  onTakeOverConfirm: _propTypes2.default.func.isRequired,
  handleRef: _propTypes2.default.func.isRequired,
  dealer: _propTypes2.default.object.isRequired
};

var MdtModals = function MdtModals(props) {
  var handleRef = props.handleRef,
      formatMessage = props.formatMessage,
      dealer = props.dealer,
      nearbyDealersList = props.nearbyDealersList,
      onTakeOverConfirm = props.onTakeOverConfirm;


  return _react2.default.createElement(
    'span',
    null,
    _react2.default.createElement(
      _Modal2.default,
      {
        ref: handleRef('reallocationModal'),
        size: 'large',
        title: formatMessage({
          id: 'dealers_nearby_order_address',
          defaultMessage: 'Dealer nearby order address'
        }),
        confirmButtonText: formatMessage({
          id: 'closeLabel',
          defaultMessage: 'Close'
        })
      },
      _react2.default.createElement(_DealersNearbyList2.default, { currentDealer: dealer, dealerList: nearbyDealersList })
    ),
    _react2.default.createElement(
      _Modal2.default,
      {
        ref: handleRef('takeControlModal'),
        title: formatMessage({
          id: 'you_are_about_to_control_this_order',
          defaultMessage: 'You are about to control this order'
        }),
        cancelButtonText: formatMessage({
          id: 'general.cancel',
          defaultMessage: 'Cancel'
        }),
        confirmButtonText: formatMessage({
          id: 'proceed',
          defaultMessage: 'Proceed'
        }),
        onConfirm: onTakeOverConfirm
      },
      _react2.default.createElement(
        _react2.default.Fragment,
        null,
        formatMessage({
          id: 'take_control_modal_body_text1',
          defaultMessage: 'By taking over this order, only Chama will be able to take actions on this order until un-assigned again'
        })
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        _react2.default.Fragment,
        null,
        formatMessage({
          id: 'take_control_modal_body_text2',
          defaultMessage: "All actions taken upon this will reflect int the dealer's Dealer Tool, Chama system and the app."
        })
      )
    )
  );
};

MdtModals.propTypes = propTypes;

exports.default = MdtModals;

/***/ }),

/***/ 3428:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _lodash = __webpack_require__(140);

var _lodash2 = _interopRequireDefault(_lodash);

var _DropDownMenu = __webpack_require__(541);

var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);

var _MenuItem = __webpack_require__(306);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _dealerStatus = __webpack_require__(580);

var _dealerStatus2 = _interopRequireDefault(_dealerStatus);

var _getEtaLabel = __webpack_require__(1084);

var _getEtaLabel2 = _interopRequireDefault(_getEtaLabel);

var _NearbyDealerRow = __webpack_require__(3429);

var _NearbyDealerRow2 = _interopRequireDefault(_NearbyDealerRow);

var _NearbyDealerTable = __webpack_require__(3431);

var _NearbyDealerTable2 = _interopRequireDefault(_NearbyDealerTable);

__webpack_require__(3432);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  dealerList: _propTypes2.default.array.isRequired,
  currentDealer: _propTypes2.default.object.isRequired
};

var getFormattedDealer = function getFormattedDealer(dealer) {
  var product = dealer.products[0];

  return _extends({}, dealer, {
    price: product.price,
    brand: product.brand,
    eta: dealer.deliveryDuration && (0, _getEtaLabel2.default)(dealer.deliveryDuration),
    status: (0, _dealerStatus2.default)(dealer)
  });
};

var renderDealerList = function renderDealerList(dealerList) {
  var mapDealers = function mapDealers(dealer) {
    return _react2.default.createElement(_NearbyDealerRow2.default, { key: dealer.id, dealer: getFormattedDealer(dealer) });
  };

  if (dealerList.length) {
    return _react2.default.createElement(
      _NearbyDealerTable2.default,
      null,
      dealerList.map(mapDealers)
    );
  }

  return _react2.default.createElement(
    'div',
    { className: 'DealersNearbyList__no_dealers_msg' },
    _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'there_is_no_other_dealers_nearby',
      defaultMessage: 'There is no other dealers nearby'
    })
  );
};

var filterOutCurrentDealer = function filterOutCurrentDealer(currentDealerId) {
  return function (dealer) {
    return dealer.id !== currentDealerId;
  };
};

var DealersNearbyList = function (_Component) {
  _inherits(DealersNearbyList, _Component);

  function DealersNearbyList(props) {
    _classCallCheck(this, DealersNearbyList);

    var formatMessage = props.intl.formatMessage;

    var _this = _possibleConstructorReturn(this, (DealersNearbyList.__proto__ || Object.getPrototypeOf(DealersNearbyList)).call(this, props));

    _this.onFilterChange = function (event, index, value) {
      return _this.setState({ activeFilter: value });
    };

    _this.renderFilterDropdownItems = function () {
      var filtersIntoMenuItems = function filtersIntoMenuItems(filter) {
        return _react2.default.createElement(_MenuItem2.default, {
          key: filter.id,
          value: filter.id,
          label: filter.label,
          primaryText: filter.primaryText
        });
      };

      return (0, _lodash2.default)(_this.filters).map(filtersIntoMenuItems);
    };

    _this.state = {
      activeFilter: 'NEARBY_FILTER_CHEAPEST'
    };

    _this.filters = {
      NEARBY_FILTER_CHEAPEST: {
        id: 'NEARBY_FILTER_CHEAPEST',
        label: formatMessage({
          id: 'price',
          defaultMessage: 'Price'
        }),
        primaryText: formatMessage({
          id: 'cheapest',
          defaultMessage: 'Cheapest'
        }),
        sortFn: function sortFn(a, b) {
          var priceA = a.products[0].price;
          var priceB = b.products[0].price;

          return a.isOpened > b.isOpened ? -1 : a.isOpened < b.isOpened ? 1 : priceA < priceB ? -1 : priceA > priceB ? 1 : 0;
        }
      },

      NEARBY_FILTER_FASTEST: {
        id: 'NEARBY_FILTER_FASTEST',
        label: formatMessage({
          id: 'nearby.filters.delivery_time',
          defaultMessage: 'ETA'
        }),
        primaryText: formatMessage({
          id: 'fastest',
          defaultMessage: 'Fastest'
        }),
        sortFn: function sortFn(a, b) {
          var durationA = parseInt(a.deliveryDuration, 10);
          var durationB = parseInt(b.deliveryDuration, 10);

          return a.isOpened > b.isOpened ? -1 : a.isOpened < b.isOpened ? 1 : durationA < durationB ? -1 : durationA > durationB ? 1 : 0;
        }
      },

      NEARBY_FILTER_BEST_RATED: {
        id: 'NEARBY_FILTER_BEST_RATED',
        label: 'Rating',
        primaryText: formatMessage({
          id: 'best_rated',
          defaultMessage: 'Best rated'
        }),
        sortFn: function sortFn(a, b) {
          return a.isOpened > b.isOpened ? -1 : a.isOpened < b.isOpened ? 1 : b.rating < a.rating ? -1 : b.rating > a.rating ? 1 : 0;
        }
      }
    };
    return _this;
  }

  _createClass(DealersNearbyList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          dealerList = _props.dealerList,
          currentDealer = _props.currentDealer;
      var activeFilter = this.state.activeFilter;

      var modifiedList = dealerList.filter(filterOutCurrentDealer(currentDealer.id)).sort(this.filters[activeFilter].sortFn);

      return _react2.default.createElement(
        'div',
        { className: 'DealersNearbyList' },
        _react2.default.createElement(
          'div',
          { className: 'DealersNearbyList__current_dealer_wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'DealersNearbyList__title' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'order_dealer', defaultMessage: 'Order dealer' })
          ),
          _react2.default.createElement(
            _NearbyDealerTable2.default,
            null,
            _react2.default.createElement(_NearbyDealerRow2.default, { key: currentDealer.id, dealer: getFormattedDealer(currentDealer) })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'DealersNearbyList__list_wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'DealersNearbyList__title DealersNearbyList__title--with_dropdown' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dealers_nearby', defaultMessage: 'Dealers nearby' }),
            _react2.default.createElement(
              'div',
              { className: 'DealersNearbyList__filter_dropdown_wrapper' },
              _react2.default.createElement(
                _DropDownMenu2.default,
                { value: activeFilter, onChange: this.onFilterChange },
                this.renderFilterDropdownItems()
              )
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            renderDealerList(modifiedList)
          )
        )
      );
    }
  }]);

  return DealersNearbyList;
}(_react.Component);

DealersNearbyList.propTypes = propTypes;

exports.default = (0, _reactIntl.injectIntl)(DealersNearbyList);

/***/ }),

/***/ 3429:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(3);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = __webpack_require__(16);

var _currency = __webpack_require__(153);

var _formatPhone = __webpack_require__(590);

var _formatPhone2 = _interopRequireDefault(_formatPhone);

var _Table = __webpack_require__(265);

var _Table2 = _interopRequireDefault(_Table);

var _ShopOpeningTimesStatusLabel = __webpack_require__(3430);

var _ShopOpeningTimesStatusLabel2 = _interopRequireDefault(_ShopOpeningTimesStatusLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  dealer: _propTypes2.default.object.isRequired
};

var formatPhone = _formatPhone2.default['pt-BR'];

var renderETA = function renderETA(eta) {
  if (eta && eta.from && eta.to) {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'span',
        null,
        eta.from,
        'm'
      ),
      ' - ',
      _react2.default.createElement(
        'span',
        null,
        eta.to,
        'm'
      )
    );
  }

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'span',
      null,
      'N/A'
    )
  );
};

var renderOpeningTimes = function renderOpeningTimes(dealer) {
  var isOpened = dealer.isOpened,
      willCloseAt = dealer.willCloseAt,
      willOpenAt = dealer.willOpenAt;

  var date = isOpened ? willCloseAt : willOpenAt;
  var now = (0, _moment2.default)();
  var target = (0, _moment2.default)(date);
  var diff = Math.abs(target.dayOfYear() - now.dayOfYear());
  var isToday = diff === 0;
  var isTomorrow = diff === 1;
  var renderOpeningText = function renderOpeningText() {
    if (isOpened) {
      return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'closes', defaultMessage: 'Closes' });
    }

    return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'opens', defaultMessage: 'Opens' });
  };
  var renderText = function renderText(when) {
    return _react2.default.createElement(
      'span',
      null,
      _react2.default.createElement(
        'span',
        { className: 'u__capitalize' },
        renderOpeningText()
      ),
      '\xA0',
      when,
      '\xA0',
      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time_at', defaultMessage: 'time_at' }),
      '\xA0',
      target.format('HH:mm')
    );
  };

  if (isToday) {
    return renderText(_react2.default.createElement(_reactIntl.FormattedMessage, { id: 'today', defaultMessage: 'today' }));
  }

  if (isTomorrow) {
    return renderText(_react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tomorrow', defaultMessage: 'tomorrow' }));
  }

  return renderText(target.format('DD/MM'));
};

var getPhone = function getPhone(dealer) {
  if (dealer.phone) {
    return formatPhone(dealer.phone.replace('+55', ''), false);
  }

  return 'N/A';
};

var NearbyDealerItem = function NearbyDealerItem(_ref) {
  var dealer = _ref.dealer;

  var ellipseClassName = (0, _classnames2.default)('DealersNearbyList__ellipse', {
    'DealersNearbyList__ellipse--open': dealer.isActive
  });

  return _react2.default.createElement(
    _Table2.default.Row,
    null,
    _react2.default.createElement(
      _Table2.default.Cell,
      null,
      _react2.default.createElement(
        'span',
        null,
        dealer.name
      )
    ),
    _react2.default.createElement(
      _Table2.default.Cell,
      null,
      _react2.default.createElement(
        'span',
        null,
        dealer.brand
      )
    ),
    _react2.default.createElement(
      _Table2.default.Cell,
      null,
      _react2.default.createElement(
        'span',
        null,
        getPhone(dealer)
      )
    ),
    _react2.default.createElement(
      _Table2.default.Cell,
      null,
      _react2.default.createElement(
        'span',
        null,
        dealer.rating
      )
    ),
    _react2.default.createElement(
      _Table2.default.Cell,
      null,
      _react2.default.createElement(
        'span',
        null,
        (0, _currency.formatPrice)(dealer.price)
      )
    ),
    _react2.default.createElement(
      _Table2.default.Cell,
      null,
      renderETA(dealer.eta)
    ),
    _react2.default.createElement(
      _Table2.default.Cell,
      null,
      renderOpeningTimes(dealer)
    ),
    _react2.default.createElement(
      _Table2.default.Cell,
      null,
      _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_ShopOpeningTimesStatusLabel2.default, { status: dealer.status }),
        _react2.default.createElement('span', { className: ellipseClassName })
      )
    )
  );
};

NearbyDealerItem.propTypes = propTypes;

exports.default = NearbyDealerItem;

/***/ }),

/***/ 3430:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _status = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  status: _propTypes2.default.string.isRequired
};

var ShopOpeningTimesStatusLabel = function ShopOpeningTimesStatusLabel(_ref) {
  var status = _ref.status;

  if (status === _status.SHOP_STATUS_CLOSED_ADHOC_ONLINE) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'shop_status.adhoc_closed_online',
      defaultMessage: 'Closed (adHoc) & Online'
    });
  }

  if (status === _status.SHOP_STATUS_CLOSED_ADHOC_OFFLINE) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'shop_status.adhoc_closed_offline',
      defaultMessage: 'Closed (adHoc) & Offline'
    });
  }

  if (status === _status.SHOP_STATUS_OPEN_ONLINE) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shop_status.open_online', defaultMessage: 'Open & Online' });
  }

  if (status === _status.SHOP_STATUS_OPEN_OFFLINE) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shop_status.open_offline', defaultMessage: 'Open & Offline' });
  }

  if (status === _status.SHOP_STATUS_CLOSED_OFFLINE) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shop_status.closed_offline', defaultMessage: 'Closed & Offline' });
  }

  if (status === _status.SHOP_STATUS_CLOSED_ONLINE) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shop_status.closed_online', defaultMessage: 'Closed & Online' });
  }

  return _react2.default.createElement(
    'span',
    null,
    'N/A'
  );
};

ShopOpeningTimesStatusLabel.propTypes = propTypes;

exports.default = ShopOpeningTimesStatusLabel;

/***/ }),

/***/ 3431:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _Table = __webpack_require__(265);

var _Table2 = _interopRequireDefault(_Table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.element]).isRequired
};

var NearbyDealerTable = function NearbyDealerTable(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    _Table2.default,
    null,
    _react2.default.createElement(
      _Table2.default.Header,
      null,
      _react2.default.createElement(
        _Table2.default.Row,
        null,
        _react2.default.createElement(
          _Table2.default.Cell,
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'name.uppercase', defaultMessage: 'NAME' })
        ),
        _react2.default.createElement(
          _Table2.default.Cell,
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'brand.uppercase', defaultMessage: 'BRAND' })
        ),
        _react2.default.createElement(
          _Table2.default.Cell,
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'phone.uppercase', defaultMessage: 'PHONE' })
        ),
        _react2.default.createElement(
          _Table2.default.Cell,
          null,
          _react2.default.createElement(
            'span',
            null,
            'RATING'
          )
        ),
        _react2.default.createElement(
          _Table2.default.Cell,
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'price.uppercase', defaultMessage: 'PRICE' })
        ),
        _react2.default.createElement(
          _Table2.default.Cell,
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'eta.uppercase', defaultMessage: 'ETA' })
        ),
        _react2.default.createElement(
          _Table2.default.Cell,
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'office_hours.uppercase', defaultMessage: 'OFFICE HOURS' })
        ),
        _react2.default.createElement(
          _Table2.default.Cell,
          null,
          _react2.default.createElement(
            'span',
            null,
            'STATUS'
          )
        )
      )
    ),
    _react2.default.createElement(
      _Table2.default.Body,
      null,
      children
    )
  );
};

NearbyDealerTable.propTypes = propTypes;

exports.default = NearbyDealerTable;

/***/ }),

/***/ 3432:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3433:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getWeekDayName = __webpack_require__(1219);

var _getWeekDayName2 = _interopRequireDefault(_getWeekDayName);

var _getMonthName = __webpack_require__(1085);

var _getMonthName2 = _interopRequireDefault(_getMonthName);

var _moment = __webpack_require__(3);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(579);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(140);

var _lodash4 = _interopRequireDefault(_lodash3);

var _lodash5 = __webpack_require__(141);

var _lodash6 = _interopRequireDefault(_lodash5);

var _calendarOutlined = __webpack_require__(3434);

var _calendarOutlined2 = _interopRequireDefault(_calendarOutlined);

var _isCsUser = __webpack_require__(588);

var _isCsUser2 = _interopRequireDefault(_isCsUser);

var _getOrderStatusIcon = __webpack_require__(3435);

var _getOrderStatusIcon2 = _interopRequireDefault(_getOrderStatusIcon);

var _getOrderStatusLabel = __webpack_require__(3442);

var _getOrderStatusLabel2 = _interopRequireDefault(_getOrderStatusLabel);

__webpack_require__(3443);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  eventList: _propTypes2.default.array.isRequired
};

var EventHistory = function (_Component) {
  _inherits(EventHistory, _Component);

  function EventHistory() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EventHistory);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EventHistory.__proto__ || Object.getPrototypeOf(EventHistory)).call.apply(_ref, [this].concat(args))), _this), _this.renderEventListItems = function (list) {
      var eventsIntoListItems = function eventsIntoListItems(_ref2) {
        var orderStatus = _ref2.orderStatus,
            creationTime = _ref2.creationTime,
            actingUserId = _ref2.actingUserId;

        var isCs = (0, _isCsUser2.default)(actingUserId);
        var momentEventDate = (0, _moment2.default)(creationTime);
        var key = '' + orderStatus + creationTime;

        return _react2.default.createElement(
          'li',
          { key: key, className: 'EventHistory__event' },
          _react2.default.createElement(
            'div',
            { className: 'EventHistory__event_icon_time' },
            _react2.default.createElement('img', {
              className: 'EventHistory__event_icon',
              src: (0, _getOrderStatusIcon2.default)(orderStatus, isCs),
              alt: 'event icon'
            }),
            _react2.default.createElement(
              'span',
              { className: 'EventHistory__event_time' },
              _react2.default.createElement(
                'span',
                null,
                momentEventDate.format('HH:mm'),
                ' '
              ),
              _react2.default.createElement(
                'span',
                { className: 'EventHistory__event_time_merediem' },
                momentEventDate.hours() > 12 ? 'pm' : 'am'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'EventHistory__event_info' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'strong',
                null,
                (0, _getOrderStatusLabel2.default)(orderStatus, isCs)
              )
            ),
            actingUserId && _react2.default.createElement(
              'div',
              { className: 'EventHistory__event_actor' },
              actingUserId
            )
          )
        );
      };

      return list.map(eventsIntoListItems);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EventHistory, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var eventList = this.props.eventList;

      var periods = (0, _lodash2.default)(eventList, function (event) {
        return event.creationTime.split('T')[0];
      });
      var periodsTime = (0, _lodash6.default)(periods);
      var periodsIntoEventLists = function periodsIntoEventLists(periodEventList, i) {
        var momentPeriodDate = (0, _moment2.default)(periodsTime[i]);
        var weekdayName = (0, _getWeekDayName2.default)(periodsTime[i]);
        var monthName = (0, _getMonthName2.default)(periodsTime[i]);

        return _react2.default.createElement(
          'div',
          { key: periodsTime[i], className: 'EventHistory__period' },
          _react2.default.createElement(
            'div',
            { className: 'EventHistory__period_title' },
            _react2.default.createElement('img', { src: _calendarOutlined2.default, alt: 'calendar' }),
            _react2.default.createElement(
              'span',
              { className: 'EventHistory__period_title_text' },
              _react2.default.createElement(
                'span',
                { className: 'u__capitalize' },
                weekdayName,
                ', '
              ),
              _react2.default.createElement(
                'span',
                null,
                momentPeriodDate.format('D'),
                ' de '
              ),
              _react2.default.createElement(
                'span',
                { className: 'u__capitalize' },
                monthName,
                ' '
              ),
              _react2.default.createElement(
                'span',
                null,
                momentPeriodDate.format('YYYY')
              )
            )
          ),
          _react2.default.createElement(
            'ul',
            { className: 'EventHistory__event_list u__normalize_list' },
            _this2.renderEventListItems(periodEventList)
          )
        );
      };

      return _react2.default.createElement(
        'div',
        { className: 'EventHistory' },
        (0, _lodash4.default)(periods).map(periodsIntoEventLists)
      );
    }
  }]);

  return EventHistory;
}(_react.Component);

EventHistory.propTypes = propTypes;

exports.default = EventHistory;

/***/ }),

/***/ 3434:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAyMCAxOSI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTAgMThoMThWMEgweiIvPgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxKSI+CiAgICAgICAgICAgIDxwYXRoIHN0cm9rZT0iIzRBNEE0QSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBkPSJNMy4zNzUgMS44NzVoLTN2MTUuNzVoMTcuMjVWMS44NzVoLTMiLz4KICAgICAgICAgICAgPG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjYSIvPgogICAgICAgICAgICA8L21hc2s+CiAgICAgICAgICAgIDxwYXRoIHN0cm9rZT0iIzRBNEE0QSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBkPSJNMy4zNzUgMy4zNzVoMi4yNXYtM2gtMi4yNXpNMTIuMzc1IDMuMzc1aDIuMjV2LTNoLTIuMjV6IiBtYXNrPSJ1cmwoI2IpIi8+CiAgICAgICAgPC9nPgogICAgICAgIDxwYXRoIHN0cm9rZT0iIzRBNEE0QSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBkPSJNNi42MjUgMS44NzVoNi43NU0xLjM3NSA1LjYyNWgxNy4yNU01Ljg3NSA3LjEyNXY5TTkuNjI1IDcuMTI1djlNMTMuMzc1IDcuMTI1djlNMi44NzUgOC42MjVoMTQuMjVNMi44NzUgMTEuNjI1aDE0LjI1TTIuODc1IDE0LjYyNWgxNC4yNSIvPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ 3435:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _status = __webpack_require__(53);

var _orderStatusIconOrdered = __webpack_require__(3436);

var _orderStatusIconOrdered2 = _interopRequireDefault(_orderStatusIconOrdered);

var _orderStatusIconDealerProcessing = __webpack_require__(3437);

var _orderStatusIconDealerProcessing2 = _interopRequireDefault(_orderStatusIconDealerProcessing);

var _orderStatusIconDealerAccepted = __webpack_require__(3438);

var _orderStatusIconDealerAccepted2 = _interopRequireDefault(_orderStatusIconDealerAccepted);

var _orderStatusIconDealerDelivered = __webpack_require__(3439);

var _orderStatusIconDealerDelivered2 = _interopRequireDefault(_orderStatusIconDealerDelivered);

var _orderStatusIconConsumerCanceled = __webpack_require__(3440);

var _orderStatusIconConsumerCanceled2 = _interopRequireDefault(_orderStatusIconConsumerCanceled);

var _orderStatusIconCsCancelled = __webpack_require__(3441);

var _orderStatusIconCsCancelled2 = _interopRequireDefault(_orderStatusIconCsCancelled);

var _dealerCancelledIcon = __webpack_require__(1061);

var _dealerCancelledIcon2 = _interopRequireDefault(_dealerCancelledIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOrderStatusIcon = function getOrderStatusIcon(status, isCsUser) {
  if (status === _status.ORDER_STATUS_ORDERED) {
    return _orderStatusIconOrdered2.default;
  }

  if (status === _status.ORDER_STATUS_DEALER_PROCESSING) {
    return _orderStatusIconDealerProcessing2.default;
  }

  if (status === _status.ORDER_STATUS_DEALER_ACCEPTED) {
    return _orderStatusIconDealerAccepted2.default;
  }

  if (status === _status.ORDER_STATUS_DEALER_CANCELLED || status === _status.ORDER_STATUS_DEALER_DECLINED) {
    if (isCsUser) {
      return _orderStatusIconCsCancelled2.default;
    }

    return _dealerCancelledIcon2.default;
  }

  if (status === _status.ORDER_STATUS_DEALER_DELIVERED) {
    return _orderStatusIconDealerDelivered2.default;
  }

  if (status === _status.ORDER_STATUS_CONSUMER_CANCELLED) {
    return _orderStatusIconConsumerCanceled2.default;
  }

  return '';
};

exports.default = getOrderStatusIcon;

/***/ }),

/***/ 3436:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 3437:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 3438:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 3439:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCI+CiAgICA8ZGVmcz4KICAgICAgICA8Y2lyY2xlIGlkPSJiIiBjeD0iMTUiIGN5PSIxNSIgcj0iMTUiLz4KICAgICAgICA8ZmlsdGVyIGlkPSJhIiB3aWR0aD0iMTUzLjMlIiBoZWlnaHQ9IjE1My4zJSIgeD0iLTI2LjclIiB5PSItMjAlIiBmaWx0ZXJVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giPgogICAgICAgICAgICA8ZmVNb3JwaG9sb2d5IGluPSJTb3VyY2VBbHBoYSIgb3BlcmF0b3I9ImRpbGF0ZSIgcmFkaXVzPSIxIiByZXN1bHQ9InNoYWRvd1NwcmVhZE91dGVyMSIvPgogICAgICAgICAgICA8ZmVPZmZzZXQgZHk9IjIiIGluPSJzaGFkb3dTcHJlYWRPdXRlcjEiIHJlc3VsdD0ic2hhZG93T2Zmc2V0T3V0ZXIxIi8+CiAgICAgICAgICAgIDxmZUdhdXNzaWFuQmx1ciBpbj0ic2hhZG93T2Zmc2V0T3V0ZXIxIiByZXN1bHQ9InNoYWRvd0JsdXJPdXRlcjEiIHN0ZERldmlhdGlvbj0iMiIvPgogICAgICAgICAgICA8ZmVDb21wb3NpdGUgaW49InNoYWRvd0JsdXJPdXRlcjEiIGluMj0iU291cmNlQWxwaGEiIG9wZXJhdG9yPSJvdXQiIHJlc3VsdD0ic2hhZG93Qmx1ck91dGVyMSIvPgogICAgICAgICAgICA8ZmVDb2xvck1hdHJpeCBpbj0ic2hhZG93Qmx1ck91dGVyMSIgdmFsdWVzPSIwIDAgMCAwIDAuMjkwMTk2MDc4IDAgMCAwIDAgMC4yOTAxOTYwNzggMCAwIDAgMCAwLjI5MDE5NjA3OCAwIDAgMCAwLjI1IDAiLz4KICAgICAgICA8L2ZpbHRlcj4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNSAzKSI+CiAgICAgICAgICAgIDx1c2UgZmlsbD0iIzAwMCIgZmlsdGVyPSJ1cmwoI2EpIiB4bGluazpocmVmPSIjYiIvPgogICAgICAgICAgICA8dXNlIGZpbGw9IiNGRkYiIHN0cm9rZT0iIzIyQzE1QSIgc3Ryb2tlLXdpZHRoPSIyIiB4bGluazpocmVmPSIjYiIvPgogICAgICAgIDwvZz4KICAgICAgICA8cGF0aCBzdHJva2U9IiMyMkMxNUEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIiBkPSJNMjYuMjUgMTQuMjVMMTYuODc1IDIzbC0zLjEyNS0zLjEyNSIvPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ 3440:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 3441:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 3442:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _statusMap;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(16);

var _status = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var statusMap = (_statusMap = {}, _defineProperty(_statusMap, _status.ORDER_STATUS_ORDERED, 'Ordered'), _defineProperty(_statusMap, _status.ORDER_STATUS_DEALER_PROCESSING, 'Dealer processing'), _defineProperty(_statusMap, _status.ORDER_STATUS_DEALER_ACCEPTED, 'Dealer accepted'), _defineProperty(_statusMap, _status.ORDER_STATUS_DEALER_CANCELLED, 'Dealer cancelled'), _defineProperty(_statusMap, _status.ORDER_STATUS_DEALER_DECLINED, 'Dealer declined'), _defineProperty(_statusMap, _status.ORDER_STATUS_DEALER_DELIVERED, 'Dealer delivered'), _defineProperty(_statusMap, _status.ORDER_STATUS_CONSUMER_CANCELLED, 'Consumer Cancelled'), _statusMap);

var getOrderStatusLabel = function getOrderStatusLabel(orderStatus, isCSUser) {
  var getFormattedMessageId = function getFormattedMessageId() {
    var base = 'order_event_history';

    if (isCSUser) {
      return base + '.' + orderStatus + '.cs';
    }

    return base + '.' + orderStatus;
  };

  return _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: getFormattedMessageId(),
    defaultMessage: statusMap[orderStatus] || orderStatus
  });
};

exports.default = getOrderStatusLabel;

/***/ }),

/***/ 3443:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3444:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3445:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

var _arrowBack = __webpack_require__(3446);

var _arrowBack2 = _interopRequireDefault(_arrowBack);

var _scrollWatcher = __webpack_require__(1077);

var _scrollWatcher2 = _interopRequireDefault(_scrollWatcher);

var _Header = __webpack_require__(1050);

__webpack_require__(3447);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  children: _propTypes2.default.element,
  scrollTop: _propTypes2.default.number.isRequired
};

var defaultProps = {
  children: null
};

var RightPanel = function (_PureComponent) {
  _inherits(RightPanel, _PureComponent);

  function RightPanel(props) {
    _classCallCheck(this, RightPanel);

    var _this = _possibleConstructorReturn(this, (RightPanel.__proto__ || Object.getPrototypeOf(RightPanel)).call(this, props));

    _this.handleRef = function (refName) {
      return function (ref) {
        _this[refName] = ref;
      };
    };

    _this.renderContent = function () {
      var children = _this.props.children;
      var isFixed = _this.state.isFixed;


      if (children) {
        return _react2.default.cloneElement(children, { isFixed: isFixed });
      }

      return _react2.default.createElement(
        'div',
        { className: 'OrderDetailsLayout__no_order_panel' },
        _react2.default.createElement(_arrowBack2.default, null),
        _react2.default.createElement(
          'div',
          { className: 'OrderDetailsLayout__no_order_text' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'orderdetails_none_selected',
            defaultMessage: 'Please select an order on the left'
          })
        )
      );
    };

    _this.state = {
      useAbsolutePositionSystem: !(CSS.supports && CSS.supports('position: sticky')),
      isFixed: false
    };
    return _this;
  }

  _createClass(RightPanel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var headerHeight = document.getElementById(_Header.HEADER_ID).offsetHeight;

      var _fixedWrapper$getBoun = this.fixedWrapper.getBoundingClientRect(),
          top = _fixedWrapper$getBoun.top;

      var wrapperOffset = top + this.props.scrollTop - headerHeight;
      var margin = 15;

      this.scrollLimit = headerHeight + wrapperOffset - margin;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var scrollTop = nextProps.scrollTop;
      var _state = this.state,
          isFixed = _state.isFixed,
          useAbsolutePositionSystem = _state.useAbsolutePositionSystem;


      if (scrollTop >= this.scrollLimit && scrollTop !== this.props.scrollTop) {
        if (!isFixed) {
          this.setState({ isFixed: true });
        }

        if (useAbsolutePositionSystem) {
          this.fixedWrapper.style.top = scrollTop - this.scrollLimit + 'px';
        }
      } else if (scrollTop < this.scrollLimit && scrollTop !== this.props.scrollTop) {
        if (isFixed) {
          this.setState({ isFixed: false });
        }

        if (useAbsolutePositionSystem) {
          this.fixedWrapper.style.top = '0px';
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state2 = this.state,
          isFixed = _state2.isFixed,
          useAbsolutePositionSystem = _state2.useAbsolutePositionSystem;

      var wrapperClass = (0, _classnames2.default)('RightPanel__wrapper', {
        'RightPanel__wrapper--sticky': !useAbsolutePositionSystem,
        'RightPanel__wrapper--fixed': isFixed
      });

      return _react2.default.createElement(
        'div',
        { ref: this.handleRef('fixedWrapper'), className: wrapperClass },
        this.renderContent()
      );
    }
  }]);

  return RightPanel;
}(_react.PureComponent);

RightPanel.propTypes = propTypes;
RightPanel.defaultProps = defaultProps;

exports.default = (0, _scrollWatcher2.default)(RightPanel);

/***/ }),

/***/ 3446:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var mui = __webpack_require__(65);
var SvgIcon = mui.SvgIcon;

var createClass = __webpack_require__(73);

var NavigationArrowBack = createClass({
  displayName: 'NavigationArrowBack',

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z' })
    );
  }

});

module.exports = NavigationArrowBack;

/***/ }),

/***/ 3447:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3448:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(47);

var _index = __webpack_require__(3449);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(_ref) {
  var selectedOrderQueue = _ref.orders.selectedOrderQueue;

  return {
    selectedOrderQueue: selectedOrderQueue
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_index2.default);

/***/ }),

/***/ 3449:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _orders = __webpack_require__(354);

var _Button = __webpack_require__(127);

var _Button2 = _interopRequireDefault(_Button);

var _reactIntl = __webpack_require__(16);

var _Spinner = __webpack_require__(125);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _reactRouter = __webpack_require__(49);

var _OrderPanelSection = __webpack_require__(670);

var _OrderPanelSection2 = _interopRequireDefault(_OrderPanelSection);

var _IncomingOrdersSection = __webpack_require__(3465);

var _IncomingOrdersSection2 = _interopRequireDefault(_IncomingOrdersSection);

var _OngoingOrdersSection = __webpack_require__(3471);

var _OngoingOrdersSection2 = _interopRequireDefault(_OngoingOrdersSection);

__webpack_require__(3477);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderPanel = function OrderPanel(_ref) {
  var activeOrder = _ref.activeOrder,
      dealers = _ref.dealers,
      ordersFinalized = _ref.ordersFinalized,
      formatMessage = _ref.intl.formatMessage,
      fetchMoreFinalizedTickets = _ref.fetchMoreFinalizedTickets,
      dismissOrder = _ref.dismissOrder,
      cancelDelivery = _ref.cancelDelivery,
      router = _ref.router,
      offset = _ref.offset,
      setCurrentOrder = _ref.setCurrentOrder,
      intl = _ref.intl,
      userId = _ref.userId,
      selectedOrderQueue = _ref.selectedOrderQueue;

  if (!Object.keys(dealers).length) {
    return _react2.default.createElement(
      _Spinner2.default,
      null,
      'Carregando dealers'
    );
  }

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      'div',
      null,
      selectedOrderQueue === _orders.ORDERS_QUEUES.INCOMING && _react2.default.createElement(_IncomingOrdersSection2.default, null),
      selectedOrderQueue === _orders.ORDERS_QUEUES.BEING_DELIVERED && _react2.default.createElement(_OngoingOrdersSection2.default, null),
      selectedOrderQueue === _orders.ORDERS_QUEUES.FINALIZED && _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(_OrderPanelSection2.default, {
          dismissOrder: dismissOrder,
          cancelDelivery: cancelDelivery,
          orders: ordersFinalized,
          router: router,
          activeOrder: activeOrder,
          dealers: dealers,
          sectionName: formatMessage({
            id: 'tickets_overview_finalised',
            defaultMessage: 'Finalized orders'
          }),
          emptyMessage: formatMessage({
            id: 'tickets_overview_finalised_empty_message',
            defaultMessage: 'There are no finalized orders'
          }),
          offset: offset,
          setCurrentOrder: setCurrentOrder,
          intl: intl,
          userId: userId
        })
      )
    )
  );
};

OrderPanel.propTypes = {
  activeOrder: _propTypes2.default.object,
  dealers: _propTypes2.default.object.isRequired,
  ordersFinalized: _propTypes2.default.array.isRequired,
  intl: _propTypes2.default.object.isRequired,
  fetchMoreFinalizedTickets: _propTypes2.default.func.isRequired,
  dismissOrder: _propTypes2.default.func.isRequired,
  cancelDelivery: _propTypes2.default.func.isRequired,
  setCurrentOrder: _propTypes2.default.func.isRequired,
  router: _propTypes2.default.object.isRequired,
  offset: _propTypes2.default.number.isRequired,
  userId: _propTypes2.default.string.isRequired
};

OrderPanel.defaultProps = {
  activeOrder: {}
};

var intlComponent = (0, _reactIntl.injectIntl)(OrderPanel);

exports.default = (0, _reactRouter.withRouter)(intlComponent);

/***/ }),

/***/ 3450:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/** FIXME: Refactor this code snippet and split in different sort methods */

/* eslint-disable no-nested-ternary */
var importantOnTop = function importantOnTop(cancelType) {
  return function (_ref, _ref2) {
    var currentTicketA = _ref.currentTicket;
    var currentTicketB = _ref2.currentTicket;

    // First, put cancelled orders on top
    // Then compare both tickets 'dueTime'. An earlier 'dueTime' comes first.
    // Then compare both tickets 'modificationTime'. A later 'modificationTime' comes first.
    // Lastly compare both tickets 'id'. A lower 'id' comes first.
    return currentTicketA.type === cancelType && currentTicketB.type !== cancelType ? -1 : currentTicketA.type !== cancelType && currentTicketB.type === cancelType ? 1 : currentTicketA.dueTime < currentTicketB.dueTime ? -1 : currentTicketA.dueTime > currentTicketB.dueTime ? 1 : currentTicketA.modificationTime > currentTicketB.modificationTime ? -1 : currentTicketA.modificationTime < currentTicketB.modificationTime ? 1 : currentTicketA.id < currentTicketB.id ? -1 : currentTicketA.id > currentTicketB.id ? 1 : 0;
  };
};
exports.default = importantOnTop;

/***/ }),

/***/ 3451:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reselect = __webpack_require__(1514);

var _lodash = __webpack_require__(1365);

var _lodash2 = _interopRequireDefault(_lodash);

var _Dealer = __webpack_require__(669);

var _Dealer2 = _interopRequireDefault(_Dealer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDealers = function getDealers(_ref) {
  var dealer = _ref.dealer;
  return dealer.all;
};

var getFilteredDealers = function getFilteredDealers(_ref2) {
  var dealer = _ref2.dealer;
  return dealer.filteredAll;
};

var getDealersSortedByNameAndEnabledStatus = (0, _reselect.createSelector)(getFilteredDealers, function (dealers) {
  return (0, _lodash2.default)(dealers, ['isEnabled', 'name'], ['desc', 'asc']);
});

var getMainShopDealersSortedByNameAndEnabledStatus = (0, _reselect.createSelector)(getDealersSortedByNameAndEnabledStatus, function (dealers) {
  return dealers.filter(function (dealer) {
    return _Dealer2.default.isMainshop(dealer.id);
  });
});

exports.default = {
  getDealers: getDealers,
  getFilteredDealers: getFilteredDealers,
  getDealersSortedByNameAndEnabledStatus: getDealersSortedByNameAndEnabledStatus,
  getMainShopDealersSortedByNameAndEnabledStatus: getMainShopDealersSortedByNameAndEnabledStatus
};

/***/ }),

/***/ 3452:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 *
 * @param {object} currentOrdersDict: the current state of orders in a dictionary
 * @param {array} currentBeingProcessedOrders: the current state of order being processed in a list
 * @param {array} newOrdersList: the updated ticket list coming from the API
 * @returns {array} the updated being processed order list. Removes orders that have been it 'queue' property changed
 */
var updateBeingProcessedOrderIds = function updateBeingProcessedOrderIds(currentOrdersDict, currentBeingProcessedOrders, newOrdersList) {
  return currentBeingProcessedOrders.filter(function (orderId) {
    var newOrder = newOrdersList.filter(function (order) {
      return order.id === orderId && order.currentTicket.queue;
    })[0];

    if (newOrder) {
      var currentTicket = currentOrdersDict[orderId].currentTicket;

      var currentOrderQueue = currentTicket.queue;
      var newTicket = newOrder.currentTicket;

      var isTicketQueueTheSame = newTicket.queue && currentOrderQueue === newTicket.queue;
      var isAssignedToCurrentUserTheSame = currentTicket.isAssignedToCurrentUser === newTicket.isAssignedToCurrentUser;

      return isTicketQueueTheSame && isAssignedToCurrentUserTheSame;
    }

    // Keep the order in the array
    return true;
  });
};

exports.default = updateBeingProcessedOrderIds;

/***/ }),

/***/ 3453:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(141);

var _lodash2 = _interopRequireDefault(_lodash);

var _isOrderAssignedToUser = __webpack_require__(1528);

var _isOrderAssignedToUser2 = _interopRequireDefault(_isOrderAssignedToUser);

var _OrderSnippet = __webpack_require__(3454);

var _OrderSnippet2 = _interopRequireDefault(_OrderSnippet);

var _OrderPanelHeader = __webpack_require__(3462);

var _OrderPanelHeader2 = _interopRequireDefault(_OrderPanelHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/require-default-props */
var OrderPanelSection = function OrderPanelSection(props) {
  var sectionName = props.sectionName,
      emptyMessage = props.emptyMessage,
      orders = props.orders,
      dealers = props.dealers,
      activeOrder = props.activeOrder,
      dismissOrder = props.dismissOrder,
      cancelDelivery = props.cancelDelivery,
      router = props.router,
      offset = props.offset,
      setCurrentOrder = props.setCurrentOrder,
      intl = props.intl,
      userId = props.userId,
      filterComponent = props.filterComponent;


  var reduceNumberOfDealers = function reduceNumberOfDealers(accum, dealerId) {
    var hasId = !!dealers[dealerId].id;

    if (hasId) {
      return accum + 1;
    }

    return accum;
  };
  var displayDealerName = (0, _lodash2.default)(dealers).reduce(reduceNumberOfDealers, 0) > 1;

  var mapOrders = function mapOrders(order) {
    var isAssignedToCurrentUser = (0, _isOrderAssignedToUser2.default)(userId, order);
    return _react2.default.createElement(
      'div',
      { key: order.id, className: 'OrderPanel__snippet_wrapper' },
      _react2.default.createElement(_OrderSnippet2.default, {
        order: order,
        active: activeOrder && order.id === activeOrder.id,
        dealer: dealers[order.dealerId],
        router: router,
        dismissOrder: dismissOrder,
        cancelDelivery: cancelDelivery,
        displayDealerName: displayDealerName,
        offset: offset,
        setCurrentOrder: setCurrentOrder,
        intl: intl,
        isAssignedToCurrentUser: isAssignedToCurrentUser,
        userId: userId
      })
    );
  };
  var renderOrders = function renderOrders() {
    if (orders.length) {
      return orders.map(mapOrders);
    }

    return _react2.default.createElement(
      'div',
      null,
      emptyMessage
    );
  };

  return _react2.default.createElement(
    'section',
    { className: 'OrderPanel__section' },
    _react2.default.createElement(_OrderPanelHeader2.default, { title: sectionName, filterComponent: filterComponent }),
    _react2.default.createElement(
      'div',
      null,
      renderOrders()
    )
  );
};

OrderPanelSection.propTypes = {
  sectionName: _propTypes2.default.string,
  emptyMessage: _propTypes2.default.string,
  orders: _propTypes2.default.array,
  dealers: _propTypes2.default.object,
  activeOrder: _propTypes2.default.object,
  dismissOrder: _propTypes2.default.func,
  cancelDelivery: _propTypes2.default.func,
  router: _propTypes2.default.object,
  offset: _propTypes2.default.number,
  setCurrentOrder: _propTypes2.default.func,
  intl: _propTypes2.default.object,
  userId: _propTypes2.default.string,
  filterComponent: _propTypes2.default.node
};

exports.default = OrderPanelSection;

/***/ }),

/***/ 3454:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

var _clipboard = __webpack_require__(626);

var _clipboard2 = _interopRequireDefault(_clipboard);

var _shallowequal = __webpack_require__(1515);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _reactIntl = __webpack_require__(16);

var _reactTransitionGroup = __webpack_require__(126);

var _cardGiftcard = __webpack_require__(409);

var _cardGiftcard2 = _interopRequireDefault(_cardGiftcard);

var _chevronRight = __webpack_require__(3455);

var _chevronRight2 = _interopRequireDefault(_chevronRight);

var _contentCopy = __webpack_require__(1530);

var _contentCopy2 = _interopRequireDefault(_contentCopy);

var _appInsights = __webpack_require__(461);

var _appInsights2 = _interopRequireDefault(_appInsights);

var _status = __webpack_require__(53);

var _isCsUser = __webpack_require__(588);

var _isCsUser2 = _interopRequireDefault(_isCsUser);

var _OrderStatusIcon = __webpack_require__(1059);

var _OrderStatusIcon2 = _interopRequireDefault(_OrderStatusIcon);

var _Tooltip = __webpack_require__(221);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _alarm = __webpack_require__(3456);

var _alarm2 = _interopRequireDefault(_alarm);

var _clock = __webpack_require__(3457);

var _clock2 = _interopRequireDefault(_clock);

var _Icon_Flat_Others_Phone = __webpack_require__(3458);

var _Icon_Flat_Others_Phone2 = _interopRequireDefault(_Icon_Flat_Others_Phone);

var _isDealerBlockedOrSuspended = __webpack_require__(407);

var _block = __webpack_require__(3459);

var _block2 = _interopRequireDefault(_block);

var _OrderClockTimer = __webpack_require__(3460);

var _OrderClockTimer2 = _interopRequireDefault(_OrderClockTimer);

__webpack_require__(3461);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  order: _propTypes2.default.object.isRequired,
  active: _propTypes2.default.bool.isRequired,
  intl: _propTypes2.default.object.isRequired,
  dismissOrder: _propTypes2.default.func.isRequired,
  cancelDelivery: _propTypes2.default.func.isRequired,
  setCurrentOrder: _propTypes2.default.func.isRequired,
  isAssignedToCurrentUser: _propTypes2.default.bool.isRequired,
  offset: _propTypes2.default.number.isRequired,
  dealer: _propTypes2.default.object,
  userId: _propTypes2.default.string.isRequired
};

var defaultProps = {
  dealer: undefined
};

var OrderSnippet = function (_Component) {
  _inherits(OrderSnippet, _Component);

  function OrderSnippet(props) {
    _classCallCheck(this, OrderSnippet);

    var _this = _possibleConstructorReturn(this, (OrderSnippet.__proto__ || Object.getPrototypeOf(OrderSnippet)).call(this, props));

    _this.track = function (eventName) {
      var _this$props = _this.props,
          _this$props$order = _this$props.order,
          orderId = _this$props$order.id,
          orderStatus = _this$props$order.status,
          ticketId = _this$props$order.currentTicket.id,
          userId = _this$props.userId;

      var data = { orderId: orderId, orderStatus: orderStatus, ticketId: ticketId, userId: userId };
      _appInsights2.default.trackEvent(eventName, data);
    };

    _this.handleRef = function (refName) {
      return function (ref) {
        _this[refName] = ref;
      };
    };

    _this.onOrderMouseEnter = function () {
      _this.clipboard = new _clipboard2.default('#' + _this.clipboardElementId);

      _this.setState({ isOptionsOpen: true });
    };

    _this.onOrderMouseLeave = function () {
      if (_this.clipboard) {
        _this.clipboard.destroy();
      }

      _this.setState({ isOptionsOpen: false });
    };

    _this.renderOrderOptions = function () {
      var isOptionsOpen = _this.state.isOptionsOpen;
      var _this$props2 = _this.props,
          id = _this$props2.order.id,
          formatMessage = _this$props2.intl.formatMessage;


      if (isOptionsOpen) {
        var copyBtnTooltip = formatMessage({
          id: 'order_snippet.copy_id',
          defaultMessage: 'Copy order ID'
        });

        return _react2.default.createElement(
          'div',
          { key: 'OrderSnippet-options', className: 'OrderSnippet__options' },
          _react2.default.createElement(
            _Tooltip2.default,
            { position: 'left', title: copyBtnTooltip },
            _react2.default.createElement(
              'button',
              {
                className: 'OrderSnippet__options_btn',
                id: _this.clipboardElementId,
                'data-clipboard-text': id,
                type: 'button'
              },
              _react2.default.createElement(_contentCopy2.default, { className: 'OrderSnippet__options_btn_icon' })
            )
          )
        );
      }

      return null;
    };

    _this.goToOrder = function () {
      var _this$props3 = _this.props,
          setCurrentOrder = _this$props3.setCurrentOrder,
          id = _this$props3.order.id;


      _this.track('mdt-order-tile-pressed');
      setCurrentOrder(id);
    };

    _this.dismissOrder = function () {
      var _this$props4 = _this.props,
          dismissOrder = _this$props4.dismissOrder,
          _this$props4$order$cu = _this$props4.order.currentTicket,
          id = _this$props4$order$cu.id,
          eTag = _this$props4$order$cu.eTag;


      return dismissOrder(id, eTag);
    };

    _this.cancelDelivery = function () {
      var _this$props5 = _this.props,
          cancelDelivery = _this$props5.cancelDelivery,
          _this$props5$order$cu = _this$props5.order.currentTicket,
          id = _this$props5$order$cu.id,
          eTag = _this$props5$order$cu.eTag;


      return cancelDelivery(id, eTag);
    };

    _this.onCancelNewOrderConfirm = function () {
      var setCurrentOrder = _this.props.setCurrentOrder;


      _this.dismissOrder().then(function () {
        setCurrentOrder(null);
      });
    };

    _this.onCancelDeliverOrderConfirm = function () {
      var setCurrentOrder = _this.props.setCurrentOrder;


      _this.cancelDelivery().then(function () {
        setCurrentOrder(null);
      });
    };

    _this.isConsumerCanceled = function () {
      var type = _this.props.order.currentTicket.type;


      return type === _status.TYPE_CANCEL_NEW_ORDER || type === _status.TYPE_CANCEL_DELIVER_ORDER;
    };

    _this.isDealerCanceled = function () {
      var status = _this.props.order.status;


      return status === _status.ORDER_STATUS_DEALER_CANCELLED || status === _status.ORDER_STATUS_DEALER_DECLINED;
    };

    _this.getComponentClass = function () {
      var _this$props6 = _this.props,
          _this$props6$order = _this$props6.order,
          voucher = _this$props6$order.voucher,
          queue = _this$props6$order.currentTicket.queue,
          active = _this$props6.active;


      return (0, _classnames2.default)('OrderSnippet', {
        'is-active': active,
        'is-incoming': queue === _status.QUEUE_INCOMING,
        'is-being_delivered': queue === _status.QUEUE_BEING_DELIVERED,
        'is-finalized': queue === _status.QUEUE_FINALIZED,
        'is-canceled': _this.isConsumerCanceled() || _this.isDealerCanceled(),
        'has-voucher': !!voucher
      });
    };

    _this.renderAssignee = function () {
      var _this$props7 = _this.props,
          isAssignedToCurrentUser = _this$props7.isAssignedToCurrentUser,
          _this$props7$order$cu = _this$props7.order.currentTicket,
          status = _this$props7$order$cu.status,
          assignedToUserEmail = _this$props7$order$cu.assignedToUserEmail;


      if (assignedToUserEmail) {
        var isInProgress = status === _status.STATUS_IN_PROGRESS;
        var assigneeClass = (0, _classnames2.default)('OrderSnippet__assignee', {
          'OrderSnippet__assignee--open_by_other_user': !isAssignedToCurrentUser && isInProgress
        });
        var assigneeInitials = assignedToUserEmail.substr(0, 2);
        var assigneeTooltip = _react2.default.createElement(
          'strong',
          null,
          assignedToUserEmail
        );

        return _react2.default.createElement(
          _Tooltip2.default,
          { position: 'bottom', html: assigneeTooltip },
          _react2.default.createElement(
            'div',
            { key: 'assignee', className: assigneeClass },
            assigneeInitials
          )
        );
      }

      return null;
    };

    _this.renderMainInfo = function () {
      var _this$props8 = _this.props,
          _this$props8$order = _this$props8.order,
          address = _this$props8$order.address,
          type = _this$props8$order.currentTicket.type,
          formatMessage = _this$props8.intl.formatMessage;


      if (type === _status.TYPE_CANCEL_NEW_ORDER || type === _status.TYPE_CANCEL_DELIVER_ORDER) {
        return formatMessage({
          id: 'cancelled_by_customer',
          defaultMessage: 'Cancelled by customer'
        });
      }

      return address;
    };

    _this.renderVoucherIndicator = function () {
      var voucher = _this.props.order.voucher;


      if (voucher) {
        return _react2.default.createElement(
          'div',
          { className: 'OrderSnippet__voucher_display' },
          _react2.default.createElement(_cardGiftcard2.default, { className: 'OrderSnippet__voucher_display_icon' })
        );
      }

      return null;
    };

    _this.renderTelephoneOrderIndicator = function () {
      var _this$props9 = _this.props,
          salesChannel = _this$props9.order.salesChannel,
          formatMessage = _this$props9.intl.formatMessage;


      if (!salesChannel || salesChannel !== 'shop') {
        return null;
      }

      var tooltipText = formatMessage({
        id: 'order_snippet.telephone_order'
      });

      return _react2.default.createElement(
        _Tooltip2.default,
        {
          className: 'OrderSnippet__telephone-order-tooltip',
          position: 'left',
          title: tooltipText
        },
        _react2.default.createElement(
          'div',
          { className: 'OrderSnippet__telephone-order' },
          _react2.default.createElement('img', { width: 20, height: 20, src: _Icon_Flat_Others_Phone2.default, alt: 'telephone' })
        )
      );
    };

    _this.renderOrderTimeIndicator = function () {
      var _this$props10 = _this.props,
          offset = _this$props10.offset,
          _this$props10$order = _this$props10.order,
          eta = _this$props10$order.eta,
          creationTime = _this$props10$order.creationTime,
          _this$props10$order$c = _this$props10$order.currentTicket,
          queue = _this$props10$order$c.queue,
          type = _this$props10$order$c.type,
          modificationTime = _this$props10$order$c.modificationTime;

      var canShowClockTimer = queue === _status.QUEUE_INCOMING && type === _status.TYPE_NEW_ORDER || queue === _status.QUEUE_BEING_DELIVERED && type === _status.TYPE_DELIVER_ORDER;

      if (canShowClockTimer) {
        return _react2.default.createElement(_OrderClockTimer2.default, {
          eta: eta,
          creationTime: creationTime,
          offset: offset,
          ticketQueue: queue,
          iconImgSrc: _clock2.default,
          attentionImgSrc: _alarm2.default,
          isConsumerCanceled: _this.isConsumerCanceled(),
          isCountdown: queue === _status.QUEUE_BEING_DELIVERED
        });
      }

      var dateValue = queue === _status.QUEUE_FINALIZED ? modificationTime : creationTime;
      return _react2.default.createElement(
        'div',
        { className: 'OrderSnippet__duration OrderSnippet__duration--date' },
        _react2.default.createElement(_reactIntl.FormattedDate, { value: dateValue, month: 'numeric', day: 'numeric' })
      );
    };

    _this.state = {
      isOptionsOpen: false
    };

    _this.clipboardElementId = 'copy-order-id-button';
    return _this;
  }

  _createClass(OrderSnippet, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.track('mdt-order-update-rendered');
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var orderStatus = this.props.order.status;
      var prevOrderStatus = prevProps.order.status;


      if (prevOrderStatus !== orderStatus) this.track('mdt-order-update-rendered');
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var _this2 = this;

      var nextEtag = nextProps.order.currentTicket.eTag;
      var eTagChanged = nextEtag !== this.props.order.currentTicket.eTag;
      var offsetChanged = nextProps.offset !== this.props.offset;
      var activeChanged = nextProps.active !== this.props.active;
      var hasStateChanged = !(0, _shallowequal2.default)(this.state, nextState);
      var hasDealerChanged = function hasDealerChanged() {
        if (nextProps.dealer && !_this2.props.dealer) {
          return true;
        }

        if (nextProps.dealer && _this2.props.dealer) {
          if (nextProps.dealer.name !== _this2.props.dealer.name) {
            return true;
          }

          if (nextProps.dealer.isActive !== _this2.props.dealer.isActive) {
            return true;
          }

          if (nextProps.dealer.id !== _this2.props.dealer.id) {
            return true;
          }
        }

        return false;
      };

      return hasStateChanged || eTagChanged || offsetChanged || activeChanged || hasDealerChanged();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          dealer = _props.dealer,
          active = _props.active;
      var _props$order = this.props.order,
          id = _props$order.id,
          status = _props$order.status,
          assignedToUserId = _props$order.currentTicket.assignedToUserId,
          consumerDelivered = _props$order.consumerDelivered;

      var splittedId = id.split('|');
      var shortId = splittedId[splittedId.length - 1];
      var shopNameClass = (0, _classnames2.default)('OrderSnippet__shop_name', {
        'OrderSnippet__shop_name--active': dealer && dealer.isActive,
        'OrderSnippet__shop_name--unactive': dealer && !dealer.isActive
      });

      return _react2.default.createElement(
        'div',
        { id: 'order-' + shortId, className: this.getComponentClass() },
        _react2.default.createElement(
          'div',
          { onMouseEnter: this.onOrderMouseEnter, onMouseLeave: this.onOrderMouseLeave },
          _react2.default.createElement(
            'div',
            { onClick: this.goToOrder, className: 'OrderSnippet__content' },
            this.renderOrderTimeIndicator(),
            _react2.default.createElement(
              'div',
              { className: 'OrderSnippet__main_info' },
              dealer && _react2.default.createElement(
                'div',
                { className: shopNameClass },
                _react2.default.createElement(
                  'span',
                  null,
                  dealer.name
                ),
                (0, _isDealerBlockedOrSuspended.isBlocked)(dealer) && _react2.default.createElement(
                  'span',
                  { className: 'OrderSnippet__dealer_not_live' },
                  _react2.default.createElement(_block2.default, { className: 'OrderSnippet__dealer_not_live_icon', color: 'red' }),
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: (0, _isDealerBlockedOrSuspended.isBlocked)(dealer) ? 'dealer_blocked' : 'dealer_suspended',
                    defaultMessage: (0, _isDealerBlockedOrSuspended.isBlocked)(dealer) ? 'Blocked' : 'Suspended'
                  })
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'OrderSnippet__dealer_id' },
                  ' (',
                  dealer.id,
                  ')'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'OrderSnippet__address' },
                this.renderMainInfo()
              ),
              _react2.default.createElement(
                'div',
                { className: 'OrderSnippet__order_id' },
                id
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'OrderSnippet__status_info' },
              _react2.default.createElement(
                _reactTransitionGroup.CSSTransitionGroup,
                {
                  transitionName: 'OrderSnippet-appear-transition',
                  transitionEnterTimeout: 300,
                  transitionLeaveTimeout: 300
                },
                this.renderAssignee()
              ),
              _react2.default.createElement(_OrderStatusIcon2.default, {
                orderStatus: status,
                isCsUser: (0, _isCsUser2.default)(assignedToUserId),
                consumerDelivered: consumerDelivered
              }),
              this.renderVoucherIndicator(),
              this.renderTelephoneOrderIndicator()
            ),
            _react2.default.createElement(
              _reactTransitionGroup.CSSTransitionGroup,
              {
                component: 'div',
                className: 'OrderSnippet__order_open',
                transitionName: 'OrderSnippet-appear-transition',
                transitionEnterTimeout: 300,
                transitionLeaveTimeout: 300
              },
              active && _react2.default.createElement(_chevronRight2.default, { key: 'active-icon', className: 'OrderSnippet__order_open_icon' })
            )
          ),
          _react2.default.createElement(
            _reactTransitionGroup.CSSTransitionGroup,
            {
              transitionName: 'OrderSnippet-options-transition',
              transitionEnterTimeout: 300,
              transitionLeaveTimeout: 200
            },
            this.renderOrderOptions()
          )
        )
      );
    }
  }]);

  return OrderSnippet;
}(_react.Component);

OrderSnippet.propTypes = propTypes;
OrderSnippet.defaultProps = defaultProps;

exports.default = OrderSnippet;

/***/ }),

/***/ 3455:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var mui = __webpack_require__(65);
var SvgIcon = mui.SvgIcon;

var createClass = __webpack_require__(73);

var NavigationChevronRight = createClass({
  displayName: 'NavigationChevronRight',

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' })
    );
  }

});

module.exports = NavigationChevronRight;

/***/ }),

/***/ 3456:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE5Ljg2MSAzLjgzM0wxNS4yOTMgMGwtMS4yODEgMS41MiA0LjU2OCAzLjgzMyAxLjI4MS0xLjUyek01LjgzOSAxLjUyTDQuNTY4IDAgMCAzLjgyM2wxLjI4MSAxLjUyIDQuNTU4LTMuODI0em00LjU4OCA0LjU3OGgtMS40OXY1Ljk1OWw0LjcxNyAyLjgzLjc0NS0xLjIyMi0zLjk3Mi0yLjM1M1Y2LjA5N3pNOS45MyAyLjEyNWE4LjkzOCA4LjkzOCAwIDAgMC04LjkzNyA4LjkzOEE4LjkzMiA4LjkzMiAwIDAgMCA5LjkzIDIwYTguOTM4IDguOTM4IDAgMCAwIDAtMTcuODc1em0wIDE1Ljg4OWE2Ljk0NiA2Ljk0NiAwIDAgMS02Ljk1LTYuOTUxQTYuOTQ2IDYuOTQ2IDAgMCAxIDkuOTMgNC4xMWE2Ljk0NiA2Ljk0NiAwIDAgMSA2Ljk1MiA2Ljk1MiA2Ljk0NiA2Ljk0NiAwIDAgMS02Ljk1MiA2Ljk1eiIvPgo8L3N2Zz4K"

/***/ }),

/***/ 3457:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTcgMGMzLjg2IDAgNyAzLjE0IDcgNyAwIDMuODU5LTMuMTQgNy03IDdzLTctMy4xNDEtNy03YzAtMy44NiAzLjE0LTcgNy03em0uNjk4IDMuODQ5YS42OTkuNjk5IDAgMCAwLTEuMzk4IDB2My40OTNjMCAuNTg2LjY3Ny45MTIgMS4xMzUuNTQ3bDMuNTAyLTMuMjExYS42OTkuNjk5IDAgMSAwLS44NzItMS4wOTNMNy42OTggNS44OTFWMy44NDl6Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ 3458:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjIxNzYgMi44MjQ3NEM1LjM5NTc3IDEuOTE5NzkgNi42MTM0MyAyLjA5NTMzIDcuMTQzNjIgMy4yNjc3NkM3LjE4NjA5IDMuMzUyMiA3LjI2MzcxIDMuNTAzMzcgNy4zNzQzMyAzLjcxNzIzTDcuMzc3MDMgMy43MjI0NEM3LjQxNjc1IDMuNzk5MjIgNy40Nzc2MiAzLjkxNjYzIDcuNTQ3NzggNC4wNTE4MUw3LjYyMDMzIDQuMTkxNTdMNy42NDE5MSA0LjIzMzExTDcuNjQ3NTggNC4yNDQwM0w3LjY0ODk0IDQuMjQ2NjNDNy42NDkxMSA0LjI0Njk2IDcuNjQ5MTEgNC4yNDY5NiA3LjQ4MjkyIDQuMzM2MzlMNy40ODM1MSA0LjMzNzU2TDcuNjQ5NiA0LjI0Nzg5QzcuODM4NzQgNC42MTcyOSA3Ljk0NzE3IDQuODU0MjkgOC4wMjY1OCA1LjA3MzI3QzguMjc0MzYgNS43NTY1MyA4LjIwNTQ3IDYuMjg3NTQgNy43OTc4NSA2LjcyMzg5TDcuNzY0NDMgNi43NTg3MUw3LjcyNzQ2IDYuNzg5MTZMNy42OTY1IDYuODA5NjhDNy42NDk0MiA2Ljg0MDg4IDcuNTc1MjUgNi44ODkyMiA3LjM3OTE1IDcuMDE2NkM3LjE1MTI0IDcuMTY0NjMgNy4wOTA0OSA3LjIwNDIyIDcuMDUzMDUgNy4yMjkxOEM2Ljg1Mjc1IDcuMzYyNjYgNi43MjU1NyA3LjQ1NzYxIDYuNjM2MzMgNy41Mzk4MUM2LjUwMDgyIDcuNjY0NjIgNi41MDMgNy42NTQ2OSA2LjU3ODcxIDcuODAwMjhDNy4yNjY4NCA5LjQzNDMgOC42MTY5MSAxMC44Njg3IDEwLjI5NzYgMTEuNzQ1NUMxMC4zNzU0IDExLjc5MzkgMTAuMzYyNyAxMS43OTQxIDEwLjQyOTggMTEuNzQ1NkMxMC41MTcxIDExLjY4MjUgMTAuNjI4NyAxMS41NjY2IDEwLjc5MDkgMTEuMzY4NUMxMC44MDUgMTEuMzUxMiAxMC44MzggMTEuMzA5OSAxMC44OTkgMTEuMjMzMkwxMS4wODAzIDExLjAwNDlMMTEuMDgyNyAxMS4wMDJDMTEuMjMxIDEwLjgxNTQgMTEuMzA0NCAxMC43MjQxIDExLjM2NzEgMTAuNjUwM0wxMS40MzM2IDEwLjU4NjhDMTEuODk2MSAxMC4yMTkgMTIuNDI1MSAxMC4xNzkxIDEzLjA3OTcgMTAuNDUwMUMxMy4zMDA3IDEwLjU0MTcgMTMuNTQzMiAxMC42NjggMTMuODkxNCAxMC44NzIzQzEzLjk2MDIgMTAuOTEyNyAxNC4xMDcxIDExLjAwMDggMTQuMzYzMyAxMS4xNTUyQzE0LjQ4MTIgMTEuMjI2MyAxNC40ODEyIDExLjIyNjMgMTQuNjYzOSAxMS4zMzY2QzE0Ljc2NiAxMS4zOTgxIDE0LjgyMjUgMTEuNDMyMiAxNC44NDcyIDExLjQ0NjlDMTUuOTY5IDEyLjA5MjUgMTYuMDQ3NyAxMy4yNTU4IDE1LjA3MDEgMTQuMzg5NEMxMi45MDI4IDE2LjgxMDMgOC45NjA3MSAxNS45MTk0IDUuNjEzOTYgMTIuMzYyNkMyLjI2MjIyIDguODAwNDYgMS42MzI2MyA0LjgxODY1IDQuMjE3NiAyLjgyNDc0WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 3459:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var mui = __webpack_require__(65);
var SvgIcon = mui.SvgIcon;

var createClass = __webpack_require__(73);

var ContentBlock = createClass({
  displayName: 'ContentBlock',

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z' })
    );
  }

});

module.exports = ContentBlock;

/***/ }),

/***/ 3460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

var _status = __webpack_require__(53);

var _clockFormat3 = __webpack_require__(1081);

var _clockFormat4 = _interopRequireDefault(_clockFormat3);

var _getCurrentTime = __webpack_require__(1083);

var _getCurrentTime2 = _interopRequireDefault(_getCurrentTime);

var _orderTimeStatus2 = __webpack_require__(1221);

var _orderTimeStatus3 = _interopRequireDefault(_orderTimeStatus2);

var _orderTimeCount = __webpack_require__(589);

var _orderTimeCount2 = _interopRequireDefault(_orderTimeCount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  offset: _propTypes2.default.number.isRequired,
  iconImgSrc: _propTypes2.default.string.isRequired,
  attentionImgSrc: _propTypes2.default.string.isRequired,
  creationTime: _propTypes2.default.string.isRequired,
  ticketQueue: _propTypes2.default.string.isRequired,
  isConsumerCanceled: _propTypes2.default.bool.isRequired,
  eta: _propTypes2.default.string,
  isCountdown: _propTypes2.default.bool
};

var defaultProps = {
  isCountdown: false,
  eta: ''
};

var OrderClockTimer = function (_PureComponent) {
  _inherits(OrderClockTimer, _PureComponent);

  function OrderClockTimer(props) {
    _classCallCheck(this, OrderClockTimer);

    var _this = _possibleConstructorReturn(this, (OrderClockTimer.__proto__ || Object.getPrototypeOf(OrderClockTimer)).call(this, props));

    _this.hasAttentionNeeded = function (danger, warning) {
      var _this$props = _this.props,
          ticketQueue = _this$props.ticketQueue,
          isConsumerCanceled = _this$props.isConsumerCanceled;


      return (danger || warning) && ticketQueue === _status.QUEUE_INCOMING && !isConsumerCanceled;
    };

    var currentTime = (0, _getCurrentTime2.default)(props.offset);

    _this.state = { currentTime: currentTime };
    return _this;
  }

  _createClass(OrderClockTimer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var tickTimer = function tickTimer() {
        var _props = _this2.props,
            offset = _props.offset,
            creationTime = _props.creationTime,
            eta = _props.eta,
            isCountdown = _props.isCountdown;

        var now = new Date().getTime();
        var timeUntilNextSec = 1000 - now % 1000;

        var bumpTime = function bumpTime() {
          var newCurrentTime = (0, _getCurrentTime2.default)(offset);
          var time = isCountdown ? eta : creationTime;
          var secs = (0, _orderTimeCount2.default)(newCurrentTime, time, isCountdown);

          var _clockFormat = (0, _clockFormat4.default)(Math.abs(secs), isCountdown),
              hours = _clockFormat.hours,
              minutes = _clockFormat.minutes,
              seconds = _clockFormat.seconds;

          if (isCountdown) {
            // just update state if the minute part has changed or if other isn't late
            var isLate = secs < -1;
            var minutesChanged = minutes !== _this2.state.minutes;

            if (minutesChanged || !isLate) {
              _this2.setState({ currentTime: newCurrentTime, hours: hours, minutes: minutes, seconds: seconds });
            }
          } else {
            var timeOverlapped = secs >= 100 * 60;

            if (!timeOverlapped) {
              _this2.setState({
                currentTime: newCurrentTime,
                hours: hours,
                minutes: minutes,
                seconds: seconds
              });
            }
          }

          tickTimer();
        };

        _this2.timer = setTimeout(bumpTime, timeUntilNextSec);
      };

      tickTimer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          iconImgSrc = _props2.iconImgSrc,
          creationTime = _props2.creationTime,
          isCountdown = _props2.isCountdown,
          eta = _props2.eta,
          ticketQueue = _props2.ticketQueue,
          attentionImgSrc = _props2.attentionImgSrc;
      var currentTime = this.state.currentTime;

      var time = isCountdown ? eta : creationTime;
      var secs = (0, _orderTimeCount2.default)(currentTime, time, isCountdown);

      var _orderTimeStatus = (0, _orderTimeStatus3.default)(ticketQueue, currentTime, eta, creationTime),
          danger = _orderTimeStatus.danger,
          warning = _orderTimeStatus.warning;

      var durationClass = (0, _classnames2.default)('OrderSnippet__duration', {
        'OrderSnippet__duration--danger': danger,
        'OrderSnippet__duration--warning': warning,
        'OrderSnippet__duration--attention_needed': this.hasAttentionNeeded(danger, warning),
        'OrderSnippet__duration--is-late': secs < 0
      });

      var _clockFormat2 = (0, _clockFormat4.default)(Math.abs(secs), isCountdown),
          hours = _clockFormat2.hours,
          minutes = _clockFormat2.minutes,
          seconds = _clockFormat2.seconds;

      var timeOverlapped = secs >= 100 * 60;
      var minutesLabel = timeOverlapped ? '99' : minutes;
      var secondsLabel = timeOverlapped ? '99' : seconds;

      if (this.hasAttentionNeeded(danger, warning)) {
        return _react2.default.createElement(
          'span',
          { className: durationClass },
          _react2.default.createElement(
            'span',
            { key: 'attention_duration', className: 'OrderSnippet__attention_duration_content' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('img', { className: 'OrderSnippet__attention_icon', src: attentionImgSrc, alt: 'alarm' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'OrderSnippet__attention_duration_text' },
                minutesLabel,
                ':',
                secondsLabel
              )
            )
          )
        );
      }

      if (secs < 120 * 60 && secs >= 0) {
        return _react2.default.createElement(
          'span',
          { className: durationClass },
          _react2.default.createElement('img', { src: iconImgSrc, alt: 'iconImgSrc' }),
          '\xA0',
          _react2.default.createElement(
            'span',
            { className: 'OrderSnippet__durationText' },
            hours ? Math.abs(hours) + 'h ' + Math.abs(minutes) + 'm' : minutesLabel + ':' + secondsLabel
          )
        );
      }

      if (isCountdown) {
        var isLateLessThanOneMinute = hours === 0 && Math.abs(minutes) === 0;

        return _react2.default.createElement(
          'span',
          { className: durationClass },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'general.order_late' }),
          !isLateLessThanOneMinute && _react2.default.createElement(
            'div',
            null,
            hours ? Math.abs(hours) + 'h ' + Math.abs(minutes) + 'm' : Math.abs(minutes) + 'm'
          )
        );
      }

      return _react2.default.createElement(
        'span',
        { className: durationClass },
        _react2.default.createElement('img', { src: iconImgSrc, alt: '.' }),
        '\xA0',
        _react2.default.createElement(
          'span',
          { className: 'OrderSnippet__durationText' },
          '99:99'
        )
      );
    }
  }]);

  return OrderClockTimer;
}(_react.PureComponent);

OrderClockTimer.propTypes = propTypes;
OrderClockTimer.defaultProps = defaultProps;

exports.default = OrderClockTimer;

/***/ }),

/***/ 3461:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3462:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _OrderPanelHeader = __webpack_require__(3463);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OrderPanelHeader).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 3463:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(3464);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrdersPanelHeader = function OrdersPanelHeader(_ref) {
  var title = _ref.title,
      filterComponent = _ref.filterComponent;

  return _react2.default.createElement(
    'div',
    { className: 'OrdersPanelHeader' },
    _react2.default.createElement(
      'h4',
      { className: 'OrdersPanelHeader__title' },
      title
    ),
    _react2.default.createElement(
      'div',
      { className: 'OrdersPanelHeader__filter' },
      filterComponent
    )
  );
};

OrdersPanelHeader.propTypes = {
  title: _propTypes2.default.string.isRequired,
  filterComponent: _propTypes2.default.node
};

OrdersPanelHeader.defaultProps = {
  filterComponent: null
};

exports.default = OrdersPanelHeader;

/***/ }),

/***/ 3464:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IncomingOrdersSection = __webpack_require__(3466);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_IncomingOrdersSection).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 3466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(47);

var _reactRouter = __webpack_require__(49);

var _orders = __webpack_require__(238);

var _orders2 = __webpack_require__(354);

var _IncomingOrdersSection = __webpack_require__(3467);

var _IncomingOrdersSection2 = _interopRequireDefault(_IncomingOrdersSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  var chamaID = state.auth.chamaID;

  var order = state.orders.dict[state.orders.currentOrderId];
  var dealers = state.dealer.all;
  var offset = state.time.offset;


  var filteredNewOrders = (0, _orders2.getFilteredNewOrders)(state);
  var allNewOrders = (0, _orders2.getNewOrders)(state);

  return {
    dealers: dealers,
    filteredNewOrders: filteredNewOrders,
    allNewOrders: allNewOrders,
    activeOrder: order,
    offset: offset,
    userId: chamaID
  };
};

var mapDispatchToProps = {
  dismissOrder: _orders.dismissOrder,
  cancelDelivery: _orders.cancelDelivery,
  setCurrentOrder: _orders.setCurrentOrder
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_IncomingOrdersSection2.default));

/***/ }),

/***/ 3467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _OrderPanelSection = __webpack_require__(670);

var _OrderPanelSection2 = _interopRequireDefault(_OrderPanelSection);

var _reactIntl = __webpack_require__(16);

var _IncomingOrdersFilter = __webpack_require__(3468);

var _IncomingOrdersFilter2 = _interopRequireDefault(_IncomingOrdersFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IncomingOrdersSection = function IncomingOrdersSection(_ref) {
  var intl = _ref.intl,
      filteredNewOrders = _ref.filteredNewOrders,
      allNewOrders = _ref.allNewOrders,
      props = _objectWithoutProperties(_ref, ['intl', 'filteredNewOrders', 'allNewOrders']);

  var labelComponent = filteredNewOrders.length === allNewOrders.length ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ordersinfo.orders-count', values: { count: allNewOrders.length } }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'orders.range',
    values: { total: allNewOrders.length, filtered: filteredNewOrders.length }
  });

  return _react2.default.createElement(_OrderPanelSection2.default, _extends({}, props, {
    orders: filteredNewOrders,
    intl: intl,
    filterComponent: _react2.default.createElement(_IncomingOrdersFilter2.default, { label: labelComponent }),
    sectionName: intl.formatMessage({ id: 'tickets_overview_incoming' }),
    emptyMessage: intl.formatMessage({ id: 'tickets_overview_incoming_empty_message' })
  }));
};

IncomingOrdersSection.propTypes = {
  intl: _propTypes2.default.object.isRequired,
  dealers: _propTypes2.default.object.isRequired,
  filteredNewOrders: _propTypes2.default.array.isRequired,
  allNewOrders: _propTypes2.default.array.isRequired,
  activeOrder: _propTypes2.default.object,
  offset: _propTypes2.default.number.isRequired,
  userId: _propTypes2.default.string.isRequired
};

IncomingOrdersSection.defaultProps = {
  activeOrder: null
};

exports.default = (0, _reactIntl.injectIntl)(IncomingOrdersSection);

/***/ }),

/***/ 3468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IncomingOrdersFilter = __webpack_require__(3469);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_IncomingOrdersFilter).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 3469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = __webpack_require__(207);

var _reactIntl = __webpack_require__(16);

var _reactSelect = __webpack_require__(662);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

__webpack_require__(3470);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IncomingOrdersFilterReduxForm = function IncomingOrdersFilterReduxForm(_ref) {
  var intl = _ref.intl,
      props = _objectWithoutProperties(_ref, ['intl']);

  var options = [{ value: 'SHOW_ALL', label: intl.formatMessage({ id: 'orders.all' }) }, {
    value: 'SHOW_AWAITING_INTERACTION',
    label: intl.formatMessage({ id: 'orders.waiting.interaction' })
  }];
  return _react2.default.createElement(_reduxForm.Field, _extends({}, props, { name: 'orderType', component: IncomingOrdersFilter, options: options }));
};

IncomingOrdersFilterReduxForm.propTypes = {
  intl: _propTypes2.default.object.isRequired
};

var IncomingOrdersFilter = function IncomingOrdersFilter(_ref2) {
  var input = _ref2.input,
      options = _ref2.options,
      label = _ref2.label;
  return _react2.default.createElement(
    'div',
    { className: 'IncomingOrdersFilter' },
    _react2.default.createElement(
      'div',
      { className: 'IncomingOrdersFilter__label' },
      label
    ),
    _react2.default.createElement(_reactSelect2.default, _extends({}, input, {
      className: 'IncomingOrdersFilter__dropdown',
      onChange: function onChange(value) {
        return input.onChange(value);
      },
      onBlur: function onBlur() {
        return input.onBlur(input.value);
      },
      options: options,
      isSearchable: false,
      isClearable: false
    }))
  );
};

IncomingOrdersFilter.propTypes = {
  label: _propTypes2.default.node.isRequired,
  input: _propTypes2.default.object.isRequired,
  options: _propTypes2.default.array.isRequired
};

var intlComponent = (0, _reactIntl.injectIntl)(IncomingOrdersFilterReduxForm);

exports.default = (0, _reduxForm.reduxForm)({
  form: '@ORDERS/INCOMING',
  destroyOnUnmount: false,
  initialValues: {
    orderType: {
      value: 'SHOW_ALL',
      label: 'Todos os pedidos'
    }
  }
})(intlComponent);

/***/ }),

/***/ 3470:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _OngoingOrdersSection = __webpack_require__(3472);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OngoingOrdersSection).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 3472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(47);

var _reactRouter = __webpack_require__(49);

var _orders = __webpack_require__(238);

var _orders2 = __webpack_require__(354);

var _OngoingOrdersSection = __webpack_require__(3473);

var _OngoingOrdersSection2 = _interopRequireDefault(_OngoingOrdersSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  var chamaID = state.auth.chamaID;

  var order = state.orders.dict[state.orders.currentOrderId];
  var dealers = state.dealer.all;
  var offset = state.time.offset;


  var filteredOngoingOrders = (0, _orders2.getFilteredOngoingOrders)(state);
  var allOngoingOrders = (0, _orders2.getOngoingOrders)(state);

  return {
    dealers: dealers,
    filteredOngoingOrders: filteredOngoingOrders,
    allOngoingOrders: allOngoingOrders,
    activeOrder: order,
    offset: offset,
    userId: chamaID
  };
};

var mapDispatchToProps = {
  dismissOrder: _orders.dismissOrder,
  cancelDelivery: _orders.cancelDelivery,
  setCurrentOrder: _orders.setCurrentOrder
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_OngoingOrdersSection2.default));

/***/ }),

/***/ 3473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _OrderPanelSection = __webpack_require__(670);

var _OrderPanelSection2 = _interopRequireDefault(_OrderPanelSection);

var _reactIntl = __webpack_require__(16);

var _OngoingOrdersFilter = __webpack_require__(3474);

var _OngoingOrdersFilter2 = _interopRequireDefault(_OngoingOrdersFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var OngoingOrdersSection = function OngoingOrdersSection(_ref) {
  var intl = _ref.intl,
      filteredOngoingOrders = _ref.filteredOngoingOrders,
      allOngoingOrders = _ref.allOngoingOrders,
      props = _objectWithoutProperties(_ref, ['intl', 'filteredOngoingOrders', 'allOngoingOrders']);

  var labelComponent = filteredOngoingOrders.length === allOngoingOrders.length ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ordersinfo.orders-count', values: { count: allOngoingOrders.length } }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'orders.range',
    values: { total: allOngoingOrders.length, filtered: filteredOngoingOrders.length }
  });

  return _react2.default.createElement(_OrderPanelSection2.default, _extends({}, props, {
    orders: filteredOngoingOrders,
    intl: intl,
    filterComponent: _react2.default.createElement(_OngoingOrdersFilter2.default, { label: labelComponent }),
    sectionName: intl.formatMessage({ id: 'tickets_overview_beingdelivered' }),
    emptyMessage: intl.formatMessage({ id: 'tickets_overview_beingdelivered_empty_message' })
  }));
};

OngoingOrdersSection.propTypes = {
  intl: _propTypes2.default.object.isRequired,
  dealers: _propTypes2.default.object.isRequired,
  filteredOngoingOrders: _propTypes2.default.array.isRequired,
  allOngoingOrders: _propTypes2.default.array.isRequired,
  activeOrder: _propTypes2.default.object,
  offset: _propTypes2.default.number.isRequired,
  userId: _propTypes2.default.string.isRequired
};

OngoingOrdersSection.defaultProps = {
  activeOrder: null
};

exports.default = (0, _reactIntl.injectIntl)(OngoingOrdersSection);

/***/ }),

/***/ 3474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _OngoingOrdersFilter = __webpack_require__(3475);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OngoingOrdersFilter).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 3475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = __webpack_require__(207);

var _reactIntl = __webpack_require__(16);

var _reactSelect = __webpack_require__(662);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

__webpack_require__(3476);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var OngoingOrdersFilterReduxForm = function OngoingOrdersFilterReduxForm(_ref) {
  var intl = _ref.intl,
      props = _objectWithoutProperties(_ref, ['intl']);

  var options = [{ value: 'SHOW_ALL', label: intl.formatMessage({ id: 'orders.all' }) }, {
    value: 'SHOW_LATE_ORDERS',
    label: intl.formatMessage({ id: 'orders.late_orders' })
  }];
  return _react2.default.createElement(_reduxForm.Field, _extends({}, props, { name: 'orderType', component: OngoingOrdersFilter, options: options }));
};

OngoingOrdersFilterReduxForm.propTypes = {
  intl: _propTypes2.default.object.isRequired
};

var OngoingOrdersFilter = function OngoingOrdersFilter(_ref2) {
  var input = _ref2.input,
      options = _ref2.options,
      label = _ref2.label;
  return _react2.default.createElement(
    'div',
    { className: 'OngoingOrdersFilter' },
    _react2.default.createElement(
      'div',
      { className: 'OngoingOrdersFilter__label' },
      label
    ),
    _react2.default.createElement(_reactSelect2.default, _extends({}, input, {
      className: 'OngoingOrdersFilter__dropdown',
      onChange: function onChange(value) {
        return input.onChange(value);
      },
      onBlur: function onBlur() {
        return input.onBlur(input.value);
      },
      options: options,
      isSearchable: false,
      isClearable: false
    }))
  );
};

OngoingOrdersFilter.propTypes = {
  label: _propTypes2.default.node.isRequired,
  input: _propTypes2.default.object.isRequired,
  options: _propTypes2.default.array.isRequired
};

var intlComponent = (0, _reactIntl.injectIntl)(OngoingOrdersFilterReduxForm);

exports.default = (0, _reduxForm.reduxForm)({
  form: '@ORDERS/ONGOING',
  destroyOnUnmount: false,
  initialValues: {
    orderType: {
      value: 'SHOW_ALL',
      label: 'Todos os pedidos'
    }
  }
})(intlComponent);

/***/ }),

/***/ 3476:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3477:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(47);

var _orders = __webpack_require__(238);

var _OrdersTabs = __webpack_require__(3479);

var _OrdersTabs2 = _interopRequireDefault(_OrdersTabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedOrderQueue: state.orders.selectedOrderQueue
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, { switchOrderQueueView: _orders.switchOrderQueueView })(_OrdersTabs2.default);

/***/ }),

/***/ 3479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _orders = __webpack_require__(354);

var _Tabs = __webpack_require__(983);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  container: {
    backgroundColor: '#4a4a4a'
  },
  inkBarStyle: {
    height: 4
  },
  tab: {
    buttonStyle: {
      fontSize: 16,
      color: 'white'
    }
  }
};

var OrdersTabs = _react2.default.memo(function (_ref) {
  var selectedOrderQueue = _ref.selectedOrderQueue,
      switchOrderQueueView = _ref.switchOrderQueueView;

  return _react2.default.createElement(
    _Tabs.Tabs,
    {
      value: selectedOrderQueue,
      onChange: function onChange(value) {
        return switchOrderQueueView(value);
      },
      inkBarStyle: styles.inkBarStyle,
      tabItemContainerStyle: styles.container
    },
    _react2.default.createElement(_Tabs.Tab, {
      value: _orders.ORDERS_QUEUES.INCOMING,
      buttonStyle: styles.tab.buttonStyle,
      label: 'Novos Pedidos'
    }),
    _react2.default.createElement(_Tabs.Tab, {
      value: _orders.ORDERS_QUEUES.BEING_DELIVERED,
      buttonStyle: styles.tab.buttonStyle,
      label: 'Pedidos em andamento'
    }),
    _react2.default.createElement(_Tabs.Tab, {
      buttonStyle: styles.tab.buttonStyle,
      value: _orders.ORDERS_QUEUES.FINALIZED,
      label: 'Pedidos Concluidos'
    })
  );
});

exports.default = OrdersTabs;

/***/ }),

/***/ 3480:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRouter = __webpack_require__(49);

var NotFoundPage = function NotFoundPage(_ref) {
  var router = _ref.router;

  router.push('/');
  return null;
};

exports.default = (0, _reactRouter.withRouter)(NotFoundPage);

/***/ }),

/***/ 3482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(47);

var _reactIntl = __webpack_require__(16);

var _messages = __webpack_require__(587);

var _messages2 = _interopRequireDefault(_messages);

var _uiComponents = __webpack_require__(369);

var _Spinner = __webpack_require__(125);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _config = __webpack_require__(167);

var _config2 = _interopRequireDefault(_config);

var _dealers = __webpack_require__(352);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = __webpack_require__(1535);

var _DebugBar = __webpack_require__(3484);

var _DebugBar2 = _interopRequireDefault(_DebugBar);

var _ToastNotifications = __webpack_require__(3485);

var _ToastNotifications2 = _interopRequireDefault(_ToastNotifications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    locale: state.featureToggles.locale,
    firebaseConnected: state.firebase.connected,
    userId: state.auth.chamaID,
    featuresFetched: state.features.featuresFetched
  };
};

var mapDispatchToProps = {
  startListeningToDealers: _dealers.startListeningToDealers,
  startListeningToFeatures: _redux.startListeningToFeatures
};

var App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
  }

  _createClass(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.startListeningToDealers();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _props = this.props,
          featuresFetched = _props.featuresFetched,
          userId = _props.userId;

      if (!featuresFetched && userId) {
        this.props.startListeningToFeatures();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          firebaseConnected = _props2.firebaseConnected,
          locale = _props2.locale,
          content = _props2.content;


      var loading = void 0;

      if (!firebaseConnected) {
        loading = _react2.default.createElement(
          _Spinner2.default,
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'loading' })
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactIntl.IntlProvider,
          { locale: locale, key: locale, messages: _messages2.default[locale] },
          _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(_ToastNotifications2.default, { fixed: true }),
            loading || content
          )
        ),
        _react2.default.createElement(_DebugBar2.default, null),
        _react2.default.createElement(_uiComponents.Segment, { apiKey: _config2.default.segment.apiKey })
      );
    }
  }]);

  return App;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);


App.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  content: _propTypes2.default.object.isRequired,
  firebaseConnected: _propTypes2.default.bool.isRequired,
  startListeningToDealers: _propTypes2.default.func.isRequired,
  startListeningToFeatures: _propTypes2.default.func.isRequired,
  userId: _propTypes2.default.string,
  featuresFetched: _propTypes2.default.bool.isRequired
};
App.defaultProps = {
  userId: null
};

/***/ }),

/***/ 3483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _splitio = __webpack_require__(1229);

var _config = __webpack_require__(167);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/no-unresolved
var factory = (0, _splitio.SplitFactory)({
  core: {
    key: 'anonymous',
    authorizationKey: _config2.default.splitio.apiKey
  },
  startup: {
    readyTimeout: 1.5 // in seconds
  }
});

exports.default = factory;

/***/ }),

/***/ 3484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(47);

var _reactRouter = __webpack_require__(49);

var _DebugBar = __webpack_require__(1048);

var _DebugBar2 = _interopRequireDefault(_DebugBar);

var _featureToggles = __webpack_require__(1536);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    debuggingEnabled: state.featureToggles.debuggingEnabled,
    locale: state.featureToggles.locale
  };
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, {
  enableDebugging: _featureToggles.enableDebugging,
  disableDebugging: _featureToggles.disableDebugging,
  setLocale: _featureToggles.setLocale
})(_DebugBar2.default));

/***/ }),

/***/ 3485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(47);

var _reactIntl = __webpack_require__(16);

var _toastsSelectors = __webpack_require__(1523);

var _Notifications = __webpack_require__(3486);

var _Notifications2 = _interopRequireDefault(_Notifications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
  var formatMessage = ownProps.intl.formatMessage;


  var messageToText = function messageToText(message) {
    if (typeof message === 'string') return message;
    return formatMessage({ id: message.id });
  };

  var notifications = (0, _toastsSelectors.getToastNotifications)(state).filter(function (toastNotification) {
    return toastNotification && toastNotification.message;
  }).map(function (_ref) {
    var id = _ref.id,
        message = _ref.message,
        type = _ref.type;
    return {
      id: id,
      text: messageToText(message),
      icon: type
    };
  });

  return {
    notifications: notifications
  };
}

exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps)(_Notifications2.default));

/***/ }),

/***/ 3486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Notifications = __webpack_require__(3487);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Notifications).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 3487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Notifications;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTransitionGroup = __webpack_require__(126);

var _Notification = __webpack_require__(3488);

var _Notification2 = _interopRequireDefault(_Notification);

__webpack_require__(3490);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Notifications(_ref) {
  var className = _ref.className,
      notifications = _ref.notifications,
      fixed = _ref.fixed,
      orientation = _ref.orientation;

  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)('Notifications', className, {
        'Notifications--fixed': fixed,
        'Notifications--right': orientation === 'right',
        'Notifications--left': orientation === 'left'
      })
    },
    _react2.default.createElement(
      _reactTransitionGroup.CSSTransitionGroup,
      {
        component: 'div',
        className: (0, _classnames2.default)('Notifications__list', {
          'Notifications__list--right': orientation === 'right',
          'Notifications__list--left': orientation === 'left'
        }),
        transitionName: 'Notification',
        transitionEnterTimeout: 1000,
        transitionLeaveTimeout: 500
      },
      notifications.map(function (notification) {
        return _react2.default.createElement(_Notification2.default, {
          key: 'notification_' + notification.id,
          text: notification.text,
          icon: notification.icon
        });
      })
    )
  );
}

Notifications.propTypes = {
  className: _propTypes2.default.string,
  notifications: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    text: _propTypes2.default.string.isRequired,
    icon: _propTypes2.default.string
  })),
  fixed: _propTypes2.default.bool,
  orientation: _propTypes2.default.oneOf(['right', 'left'])
};
Notifications.defaultProps = {
  className: null,
  notifications: [],
  fixed: false,
  orientation: 'right'
};

/***/ }),

/***/ 3488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Notification;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = __webpack_require__(272);

var _Icon2 = _interopRequireDefault(_Icon);

__webpack_require__(3489);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Notification(_ref) {
  var text = _ref.text,
      icon = _ref.icon;

  return _react2.default.createElement(
    'div',
    { className: 'Notification' },
    _react2.default.createElement(
      'div',
      { className: 'Notification__container' },
      _react2.default.createElement(
        'div',
        { className: 'Notification__icon' },
        _react2.default.createElement(_Icon2.default, { width: 16, height: 16, type: icon, iconColor: 'white' })
      ),
      _react2.default.createElement(
        'div',
        { className: 'Notification__text' },
        text
      )
    )
  );
}
Notification.defaultProps = {
  icon: 'checkmark'
};
Notification.propTypes = {
  text: _propTypes2.default.string.isRequired,
  icon: _propTypes2.default.string
};

/***/ }),

/***/ 3489:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3490:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3491:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./auth/routes.jsx": 3492,
	"./orders/routes.jsx": 3503
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3491;

/***/ }),

/***/ 3492:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(49);

var _index = __webpack_require__(3493);

var _index2 = _interopRequireDefault(_index);

var _Logout = __webpack_require__(3500);

var _Logout2 = _interopRequireDefault(_Logout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createElement(
  _reactRouter.Route,
  { key: 'auth-route' },
  _react2.default.createElement(_reactRouter.Route, { key: 'login-route', path: 'login', components: { content: _index2.default } }),
  _react2.default.createElement(_reactRouter.Route, { key: 'logout-route', path: 'logout', components: { content: _Logout2.default } })
);

/***/ }),

/***/ 3493:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Auth = __webpack_require__(3494);

var _Auth2 = _interopRequireDefault(_Auth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Auth2.default;

/***/ }),

/***/ 3494:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Login = __webpack_require__(3495);

var _Login2 = _interopRequireDefault(_Login);

__webpack_require__(3499);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    'div',
    { className: 'Auth' },
    _react2.default.createElement(_Login2.default, null)
  );
};

/***/ }),

/***/ 3495:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Login = __webpack_require__(3496);

var _Login2 = _interopRequireDefault(_Login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Login2.default;

/***/ }),

/***/ 3496:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(47);

var _Login = __webpack_require__(3497);

var _Login2 = _interopRequireDefault(_Login);

var _redux = __webpack_require__(462);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    loading: state.auth.loading,
    success: state.auth.success,
    error: state.auth.error
  };
};

var mapDispatchToProps = {
  onLogin: _redux.login
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Login2.default);

/***/ }),

/***/ 3497:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _reactRouter = __webpack_require__(49);

var _Button = __webpack_require__(127);

var _Button2 = _interopRequireDefault(_Button);

var _Logo = __webpack_require__(1054);

var _Logo2 = _interopRequireDefault(_Logo);

__webpack_require__(3498);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var translateErrors = function translateErrors(_ref, formatMessage) {
  var code = _ref.code;

  var message = void 0;
  switch (code) {
    case 'auth/popup-closed-by-user':
      message = formatMessage({
        id: 'login_error_closed_modal',
        defaultMessage: 'Oops, you closed the popup'
      });
      break;
    case 'unauthorised':
      message = formatMessage({
        id: 'login_error_unauthorised',
        defaultMessage: "You don't have permission"
      });
      break;
    default:
      message = formatMessage({
        id: 'generic_error_message',
        defaultMessage: 'Oops, unknown error'
      });
      break;
  }
  return message;
};

var Login = function Login(_ref2) {
  var loading = _ref2.loading,
      success = _ref2.success,
      error = _ref2.error,
      onLogin = _ref2.onLogin,
      router = _ref2.router,
      formatMessage = _ref2.intl.formatMessage;

  if (success) {
    router.push('/');
    return null;
  }

  var errorMessage = null;
  if (error) errorMessage = _react2.default.createElement(
    'div',
    { className: 'Login__errors' },
    translateErrors(error, formatMessage)
  );

  return _react2.default.createElement(
    'div',
    { className: 'Login' },
    _react2.default.createElement(
      'div',
      { className: 'Login__logo-container' },
      _react2.default.createElement(_Logo2.default, null)
    ),
    _react2.default.createElement(
      'div',
      { className: 'Login__greeting' },
      formatMessage({
        id: 'login_title',
        defaultMessage: 'Sign in to continue to the Chama dealer tool'
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'Login__gbutton-container' },
      _react2.default.createElement(
        _Button2.default,
        { onClick: onLogin, id: 'login-submit-btn', fullWidth: true, type: 'submit', isLoading: loading },
        formatMessage({
          id: 'login_button_sign_in',
          defaultMessage: 'Log in'
        })
      )
    ),
    errorMessage
  );
};

Login.propTypes = {
  loading: _propTypes2.default.bool.isRequired,
  onLogin: _propTypes2.default.func.isRequired,
  success: _propTypes2.default.bool.isRequired,
  error: _propTypes2.default.any.isRequired,
  router: _propTypes2.default.object.isRequired
};

exports.default = (0, _reactRouter.withRouter)((0, _reactIntl.injectIntl)(Login));

/***/ }),

/***/ 3498:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3499:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3500:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Logout = __webpack_require__(3501);

var _Logout2 = _interopRequireDefault(_Logout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Logout2.default;

/***/ }),

/***/ 3501:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(47);

var _redux = __webpack_require__(462);

var _Logout = __webpack_require__(3502);

var _Logout2 = _interopRequireDefault(_Logout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = {
  onLogout: _redux.logout
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_Logout2.default);

/***/ }),

/***/ 3502:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Logout = function (_Component) {
  _inherits(Logout, _Component);

  function Logout() {
    _classCallCheck(this, Logout);

    return _possibleConstructorReturn(this, (Logout.__proto__ || Object.getPrototypeOf(Logout)).apply(this, arguments));
  }

  _createClass(Logout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          onLogout = _props.onLogout,
          router = _props.router;

      onLogout();
      router.push('/');
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Logout;
}(_react.Component);

Logout.defaultProps = {
  onLogout: function onLogout() {
    return null;
  }
};
Logout.propTypes = {
  onLogout: _propTypes2.default.func,
  router: _propTypes2.default.object.isRequired
};
exports.default = (0, _reactRouter.withRouter)(Logout);

/***/ }),

/***/ 3503:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(49);

var _requireAuthentication = __webpack_require__(1534);

var _requireAuthentication2 = _interopRequireDefault(_requireAuthentication);

var _Orders = __webpack_require__(1524);

var _Orders2 = _interopRequireDefault(_Orders);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createElement(_reactRouter.Route, {
  key: 'orders-route',
  path: 'orders',
  components: {
    content: (0, _requireAuthentication2.default)(_Orders2.default)
  }
});

/***/ }),

/***/ 3504:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(246);

var _reduxThunk = __webpack_require__(1513);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxLogger = __webpack_require__(1512);

var _reducer = __webpack_require__(3505);

var _reducer2 = _interopRequireDefault(_reducer);

var _lodash = __webpack_require__(544);

var _lodash2 = _interopRequireDefault(_lodash);

var _localStorage = __webpack_require__(408);

var _versionHandler = __webpack_require__(3521);

var _versionHandler2 = _interopRequireDefault(_versionHandler);

var _time = __webpack_require__(1533);

var _redux2 = __webpack_require__(462);

var _firebase = __webpack_require__(1538);

var _apiConnectivity = __webpack_require__(1537);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var configureStore = function configureStore(_ref) {
  var firebaseClient = _ref.firebaseClient,
      api = _ref.api,
      applicationFacade = _ref.applicationFacade;

  var inititalState = (0, _localStorage.loadState)();
  var logger = (0, _reduxLogger.createLogger)({
    predicate: function predicate(getState, action) {
      // only log when debugging is enabled
      if (!getState().featureToggles.debuggingEnabled) {
        return false;
      }
      if (action.type === _time.SET_CURRENT_TIME) {
        // don't spam the console with exhaustive 'SET_CURRENT_TIME' actions
        console.log('action SET_CURRENT_TIME');
        return false;
      }

      return true;
    }
  });

  var thunkWithApi = _reduxThunk2.default.withExtraArgument({
    api: api,
    firebaseClient: firebaseClient,
    applicationFacade: applicationFacade
  });
  var middlewares = (0, _redux.applyMiddleware)(thunkWithApi, logger);
  // eslint-disable-next-line no-underscore-dangle
  var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
  var enhancers =  false ? composeEnhancers(middlewares) : middlewares;
  var store = (0, _redux.createStore)(_reducer2.default, inititalState, enhancers);

  api.onRetryScheduled(function (t) {
    store.dispatch((0, _apiConnectivity.apiRetryScheduled)(t));
  });

  api.onRetrySucceeded(function () {
    store.dispatch((0, _apiConnectivity.apiRetrySucceeded)());
  });

  firebaseClient.onConnectionStateChange(function (connected) {
    if (connected) {
      store.dispatch((0, _firebase.firebaseConnected)());
    } else {
      store.dispatch((0, _firebase.firebaseDisconnected)());
    }
  });

  firebaseClient.onTokenChanged(function (user) {
    if (user) {
      store.dispatch((0, _redux2.updateToken)(user));
      store.dispatch((0, _firebase.firebaseAuthenticated)(user.uid));
    } else {
      store.dispatch((0, _firebase.firebaseUnAuthenticated)());
    }
  });

  firebaseClient.onServerTimeOffsetChanged(function (offset) {
    store.dispatch((0, _time.setServerTimeOffset)(offset));
  });

  firebaseClient.onVersionChanged(_versionHandler2.default);

  store.subscribe((0, _lodash2.default)(function () {
    var state = store.getState();
    var featureToggles = state.featureToggles,
        reminders = state.reminders;


    (0, _localStorage.saveState)({
      featureToggles: featureToggles,
      reminders: reminders
    });
  }, 1000));

  return store;
};

exports.default = configureStore;

/***/ }),

/***/ 3505:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(246);

var _redux2 = __webpack_require__(462);

var _redux3 = _interopRequireDefault(_redux2);

var _redux4 = __webpack_require__(1535);

var _redux5 = _interopRequireDefault(_redux4);

var _apiConnectivity = __webpack_require__(3506);

var _apiConnectivity2 = _interopRequireDefault(_apiConnectivity);

var _time = __webpack_require__(1532);

var _time2 = _interopRequireDefault(_time);

var _orders = __webpack_require__(354);

var _orders2 = _interopRequireDefault(_orders);

var _user = __webpack_require__(3507);

var _user2 = _interopRequireDefault(_user);

var _featureToggles = __webpack_require__(3508);

var _featureToggles2 = _interopRequireDefault(_featureToggles);

var _firebase = __webpack_require__(3509);

var _firebase2 = _interopRequireDefault(_firebase);

var _dealer = __webpack_require__(3510);

var _dealer2 = _interopRequireDefault(_dealer);

var _reminders = __webpack_require__(3511);

var _reminders2 = _interopRequireDefault(_reminders);

var _notifications = __webpack_require__(3513);

var _notifications2 = _interopRequireDefault(_notifications);

var _toasts = __webpack_require__(1522);

var _toasts2 = _interopRequireDefault(_toasts);

var _form = __webpack_require__(1531);

var _form2 = _interopRequireDefault(_form);

var _orderHistory = __webpack_require__(3515);

var _orderHistory2 = _interopRequireDefault(_orderHistory);

var _orderEventHistory = __webpack_require__(3517);

var _orderEventHistory2 = _interopRequireDefault(_orderEventHistory);

var _orderSound = __webpack_require__(3518);

var _orderSound2 = _interopRequireDefault(_orderSound);

var _drivers = __webpack_require__(3519);

var _drivers2 = _interopRequireDefault(_drivers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rootReducer = (0, _redux.combineReducers)({
  apiConnectivity: _apiConnectivity2.default,
  time: _time2.default,
  orders: _orders2.default,
  user: _user2.default,
  featureToggles: _featureToggles2.default,
  firebase: _firebase2.default,
  dealer: _dealer2.default,
  reminders: _reminders2.default,
  toasts: _toasts2.default,
  notifications: _notifications2.default,
  form: _form2.default,
  orderHistory: _orderHistory2.default,
  orderEventHistory: _orderEventHistory2.default,
  orderSound: _orderSound2.default,
  drivers: _drivers2.default,
  auth: _redux3.default,
  features: _redux5.default
});

exports.default = rootReducer;

/***/ }),

/***/ 3506:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiConnectivity = __webpack_require__(1537);

var initialState = {
  connected: true
};

var apiConnectivity = function apiConnectivity() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _apiConnectivity.API_RETRY_SCHEDULED:
      return {
        connected: false
      };
    case _apiConnectivity.API_RETRY_SUCCEEDED:
      return {
        connected: true
      };
    default:
      return state;
  }
};

exports.default = apiConnectivity;

/***/ }),

/***/ 3507:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(491);

var _lodash2 = _interopRequireDefault(_lodash);

var _user = __webpack_require__(353);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isAuthenticated: false,
  customerServiceAdminAccounts: {}
};

var user = function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _user.SET_CS_ADMIN_ACCOUNTS:
      return _extends({}, state, {
        customerServiceAdminAccounts: action.customerServiceAdminAccounts
      });

    case _user.GET_USER_KIND:
      return _extends({}, state, {
        kind: action.kind
      });

    case _user.LOGIN_SUCCESS:
      var account = action.account,
          username = action.username,
          password = action.password;

      return _extends({}, state, {
        account: account,
        username: username,
        password: password,
        isAuthenticated: true
      });

    case _user.UNSET_ACCOUNT:
      return (0, _lodash2.default)(state, 'account');

    case _user.LOGOUT:
      return {
        account: state.account,
        isAuthenticated: false
      };

    default:
      return state;
  }
};

exports.default = user;

/***/ }),

/***/ 3508:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _featureToggles = __webpack_require__(1536);

var initialState = {
  firebaseAuthEnabled: false,
  firebaseDbEnabled: false,
  apiJwtEnabled: false,
  debuggingEnabled: false,
  locale: 'pt-BR'
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var firebaseAuthEnabled = !state.firebaseAuthEnabled;
  var firebaseDbEnabled = !state.firebaseDbEnabled;
  var apiJwtEnabled = !state.apiJwtEnabled;

  switch (action.type) {
    case _featureToggles.TOGGLE_FIREBASE_AUTH:
      return _extends({}, state, {
        firebaseAuthEnabled: firebaseAuthEnabled
      });

    case _featureToggles.TOGGLE_FIREBASE_DB:
      return _extends({}, state, {
        firebaseDbEnabled: firebaseDbEnabled
      });

    case _featureToggles.TOGGLE_API_JWT:
      return _extends({}, state, {
        apiJwtEnabled: apiJwtEnabled
      });

    case _featureToggles.ENABLE_DEBUGGING:
      return _extends({}, state, {
        debuggingEnabled: true
      });

    case _featureToggles.DISABLE_DEBUGGING:
      return initialState;

    case _featureToggles.SET_LOCALE:
      return _extends({}, state, {
        locale: action.locale
      });

    default:
      return state;
  }
};

/***/ }),

/***/ 3509:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _firebase = __webpack_require__(1538);

var initialState = {
  connected: false,
  connectedAtLeastOnce: false,
  previousConnectionStatusChangeAt: Date.now(),
  authenticated: undefined
};

var firebase = function firebase() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _firebase.FIREBASE_CONNECTED:
      if (state.connected) {
        return state;
      }
      return _extends({}, state, {
        connected: true,
        connectedAtLeastOnce: true,
        previousConnectionStatusChangeAt: Date.now()
      });
    case _firebase.FIREBASE_DISCONNECTED:
      if (!state.connected) {
        return state;
      }
      return _extends({}, state, {
        connected: false,
        previousConnectionStatusChangeAt: Date.now()
      });
    case _firebase.FIREBASE_AUTHENTICATED:
      return _extends({}, state, {
        authenticated: true,
        uid: action.uid
      });
    case _firebase.FIREBASE_UNAUTHENTICATED:
      return _extends({}, state, {
        authenticated: false,
        uid: undefined
      });
    default:
      return state;
  }
};

exports.default = firebase;

/***/ }),

/***/ 3510:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _stringToHash = __webpack_require__(1223);

var _stringToHash2 = _interopRequireDefault(_stringToHash);

var _lodash = __webpack_require__(141);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(140);

var _lodash4 = _interopRequireDefault(_lodash3);

var _dealers = __webpack_require__(352);

var _user = __webpack_require__(353);

var _isDealerBlockedOrSuspended = __webpack_require__(407);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MAX_NUMBER_OF_BUCKETS = 10;
var initialState = {
  all: {},
  filteredAll: {},
  termsAndConditions: undefined,
  isFetching: false,
  filters: [],
  numberOfBuckets: 0,
  nearby: {
    lat: undefined,
    lon: undefined,
    dict: {}
  },
  suspended: [],
  blocked: []
};

var createDealerDictionary = function createDealerDictionary(dealerList) {
  var reduceDealers = function reduceDealers(accum, dealer) {
    return _extends({}, accum, _defineProperty({}, dealer.id, dealer));
  };

  return dealerList.reduce(reduceDealers, {});
};

var getActiveDealers = function getActiveDealers(activeFilters, dividedDealerList) {
  var reduceActiveDealers = function reduceActiveDealers(accum, filter) {
    var bucket = dividedDealerList[filter];

    return [].concat(_toConsumableArray(accum), _toConsumableArray(bucket));
  };

  return activeFilters.reduce(reduceActiveDealers, []);
};

var cleanActiveFilters = function cleanActiveFilters(activeFilters, oldNumberOfBuckets, newNumberOfBuckets) {
  var newActiveFilters = _extends({}, activeFilters);
  var removeFilter = oldNumberOfBuckets - newNumberOfBuckets;

  while (removeFilter < oldNumberOfBuckets) {
    if (newActiveFilters.indexOf(removeFilter) !== -1) {
      newActiveFilters.splice(newActiveFilters.indexOf(removeFilter), 1);
    }

    removeFilter += 1;
  }

  return newActiveFilters;
};

var divideDealers = function divideDealers() {
  var dealerList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var numberOfBuckets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var activeFilters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var newDividedDealersList = [];
  var fillDealerList = function fillDealerList(dealer) {
    // Transform 'dealerId + dealerId + dealerId' to an integer.
    var dealerHashCode = (0, _stringToHash2.default)('' + dealer.id + dealer.id + dealer.id);
    // Assign each dealer to a 'filter bucket' based on its 'hashCode'.
    var filterBucket = dealerHashCode % MAX_NUMBER_OF_BUCKETS;
    // If 'filterBucket' is a negative integer. We'll transform in into a positive integer.
    filterBucket = filterBucket < 0 ? MAX_NUMBER_OF_BUCKETS + filterBucket : filterBucket;

    newDividedDealersList[filterBucket].push(dealer);
  };

  // Push empty 'buckets' to 'newDividedDealersList'.
  for (var i = 0; i < MAX_NUMBER_OF_BUCKETS; i += 1) {
    newDividedDealersList.push([]);
  }

  // We're now going to fill the empty 'buckets' with dealers.
  dealerList.forEach(fillDealerList);

  // Remove 'buckets' that are still empty.
  newDividedDealersList = newDividedDealersList.filter(function (bucket) {
    return bucket.length;
  });

  /**
   * Update the number of filter buckets,
   * when we've created a new divided dealers list.
   *
   * @event FilterTicketsAgent#numberOfBucketsChanged
   * @private
   */
  var oldNumberOfBuckets = numberOfBuckets;
  var newNumberOfBuckets = newDividedDealersList.length;
  var filteredDealerList = activeFilters.length ? getActiveDealers(activeFilters, newDividedDealersList) : dealerList;

  // Clean our 'active filters' if we have fewer filter buckets than before.
  if (newNumberOfBuckets < oldNumberOfBuckets) {
    return {
      filteredAll: createDealerDictionary(filteredDealerList),
      numberOfBuckets: newNumberOfBuckets,
      filters: cleanActiveFilters(dealerList, oldNumberOfBuckets, newNumberOfBuckets)
    };
  }

  return {
    filteredAll: createDealerDictionary(filteredDealerList),
    numberOfBuckets: newNumberOfBuckets,
    filters: activeFilters
  };
};

var updateSeveralDealers = function updateSeveralDealers(currentStateDealersDict, updatedDealerList) {
  var dealerInArray = function dealerInArray(dealerId) {
    return function (dealer) {
      return dealer.id === dealerId;
    };
  };
  var toUpdateDealers = function toUpdateDealers(accum, dealerId) {
    var updatedCurrentDealer = updatedDealerList.find(dealerInArray(dealerId));

    if (updatedCurrentDealer) {
      return _extends({}, accum, _defineProperty({}, dealerId, _extends({}, currentStateDealersDict[dealerId], updatedCurrentDealer)));
    }

    return accum;
  };

  if (updatedDealerList.length) {
    return (0, _lodash2.default)(currentStateDealersDict).reduce(toUpdateDealers, currentStateDealersDict);
  }

  return currentStateDealersDict;
};

var groupIntoSuspendedOrBlocked = function groupIntoSuspendedOrBlocked(dealers, _ref) {
  var _ref$suspended = _ref.suspended,
      suspended = _ref$suspended === undefined ? [] : _ref$suspended,
      _ref$blocked = _ref.blocked,
      blocked = _ref$blocked === undefined ? [] : _ref$blocked;
  return dealers.reduce(function (acc, item) {
    if ((0, _isDealerBlockedOrSuspended.isBlocked)(item)) {
      if (!blocked.includes(item.id)) {
        return _extends({}, acc, {
          suspended: acc.suspended.filter(function (suspendedItem) {
            return suspendedItem !== item.id;
          }),
          blocked: acc.blocked.concat(item.id)
        });
      }
      return acc;
    }
    if ((0, _isDealerBlockedOrSuspended.isSuspended)(item)) {
      if (!suspended.includes(item.id)) {
        return _extends({}, acc, {
          suspended: acc.suspended.concat(item.id),
          blocked: acc.blocked.filter(function (blockedItem) {
            return blockedItem !== item.id;
          })
        });
      }
      return acc;
    }
    return _extends({}, acc, {
      suspended: acc.suspended.filter(function (suspendedItem) {
        return suspendedItem !== item.id;
      }),
      blocked: acc.blocked.filter(function (blockedItem) {
        return blockedItem !== item.id;
      })
    });
  }, { suspended: suspended, blocked: blocked });
};

var dealer = function dealer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _dealers.FETCH_DEALER_DATA:
      return _extends({}, state, divideDealers(action.dealers, state.numberOfBuckets, state.filters), {
        all: createDealerDictionary(action.dealers),
        isFetching: false
      }, groupIntoSuspendedOrBlocked(action.dealers, {
        suspended: state.suspended,
        blocked: state.blocked
      }));

    case _dealers.ADD_DEALER_DATA:
      {
        var newDealerList = [action.dealer].concat(_toConsumableArray(Object.values(state.all)));
        return _extends({}, state, divideDealers(newDealerList, state.numberOfBuckets, state.filters), {
          all: createDealerDictionary(newDealerList),
          isFetching: false
        }, groupIntoSuspendedOrBlocked(newDealerList, {
          suspended: state.suspended,
          blocked: state.blocked
        }));
      }

    case _dealers.UPDATE_SEVERAL_DEALERS:
      return _extends({}, state, {
        all: updateSeveralDealers(state.all, action.updatedDealerList),
        filteredAll: updateSeveralDealers(state.filteredAll, action.updatedDealerList),
        isFetching: false
      }, groupIntoSuspendedOrBlocked(action.updatedDealerList, {
        suspended: state.suspended,
        blocked: state.blocked
      }));

    case _dealers.UPDATE_DEALER_DATA:
      return _extends({}, state, {
        all: _extends({}, state.all, _defineProperty({}, action.updatedDealer.id, _extends({}, state.all[action.updatedDealer.id], action.updatedDealer))),
        filteredAll: _extends({}, state.filteredAll, _defineProperty({}, action.updatedDealer.id, _extends({}, state.filteredAll[action.updatedDealer.id], action.updatedDealer))),
        isFetching: false
      }, groupIntoSuspendedOrBlocked([action.updatedDealer], {
        suspended: state.suspended,
        blocked: state.blocked
      }));

    case _dealers.DEALER_LOADING:
      return _extends({}, state, {
        isFetching: true
      });

    case _dealers.GET_NEARBY_DEALERS:
      return _extends({}, state, {
        nearby: {
          lat: action.lat,
          lon: action.lon,
          dict: createDealerDictionary(action.dealers)
        }
      });

    case _user.LOGOUT:
      return _extends({}, initialState);

    case _dealers.ADD_FILTER:
      return _extends({}, state, divideDealers((0, _lodash4.default)(state.all), state.numberOfBuckets, [].concat(_toConsumableArray(state.filters), [action.number])));

    case _dealers.REMOVE_FILTER:
      return _extends({}, state, divideDealers((0, _lodash4.default)(state.all), state.numberOfBuckets, [].concat(_toConsumableArray(state.filters.slice(0, action.indexOfFilter)), _toConsumableArray(state.filters.slice(action.indexOfFilter + 1)))));

    default:
      return state;
  }
};

exports.default = dealer;

/***/ }),

/***/ 3511:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reminders = __webpack_require__(3512);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  all: {}
};

var currentTime = function currentTime() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _reminders.ADD_REMINDER:
      return _extends({}, state, {
        all: _extends({}, state.all, _defineProperty({}, action.id, {
          setRemindDate: action.setRemindDate,
          toRemindDate: action.toRemindDate,
          message: action.message,
          linkTo: action.linkTo
        }))
      });
    default:
      return state;
  }
};

exports.default = currentTime;

/***/ }),

/***/ 3512:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADD_REMINDER = exports.ADD_REMINDER = 'ADD_REMINDER';

var addReminder = exports.addReminder = function addReminder(id, setRemindDate, toRemindDate, message, linkTo) {
  return function (dispatch) {
    dispatch({
      type: ADD_REMINDER,
      id: id,
      setRemindDate: setRemindDate,
      toRemindDate: toRemindDate,
      message: message,
      linkTo: linkTo
    });
  };
};

/***/ }),

/***/ 3513:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _notifications = __webpack_require__(3514);

var initialState = {
  current: {}
};

var notifications = function notifications() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _notifications.NOTIFY:
      return _extends({}, state, {
        current: {
          id: action.id,
          message: action.message,
          error: action.error
        }
      });
    default:
      return state;
  }
};

exports.default = notifications;

/***/ }),

/***/ 3514:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var NOTIFY = exports.NOTIFY = 'NOTIFY';

var notify = exports.notify = function notify(message) {
  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch) {
    var id = new Date().getTime();

    dispatch({
      type: NOTIFY,
      id: id,
      message: message,
      error: error
    });
  };
};

/***/ }),

/***/ 3515:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _orderHistory = __webpack_require__(3516);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getPeriodId = function getPeriodId(periodStart, periodEnd, dealerId) {
  if (dealerId) {
    return periodStart + '|' + periodEnd + '@' + dealerId;
  }

  return periodStart + '|' + periodEnd;
};

var transformOrderListIntoDict = function transformOrderListIntoDict(state, orders) {
  var ordersIntoDict = function ordersIntoDict(accum, order) {
    var id = order.orderId;

    return _extends({}, accum, _defineProperty({}, id, _extends({}, order, {
      id: id,
      isFetchingDetails: false
    })));
  };

  return orders.reduce(ordersIntoDict, state);
};

var transformPeriodListIntoDict = function transformPeriodListIntoDict(state, periods, dealerId) {
  var periodsIntoDict = function periodsIntoDict(accum, period) {
    var periodId = getPeriodId(period.periodStartTime, period.periodEndTime, dealerId);

    return _extends({}, accum, _defineProperty({}, periodId, _extends({}, period, {
      id: periodId,
      isFetchingOrders: false,
      orders: {}
    })));
  };

  return periods.reduce(periodsIntoDict, state);
};

var order = function order(state, action) {
  switch (action.type) {
    case _orderHistory.START_FETCHING_HISTORY_ORDER_DETAILS:
      return _extends({}, state, {
        isFetchingDetails: true
      });

    case _orderHistory.SUCCESS_FETCHING_HISTORY_ORDER_DETAILS:
      return _extends({}, state, {
        details: action.orderDetails,
        isFetchingDetails: false
      });

    case _orderHistory.ERROR_FETCHING_HISTORY_ORDER_DETAILS:
      return _extends({}, state, {
        isFetchingDetails: false
      });

    default:
      return state;
  }
};

var period = function period(state, action) {
  switch (action.type) {
    case _orderHistory.START_FETCHING_ORDER_HISTORY:
      return _extends({}, state, {
        isFetchingOrders: true
      });

    case _orderHistory.SUCCESS_FETCHING_ORDER_HISTORY:
      return _extends({}, state, {
        orders: transformOrderListIntoDict(state.orders, action.orders.list),
        nextBatchHref: action.orders.nextBatchHref,
        isFetchingOrders: false
      });

    case _orderHistory.ERROR_FETCHING_ORDER_HISTORY:
      return _extends({}, state, {
        isFetchingOrders: false
      });

    case _orderHistory.START_FETCHING_HISTORY_ORDER_DETAILS:
      return _extends({}, state, {
        orders: _extends({}, state.orders, _defineProperty({}, action.orderId, order(state.orders[action.orderId], action)))
      });

    case _orderHistory.SUCCESS_FETCHING_HISTORY_ORDER_DETAILS:
      return _extends({}, state, {
        orders: _extends({}, state.orders, _defineProperty({}, action.orderId, order(state.orders[action.orderId], action)))
      });

    case _orderHistory.ERROR_FETCHING_HISTORY_ORDER_DETAILS:
      return _extends({}, state, {
        orders: _extends({}, state.orders, _defineProperty({}, action.orderId, order(state.orders[action.orderId], action)))
      });
    default:
      return state;
  }
};

var initialState = {
  isFetchingPeriods: false,
  isFetchingMorePeriods: false,
  isDownloading: false,
  fileError: false,
  fileErrorCode: null,
  nextBatchHref: null,
  periods: {}
};

var orderHistory = function orderHistory() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    /* ORDER HISTORY PERIODS */
    case _orderHistory.START_FETCHING_ORDER_PERIODS:
      return _extends({}, state, {
        isFetchingPeriods: true
      });

    case _orderHistory.SUCCESS_FETCHING_ORDER_PERIODS:
      return _extends({}, state, {
        periods: transformPeriodListIntoDict({}, action.periods, action.dealerId),
        nextBatchHref: action.nextBatchHref,
        isFetchingPeriods: false
      });

    case _orderHistory.START_FETCHING_MORE_ORDER_PERIODS:
      return _extends({}, state, {
        isFetchingMorePeriods: true
      });

    case _orderHistory.ERROR_FETCHING_MORE_ORDER_PERIODS:
      return _extends({}, state, {
        isFetchingMorePeriods: false
      });

    case _orderHistory.SUCCESS_FETCHING_MORE_ORDER_PERIODS:
      return _extends({}, state, {
        periods: transformPeriodListIntoDict(state.periods, action.periods, action.dealerId),
        nextBatchHref: action.nextBatchHref,
        isFetchingMorePeriods: false
      });

    case _orderHistory.ERROR_FETCHING_ORDER_PERIODS:
      return _extends({}, state, {
        isFetchingPeriods: false
      });

    /* ORDER HISTORY FOR A PARTICULAR PERIOD */
    case _orderHistory.START_FETCHING_ORDER_HISTORY:
      return _extends({}, state, {
        periods: _extends({}, state.periods, _defineProperty({}, action.periodId, period(state.periods[action.periodId], action)))
      });

    case _orderHistory.SUCCESS_FETCHING_ORDER_HISTORY:
      return _extends({}, state, {
        periods: _extends({}, state.periods, _defineProperty({}, action.periodId, period(state.periods[action.periodId], action)))
      });

    case _orderHistory.ERROR_FETCHING_ORDER_HISTORY:
      return _extends({}, state, {
        periods: _extends({}, state.periods, _defineProperty({}, action.periodId, period(state.periods[action.periodId], action)))
      });

    /* HISTORY ORDER DETAILS */
    case _orderHistory.START_FETCHING_HISTORY_ORDER_DETAILS:
      return _extends({}, state, {
        periods: _extends({}, state.periods, _defineProperty({}, action.periodId, period(state.periods[action.periodId], action)))
      });

    case _orderHistory.SUCCESS_FETCHING_HISTORY_ORDER_DETAILS:
      return _extends({}, state, {
        periods: _extends({}, state.periods, _defineProperty({}, action.periodId, period(state.periods[action.periodId], action)))
      });

    case _orderHistory.ERROR_FETCHING_HISTORY_ORDER_DETAILS:
      return _extends({}, state, {
        periods: _extends({}, state.periods, _defineProperty({}, action.periodId, period(state.periods[action.periodId], action)))
      });

    case _orderHistory.START_DOWNLOADING_INVOICE:
    case _orderHistory.START_FETCHING_NOTA_FISCAL_LINK:
    case _orderHistory.START_DOWNLOADING_PAYMENT_SLIP:
      return _extends({}, state, {
        fileError: false,
        fileErrorCode: null,
        isDownloading: true
      });

    case _orderHistory.DOWNLOADING_INVOICE_SUCCESS:
    case _orderHistory.FETCHING_NOTA_FISCAL_LINK_SUCCESS:
    case _orderHistory.DOWNLOADING_PAYMENT_SLIP_SUCCESS:
      return _extends({}, state, {
        fileError: false,
        fileErrorCode: null,
        isDownloading: false
      });

    case _orderHistory.DOWNLOADING_INVOICE_ERROR:
    case _orderHistory.FETCHING_NOTA_FISCAL_LINK_ERROR:
    case _orderHistory.DOWNLOADING_PAYMENT_SLIP_ERROR:
      return _extends({}, state, {
        fileError: true,
        fileErrorCode: action.errorCode,
        isDownloading: false
      });

    default:
      return state;
  }
};

exports.default = orderHistory;

/***/ }),

/***/ 3516:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNotaFiscaLink = exports.downloadPaymentSlip = exports.downloadInvoice = exports.fetchHistoryOrderDetail = exports.fetchMoreOrdersForPeriod = exports.fetchOrderHistoryForPeriod = exports.fetchOrderPeriods = exports.NOT_FOUND_ERROR_CODE = exports.FETCHING_NOTA_FISCAL_LINK_ERROR = exports.FETCHING_NOTA_FISCAL_LINK_SUCCESS = exports.START_FETCHING_NOTA_FISCAL_LINK = exports.DOWNLOADING_PAYMENT_SLIP_ERROR = exports.DOWNLOADING_PAYMENT_SLIP_SUCCESS = exports.START_DOWNLOADING_PAYMENT_SLIP = exports.DOWNLOADING_INVOICE_ERROR = exports.DOWNLOADING_INVOICE_SUCCESS = exports.START_DOWNLOADING_INVOICE = exports.ERROR_FETCHING_HISTORY_ORDER_DETAILS = exports.SUCCESS_FETCHING_HISTORY_ORDER_DETAILS = exports.START_FETCHING_HISTORY_ORDER_DETAILS = exports.ERROR_FETCHING_ORDER_PERIODS = exports.ERROR_FETCHING_MORE_ORDER_PERIODS = exports.SUCCESS_FETCHING_MORE_ORDER_PERIODS = exports.START_FETCHING_MORE_ORDER_PERIODS = exports.SUCCESS_FETCHING_ORDER_PERIODS = exports.START_FETCHING_ORDER_PERIODS = exports.ERROR_FETCHING_ORDER_HISTORY = exports.SUCCESS_FETCHING_ORDER_HISTORY = exports.START_FETCHING_ORDER_HISTORY = undefined;

var _downloadFile = __webpack_require__(1226);

var _downloadFile2 = _interopRequireDefault(_downloadFile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var START_FETCHING_ORDER_HISTORY = exports.START_FETCHING_ORDER_HISTORY = 'START_FETCHING_ORDER_HISTORY';
var SUCCESS_FETCHING_ORDER_HISTORY = exports.SUCCESS_FETCHING_ORDER_HISTORY = 'SUCCESS_FETCHING_ORDER_HISTORY';
var ERROR_FETCHING_ORDER_HISTORY = exports.ERROR_FETCHING_ORDER_HISTORY = 'ERROR_FETCHING_ORDER_HISTORY';
var START_FETCHING_ORDER_PERIODS = exports.START_FETCHING_ORDER_PERIODS = 'START_FETCHING_ORDER_PERIODS';
var SUCCESS_FETCHING_ORDER_PERIODS = exports.SUCCESS_FETCHING_ORDER_PERIODS = 'SUCCESS_FETCHING_ORDER_PERIODS';
var START_FETCHING_MORE_ORDER_PERIODS = exports.START_FETCHING_MORE_ORDER_PERIODS = 'START_FETCHING_MORE_ORDER_PERIODS';
var SUCCESS_FETCHING_MORE_ORDER_PERIODS = exports.SUCCESS_FETCHING_MORE_ORDER_PERIODS = 'SUCCESS_FETCHING_MORE_ORDER_PERIODS';
var ERROR_FETCHING_MORE_ORDER_PERIODS = exports.ERROR_FETCHING_MORE_ORDER_PERIODS = 'ERROR_FETCHING_MORE_ORDER_PERIODS';
var ERROR_FETCHING_ORDER_PERIODS = exports.ERROR_FETCHING_ORDER_PERIODS = 'ERROR_FETCHING_ORDER_PERIODS';
var START_FETCHING_HISTORY_ORDER_DETAILS = exports.START_FETCHING_HISTORY_ORDER_DETAILS = 'START_FETCHING_HISTORY_ORDER_DETAILS';
var SUCCESS_FETCHING_HISTORY_ORDER_DETAILS = exports.SUCCESS_FETCHING_HISTORY_ORDER_DETAILS = 'SUCCESS_FETCHING_HISTORY_ORDER_DETAILS';
var ERROR_FETCHING_HISTORY_ORDER_DETAILS = exports.ERROR_FETCHING_HISTORY_ORDER_DETAILS = 'ERROR_FETCHING_HISTORY_ORDER_DETAILS';
var START_DOWNLOADING_INVOICE = exports.START_DOWNLOADING_INVOICE = 'START_DOWNLOADING_INVOICE';
var DOWNLOADING_INVOICE_SUCCESS = exports.DOWNLOADING_INVOICE_SUCCESS = 'DOWNLOADING_INVOICE_SUCCESS';
var DOWNLOADING_INVOICE_ERROR = exports.DOWNLOADING_INVOICE_ERROR = 'DOWNLOADING_INVOICE_ERROR';
var START_DOWNLOADING_PAYMENT_SLIP = exports.START_DOWNLOADING_PAYMENT_SLIP = 'START_DOWNLOADING_PAYMENT_SLIP';
var DOWNLOADING_PAYMENT_SLIP_SUCCESS = exports.DOWNLOADING_PAYMENT_SLIP_SUCCESS = 'DOWNLOADING_PAYMENT_SLIP_SUCCESS';
var DOWNLOADING_PAYMENT_SLIP_ERROR = exports.DOWNLOADING_PAYMENT_SLIP_ERROR = 'DOWNLOADING_PAYMENT_SLIP_ERROR';
var START_FETCHING_NOTA_FISCAL_LINK = exports.START_FETCHING_NOTA_FISCAL_LINK = 'START_FETCHING_NOTA_FISCAL_LINK';
var FETCHING_NOTA_FISCAL_LINK_SUCCESS = exports.FETCHING_NOTA_FISCAL_LINK_SUCCESS = 'FETCHING_NOTA_FISCAL_LINK_SUCCESS';
var FETCHING_NOTA_FISCAL_LINK_ERROR = exports.FETCHING_NOTA_FISCAL_LINK_ERROR = 'FETCHING_NOTA_FISCAL_LINK_ERROR';
var NOT_FOUND_ERROR_CODE = exports.NOT_FOUND_ERROR_CODE = 'NOT_FOUND_ERROR_CODE';

var fetchOrderPeriods = exports.fetchOrderPeriods = function fetchOrderPeriods(dealerId, fetchMore) {
  return function (dispatch, getState, _ref) {
    var api = _ref.api;

    var success = function success(type) {
      return function (periods) {
        return dispatch({
          type: type,
          periods: periods.items,
          nextBatchHref: periods.nextBatch && periods.nextBatch.href,
          dealerId: dealerId
        });
      };
    };

    if (fetchMore) {
      var _getState = getState(),
          nextBatchHref = _getState.orderHistory.nextBatchHref;

      dispatch({
        type: START_FETCHING_MORE_ORDER_PERIODS
      });

      return api.fetchMoreOrderPeriods(nextBatchHref).then(success(SUCCESS_FETCHING_MORE_ORDER_PERIODS)).catch(function () {
        return dispatch({ type: ERROR_FETCHING_MORE_ORDER_PERIODS });
      });
    }

    dispatch({
      type: START_FETCHING_ORDER_PERIODS
    });

    return api.fetchOrderPeriods(dealerId).then(success(SUCCESS_FETCHING_ORDER_PERIODS)).catch(function () {
      return dispatch({ type: ERROR_FETCHING_ORDER_PERIODS });
    });
  };
};

var fetchOrderHistoryForPeriod = exports.fetchOrderHistoryForPeriod = function fetchOrderHistoryForPeriod(periodId) {
  return function (dispatch, getState, _ref2) {
    var api = _ref2.api;

    var _getState2 = getState(),
        periods = _getState2.orderHistory.periods;

    var href = periods[periodId].billableItems.href;

    var success = function success(orders) {
      return dispatch({
        type: SUCCESS_FETCHING_ORDER_HISTORY,
        periodId: periodId,
        orders: {
          nextBatchHref: orders.nextBatch && orders.nextBatch.href,
          list: orders.items
        }
      });
    };
    var error = function error() {
      return dispatch({ type: ERROR_FETCHING_ORDER_HISTORY, periodId: periodId });
    };

    dispatch({ type: START_FETCHING_ORDER_HISTORY, periodId: periodId });

    return api.fetchOrderHistoryForPeriod(href).then(success).catch(error);
  };
};

var fetchMoreOrdersForPeriod = exports.fetchMoreOrdersForPeriod = function fetchMoreOrdersForPeriod(periodId) {
  return function (dispatch, getState, _ref3) {
    var api = _ref3.api;

    var _getState3 = getState(),
        periods = _getState3.orderHistory.periods;

    var nextBatchHref = periods[periodId].nextBatchHref;

    var success = function success(orders) {
      return dispatch({
        type: SUCCESS_FETCHING_ORDER_HISTORY,
        periodId: periodId,
        orders: {
          nextBatchHref: orders.nextBatch && orders.nextBatch.href,
          list: orders.items
        }
      });
    };
    var error = function error() {
      return dispatch({ type: ERROR_FETCHING_ORDER_HISTORY, periodId: periodId });
    };

    dispatch({ type: START_FETCHING_ORDER_HISTORY, periodId: periodId });

    return api.fetchMoreHistoryOrders(nextBatchHref).then(success).catch(error);
  };
};

var fetchHistoryOrderDetail = exports.fetchHistoryOrderDetail = function fetchHistoryOrderDetail(periodId, orderId) {
  return function (dispatch, getState, _ref4) {
    var api = _ref4.api;

    var _getState4 = getState(),
        periods = _getState4.orderHistory.periods;

    var href = periods[periodId].orders[orderId].order.href;

    var success = function success(orderDetails) {
      return dispatch({
        type: SUCCESS_FETCHING_HISTORY_ORDER_DETAILS,
        periodId: periodId,
        orderId: orderId,
        orderDetails: orderDetails
      });
    };
    var error = function error() {
      return dispatch({
        type: ERROR_FETCHING_HISTORY_ORDER_DETAILS,
        periodId: periodId,
        orderId: orderId
      });
    };

    dispatch({
      type: START_FETCHING_HISTORY_ORDER_DETAILS,
      periodId: periodId,
      orderId: orderId
    });

    return api.fetchHistoryOrderDetail(href).then(success).catch(error);
  };
};

var downloadInvoice = exports.downloadInvoice = function downloadInvoice(dealerId, periodTimestamp) {
  return function (dispatch, getState, _ref5) {
    var api = _ref5.api;

    var requestSucess = function requestSucess(blob) {
      var fileName = 'chama-nota-fiscal@' + dealerId + '.pdf';

      (0, _downloadFile2.default)(blob, fileName);
      dispatch({ type: DOWNLOADING_INVOICE_SUCCESS });
    };

    var requestRejected = function requestRejected(response) {
      if (response.status === 404) {
        return dispatch({ type: DOWNLOADING_INVOICE_ERROR, errorCode: NOT_FOUND_ERROR_CODE });
      }

      return dispatch({ type: DOWNLOADING_INVOICE_ERROR });
    };

    dispatch({ type: START_DOWNLOADING_INVOICE });

    return api.downloadInvoice(dealerId, periodTimestamp).then(requestSucess, requestRejected).catch(function (e) {
      throw new Error(e);
    });
  };
};

var downloadPaymentSlip = exports.downloadPaymentSlip = function downloadPaymentSlip(dealerId, periodTimestamp) {
  return function (dispatch, getState, _ref6) {
    var api = _ref6.api;

    var requestSucess = function requestSucess(blob) {
      var fileName = 'chama-boleto@' + dealerId + '.pdf';

      (0, _downloadFile2.default)(blob, fileName);
      dispatch({ type: DOWNLOADING_PAYMENT_SLIP_SUCCESS });
    };

    var requestRejected = function requestRejected(response) {
      if (response.status === 404) {
        return dispatch({ type: DOWNLOADING_PAYMENT_SLIP_ERROR, errorCode: NOT_FOUND_ERROR_CODE });
      }

      return dispatch({ type: DOWNLOADING_PAYMENT_SLIP_ERROR });
    };

    dispatch({ type: START_DOWNLOADING_PAYMENT_SLIP });

    return api.downloadPaymentSlip(dealerId, periodTimestamp).then(requestSucess, requestRejected).catch(function (e) {
      throw new Error(e);
    });
  };
};

var getNotaFiscaLink = exports.getNotaFiscaLink = function getNotaFiscaLink(dealerId, periodTimestamp) {
  return function (dispatch, getState, _ref7) {
    var api = _ref7.api;

    var requestSucess = function requestSucess(response) {
      var href = response.href;

      var newTab = window.open(href, '_blank');

      if (newTab) {
        newTab.focus();
      } else {
        // New tab got blocked by Chrome/AdBlocker
        window.location = href;
      }

      dispatch({ type: FETCHING_NOTA_FISCAL_LINK_SUCCESS });
    };

    var requestRejected = function requestRejected(response) {
      if (response.status === 404) {
        return dispatch({ type: FETCHING_NOTA_FISCAL_LINK_ERROR, errorCode: NOT_FOUND_ERROR_CODE });
      }

      return dispatch({ type: FETCHING_NOTA_FISCAL_LINK_ERROR });
    };

    dispatch({ type: START_FETCHING_NOTA_FISCAL_LINK });

    return api.getNotaFiscalLink(dealerId, periodTimestamp).then(requestSucess, requestRejected).catch(function (e) {
      throw new Error(e);
    });
  };
};

/***/ }),

/***/ 3517:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _orderEventHistory = __webpack_require__(1529);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isFetching: false,
  orders: {}
};

var orderEventHistory = function orderEventHistory() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _orderEventHistory.START_FETCHING_ORDER_EVENT_HISTORY:
      return _extends({}, state, {
        isFetching: true
      });

    case _orderEventHistory.ERROR_FETCHING_ORDER_EVENT_HISTORY:
      return _extends({}, state, {
        isFetching: false
      });

    case _orderEventHistory.SUCCESS_FETCHING_ORDER_EVENT_HISTORY:
      return _extends({}, state, {
        isFetching: false,
        orders: _extends({}, state.orders, _defineProperty({}, action.orderId, action.eventHistory))
      });

    default:
      return state;
  }
};

exports.default = orderEventHistory;

/***/ }),

/***/ 3518:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _analytics = __webpack_require__(411);

var _orderSound = __webpack_require__(1527);

var initialState = {
  isSoundMuted: false,
  hasUserInteractedWithPage: false
};

var orderSound = function orderSound() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _orderSound.MUTE_ORDER_SOUND:
      return _extends({}, state, {
        isSoundMuted: true,
        hasUserInteractedWithPage: true
      });

    case _orderSound.UNMUTE_ORDER_SOUND:
      return _extends({}, state, {
        isSoundMuted: false,
        hasUserInteractedWithPage: true
      });
    case _analytics.TYPE_TRACK:
      return changeUserInteractionWithPage(state, action);

    default:
      return state;
  }
};

function changeUserInteractionWithPage(state, _ref) {
  var payload = _ref.payload;

  var shouldSkip = !payload || ![_orderSound.SOUND_WARNING_DISMISSED, _orderSound.SOUND_PLAYBACK].includes(payload.name);

  if (shouldSkip) return state;

  var properties = payload.properties;


  return _extends({}, state, {
    hasUserInteractedWithPage: payload.name === _orderSound.SOUND_WARNING_DISMISSED || properties.isPlayed
  });
}

exports.default = orderSound;

/***/ }),

/***/ 3519:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _apiDrivers = __webpack_require__(1526);

var _drivers = __webpack_require__(3520);

var initialState = {
  all: [],
  driverSelectedId: ''
};

var drivers = function drivers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _apiDrivers.START_FETCHING_DRIVERS:
      return _extends({}, initialState);

    case _apiDrivers.FETCHING_DRIVERS_SUCCESS:
      return _extends({}, state, {
        all: action.drivers
      });

    case _apiDrivers.FETCHING_DRIVERS_ERROR:
      return state;

    case _drivers.SET_DRIVER_ID:
      return _extends({}, state, {
        driverSelectedId: action.driverId
      });

    default:
      return state;
  }
};

exports.default = drivers;

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startListeningToDealers = exports.getNearbyDealers = exports.toggleFilter = exports.reopenShop = exports.adHocCloseShop = exports.updateDealerData = exports.ADD_DEALER_DATA = exports.REMOVE_FILTER = exports.GET_NEARBY_DEALERS = exports.ADD_FILTER = exports.DEALER_LOADING = exports.UPDATE_SEVERAL_DEALERS = exports.UPDATE_DEALER_DATA = exports.FETCH_DEALER_DATA = undefined;

var _status = __webpack_require__(53);

var _Dealer = __webpack_require__(669);

var _Dealer2 = _interopRequireDefault(_Dealer);

var _analyticsHandler = __webpack_require__(1525);

var _analyticsHandler2 = _interopRequireDefault(_analyticsHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_DEALER_DATA = exports.FETCH_DEALER_DATA = 'FETCH_DEALER_DATA';
var UPDATE_DEALER_DATA = exports.UPDATE_DEALER_DATA = 'UPDATE_DEALER_DATA';
var UPDATE_SEVERAL_DEALERS = exports.UPDATE_SEVERAL_DEALERS = 'UPDATE_SEVERAL_DEALERS';
var DEALER_LOADING = exports.DEALER_LOADING = 'DEALER_LOADING';
var ADD_FILTER = exports.ADD_FILTER = 'ADD_FILTER';
var GET_NEARBY_DEALERS = exports.GET_NEARBY_DEALERS = 'GET_NEARBY_DEALERS';
var REMOVE_FILTER = exports.REMOVE_FILTER = 'REMOVE_FILTER';
var ADD_DEALER_DATA = exports.ADD_DEALER_DATA = 'ADD_DEALER_DATA';

var updateDealerData = exports.updateDealerData = function updateDealerData(dealerId, updatedData) {
  return function (dispatch, getState, _ref) {
    var api = _ref.api;

    dispatch({ type: DEALER_LOADING });

    return api.updateDealerData(dealerId, updatedData).then(onUserDataFulfill);

    function onUserDataFulfill(updatedDealer) {
      dispatch({
        type: UPDATE_DEALER_DATA,
        updatedDealer: new _Dealer2.default(updatedDealer)
      });
    }
  };
};

var adHocCloseShop = exports.adHocCloseShop = function adHocCloseShop(dealerId) {
  return function (dispatch, getState, _ref2) {
    var api = _ref2.api;

    var updatedData = {
      isOpenedMode: _status.SHOP_OPENED_MODE_ADHOC_CLOSED
    };

    dispatch({ type: DEALER_LOADING });

    return api.updateDealerData(dealerId, updatedData).then(onUserDataFulfill);

    function onUserDataFulfill(updatedDealer) {
      return dispatch({
        type: UPDATE_DEALER_DATA,
        updatedDealer: updatedDealer
      });
    }
  };
};

var reopenShop = exports.reopenShop = function reopenShop(dealerId) {
  return function (dispatch, getState, _ref3) {
    var api = _ref3.api;

    var updatedData = {
      isOpenedMode: _status.SHOP_OPENED_MODE_DEFAULT
    };

    dispatch({ type: DEALER_LOADING });

    return api.updateDealerData(dealerId, updatedData).then(onUserDataFulfill);

    function onUserDataFulfill(updatedDealer) {
      return dispatch({
        type: UPDATE_DEALER_DATA,
        updatedDealer: updatedDealer
      });
    }
  };
};

var toggleFilter = exports.toggleFilter = function toggleFilter(number) {
  return function (dispatch, getState) {
    var _getState = getState(),
        filters = _getState.dealer.filters,
        _getState$user = _getState.user,
        username = _getState$user.username,
        account = _getState$user.account;

    var indexOfFilter = filters.indexOf(number);
    var isSelected = indexOfFilter === -1;

    // Bucket start from 0. For better reading, adding + 1
    var bucketNumber = number + 1;

    (0, _analyticsHandler2.default)('Clicked Bucket Filter', {
      location: 'OrderHandling',
      type: 'button',
      bucketNumber: bucketNumber,
      isSelected: isSelected,
      username: username,
      userId: username + '@' + account
    });

    if (!isSelected) {
      // Remove
      dispatch({
        type: REMOVE_FILTER,
        indexOfFilter: indexOfFilter
      });
    } else {
      // Add
      dispatch({
        type: ADD_FILTER,
        number: number
      });
    }
  };
};

var getNearbyDealers = exports.getNearbyDealers = function getNearbyDealers(lat, lon) {
  return function (dispatch, getState, _ref4) {
    var api = _ref4.api;

    return api.getNearbyDealers(lat, lon).then(function (dealers) {
      return dispatch({
        type: GET_NEARBY_DEALERS,
        lat: lat,
        lon: lon,
        dealers: dealers
      });
    });
  };
};

var dealerData = function dealerData(dealers) {
  return {
    type: FETCH_DEALER_DATA,
    dealers: dealers
  };
};

var addDealerToDealersData = function addDealerToDealersData(dealer) {
  return {
    type: ADD_DEALER_DATA,
    dealer: dealer
  };
};

var dealerDataUpdate = function dealerDataUpdate(dealer) {
  return {
    type: UPDATE_DEALER_DATA,
    updatedDealer: dealer
  };
};

/**
 * When application gets loaded, all dealers are fetched.
 *
 * After that, the application will react only when dealer gets added or updated.
 * So we can avoid downloading all the data in every change.
 *
 * Firebase has limitations on 'child_added' event (more here: https://stackoverflow.com/questions/11788902/firebase-child-added-only-get-child-added)
 * Therefore we sort by timestamp to be able to retrieve only the latest one
 */
var startListeningToDealers = exports.startListeningToDealers = function startListeningToDealers() {
  return function (dispatch, getState, _ref5) {
    var firebaseClient = _ref5.firebaseClient;

    firebaseClient.database.ref('/dealers').once('value', function (snapshot) {
      var dealers = Object.values(snapshot.val()).map(function (dealer) {
        return new _Dealer2.default(dealer);
      });
      dispatch(dealerData(dealers));
    });

    firebaseClient.database.ref('/dealers').orderByChild('creationTime').limitToLast(1).on('child_added', function (snapshot) {
      var dealers = getState().dealer.all;
      var dealer = new _Dealer2.default(snapshot.val());
      var dealerKeys = Object.keys(dealers);
      if (dealerKeys.length && !dealerKeys.includes(dealer.id)) {
        dispatch(addDealerToDealersData(dealer));
      }
    });

    firebaseClient.database.ref('/dealers').on('child_changed', function (snapshot) {
      var dealer = new _Dealer2.default(snapshot.val());
      dispatch(dealerDataUpdate(dealer));
    });
  };
};

/***/ }),

/***/ 3520:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_DRIVER_ID = exports.SET_DRIVER_ID = 'SET_DRIVER_ID';

var setDriverId = exports.setDriverId = function setDriverId(driverId) {
  return {
    type: SET_DRIVER_ID,
    driverId: driverId
  };
};

/***/ }),

/***/ 3521:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handleVersion;
function handleVersion(availableVersion) {
  var currentVersion = localStorage.getItem('current_version') || true;
  var isNewVersion = currentVersion && availableVersion && currentVersion !== availableVersion;

  if (!isNewVersion) return;

  console.info('newer version available (current: ' + currentVersion + ', available: ' + availableVersion);

  localStorage.setItem('current_version', availableVersion);

  var urlParams = window.location.search.substring(1).split('&');
  var shouldReload = !urlParams.find(function (param) {
    return param.includes('_=');
  });

  if (shouldReload) {
    window.location = window.location + '/?_=' + Date.now();
  }
}

var readVersion = exports.readVersion = function readVersion() {
  return localStorage.getItem('current_version');
};

/***/ }),

/***/ 3522:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(3523);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(3524);

__webpack_require__(3525);

var _config = __webpack_require__(167);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FirebaseClient = function () {
  function FirebaseClient() {
    _classCallCheck(this, FirebaseClient);

    var app = _app2.default.initializeApp(_config2.default.firebase);
    window.app = app;
    this.database = app.database();
    this.connectedRef = this.database.ref('.info/connected');
    this.auth = app.auth();
    this.googleProvider = new _app2.default.auth.GoogleAuthProvider();
  }

  _createClass(FirebaseClient, [{
    key: 'signInWithGoogle',
    value: function signInWithGoogle() {
      return this.auth.signInWithPopup(this.googleProvider);
    }
  }, {
    key: 'signOut',
    value: function signOut() {
      return this.auth.signOut();
    }
  }, {
    key: 'getToken',
    value: function getToken() {
      var forceRefresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return this.auth.currentUser.getIdToken(forceRefresh);
    }
  }, {
    key: 'onTokenChanged',
    value: function onTokenChanged(callback) {
      this.auth.onIdTokenChanged(callback);
    }
  }, {
    key: 'onConnectionStateChange',
    value: function onConnectionStateChange(callback) {
      this.database.ref('.info/connected').on('value', function (snapshot) {
        if (snapshot.val() === true) {
          callback(true);
        } else {
          callback(false);
        }
      });
    }
  }, {
    key: 'onVersionChanged',
    value: function onVersionChanged(callback) {
      this.database.ref('version').on('value', function (snapshot) {
        callback(snapshot.val());
      });
    }
  }, {
    key: 'onServerTimeOffsetChanged',
    value: function onServerTimeOffsetChanged(callback) {
      this.database.ref('.info/serverTimeOffset').on('value', function (snap) {
        var offset = snap.val();
        callback(offset);
      });
    }
  }, {
    key: 'onCustomerServiceAdminAccountsChanged',
    value: function onCustomerServiceAdminAccountsChanged(callback, errorHandler) {
      this.database.ref('customerService/adminAccounts').on('value', function (snap) {
        var customerServiceAdminAccounts = snap.val();

        callback(customerServiceAdminAccounts);
      }, errorHandler);
    }
  }]);

  return FirebaseClient;
}();

exports.default = FirebaseClient;

/***/ }),

/***/ 3523:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

__webpack_require__(1359);
var firebase = _interopDefault(__webpack_require__(193));

/**
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

module.exports = firebase;


/***/ }),

/***/ 3524:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_auth__ = __webpack_require__(1361);


/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/***/ }),

/***/ 3525:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_database__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_database___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_database__);


/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unsetAccount = exports.setCustomerServiceAdminAccounts = exports.logout = exports.login = exports.UNSET_ACCOUNT = exports.SET_CS_ADMIN_ACCOUNTS = exports.GET_USER_KIND = exports.LOGOUT = exports.LOGIN_SUCCESS = undefined;

var _localStorage = __webpack_require__(408);

var _sentry = __webpack_require__(460);

var _sentry2 = _interopRequireDefault(_sentry);

var _orders = __webpack_require__(238);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOGIN_SUCCESS = exports.LOGIN_SUCCESS = 'LOGIN_SUCCESS';
var LOGOUT = exports.LOGOUT = 'LOGOUT';
var GET_USER_KIND = exports.GET_USER_KIND = 'GET_USER_KIND';
var SET_CS_ADMIN_ACCOUNTS = exports.SET_CS_ADMIN_ACCOUNTS = 'SET_CS_ADMIN_ACCOUNTS';
var UNSET_ACCOUNT = exports.UNSET_ACCOUNT = 'UNSET_ACCOUNT';

var loginSuccess = function loginSuccess(account, username, password) {
  return {
    type: LOGIN_SUCCESS,
    account: account,
    username: username,
    password: password
  };
};

var getUserKind = function getUserKind(dispatch, api) {
  return api.getUserKind().then(function (_ref) {
    var kind = _ref.kind;

    dispatch({
      type: GET_USER_KIND,
      kind: kind
    });
  });
};

var loginApi = function loginApi(account, username, password) {
  return function (dispatch, getState, _ref2) {
    var api = _ref2.api;

    api.signIn(account, username, password);

    return dispatch((0, _orders.startFetchingTickets)()).then(function () {
      return getUserKind(dispatch, api).then(function () {
        dispatch(loginSuccess(account, username, password));
      });
    });
  };
};

var loginFirebaseAndOrApi = function loginFirebaseAndOrApi(account, username, password) {
  return function (dispatch, getState, _ref3) {
    var firebaseClient = _ref3.firebaseClient;

    if (getState().featureToggles.firebaseAuthEnabled) {
      var email = username + '@' + account + '.dealer.revendedorchama.com';
      return firebaseClient.signIn(email, password).then(function (_ref4) {
        var user = _ref4.user;

        if (getState().featureToggles.toggleApiJwt) {
          return user.getIdToken();
        }

        return dispatch(loginApi(account, username, password)).catch(function (e) {
          firebaseClient.signOut();
          throw e;
        });
      });
    }

    return dispatch(loginApi(account, username, password));
  };
};

var login = exports.login = function login(account, username, password) {
  return function (dispatch) {
    return dispatch(loginFirebaseAndOrApi(account, username, password)).then(function () {
      _sentry2.default.setUserContext({
        id: username + '@' + account,
        account: account,
        username: username
      });
    });
  };
};

var logoutWithoutFirebase = function logoutWithoutFirebase() {
  return function (dispatch, getState, _ref5) {
    var api = _ref5.api;

    api.signOut();
    dispatch({ type: LOGOUT });

    (0, _localStorage.saveState)(getState());
    // NOTE: IE tax: IE10 will not have flushed localStorage yet if the
    // following is not wrapped in setImmediate :(
    setImmediate(function () {
      window.location = '/login';
    });
  };
};

var logout = exports.logout = function logout() {
  return function (dispatch, getState, _ref6) {
    var firebaseClient = _ref6.firebaseClient;

    if (getState().featureToggles.firebaseAuthEnabled) {
      firebaseClient.signOut().then(function () {
        dispatch(logoutWithoutFirebase());
      });
    } else {
      dispatch(logoutWithoutFirebase());
    }
  };
};

var setCustomerServiceAdminAccounts = exports.setCustomerServiceAdminAccounts = function setCustomerServiceAdminAccounts() {
  var customerServiceAdminAccounts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: SET_CS_ADMIN_ACCOUNTS,
    customerServiceAdminAccounts: customerServiceAdminAccounts
  };
};

var unsetAccount = exports.unsetAccount = function unsetAccount() {
  return {
    type: UNSET_ACCOUNT
  };
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1360).setImmediate))

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOngoingOrders = exports.getNewOrders = exports.getFilteredOngoingOrders = exports.getFilteredNewOrders = exports.ORDERS_QUEUES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _user = __webpack_require__(353);

var _orders = __webpack_require__(238);

var _getFilteredDealerOrders = __webpack_require__(668);

var _getFilteredDealerOrders2 = _interopRequireDefault(_getFilteredDealerOrders);

var _ordersSort = __webpack_require__(3450);

var _ordersSort2 = _interopRequireDefault(_ordersSort);

var _status = __webpack_require__(53);

var _form = __webpack_require__(1531);

var _time = __webpack_require__(1532);

var _dealerSelectors = __webpack_require__(3451);

var _dealerSelectors2 = _interopRequireDefault(_dealerSelectors);

var _orderTimeCount = __webpack_require__(589);

var _orderTimeCount2 = _interopRequireDefault(_orderTimeCount);

var _updateProcessingOrderIds = __webpack_require__(3452);

var _updateProcessingOrderIds2 = _interopRequireDefault(_updateProcessingOrderIds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ticketToOrder = function ticketToOrder(_ref) {
  var _ref$data = _ref.data,
      order = _ref$data.order,
      delivery = _ref$data.delivery,
      ticket = _objectWithoutProperties(_ref, ['data']);

  return _extends({}, order, {
    orderId: order.id,
    delivery: delivery,
    currentTicket: ticket
  });
};

/**
 * This method here contains a big Redux anti-pattern which is mutability
 * it mutate the state when it is executed, making only possible to see the previous state
 * when everything is executed before the execution of this one.
 * Angry note: By the lack of time, I can't fix this now (time of writing) and
 * the developer who wrote this (Bas) should really read about good practices.
 * I literally lost more than 1 hour trying to find a bug in a perfectly fine code
 * when the problem was this stupid method. Yeah, other ppl's code can sometimes be a nightmare
 * indeed.
 *
 * Be aware of this!
 */
var updateStateWithOrders = function updateStateWithOrders(state, updatedOrders) {
  return updatedOrders.reduce(function (prevState, order) {
    // only update order if the ticket is valid to be displayed (has a queue property)
    if (!(order.id in prevState) || order.currentTicket.queue) {
      // eslint-disable-next-line no-param-reassign
      prevState[order.id] = order;
    }

    return prevState;
  }, state);
};

var ordersToDict = function ordersToDict(orders) {
  return orders.reduce(function (memo, order) {
    return _extends(_defineProperty({}, order.id, order), memo);
  }, {});
};

var ORDERS_QUEUES = exports.ORDERS_QUEUES = Object.freeze({
  INCOMING: 'incoming',
  BEING_DELIVERED: 'beingDelivered',
  FINALIZED: 'finalized'
});

var initialState = {
  selectedOrderQueue: ORDERS_QUEUES.INCOMING,
  isExecutingCommand: false,
  isExecutingAssignment: false,
  fetched: false,
  currentOrderId: null,
  beingProcessedOrderIds: [],
  dict: {}
};

var orders = function orders() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var updatedOrders = void 0;

  switch (action.type) {
    case _orders.ADD_OR_UPDATE_TICKETS:
      updatedOrders = action.tickets.map(ticketToOrder);

      return _extends({}, state, {
        fetched: true,
        beingProcessedOrderIds: (0, _updateProcessingOrderIds2.default)(state.dict, state.beingProcessedOrderIds, updatedOrders),
        dict: ordersToDict(updatedOrders)
      });

    case _orders.START_PROCESSING_ORDER:
      return _extends({}, state, {
        beingProcessedOrderIds: [].concat(_toConsumableArray(state.beingProcessedOrderIds), [action.orderId])
      });

    case _orders.PROCESSING_ORDER_ERROR:
      return _extends({}, state, {
        beingProcessedOrderIds: state.beingProcessedOrderIds.filter(function (orderId) {
          return orderId !== action.orderId;
        })
      });

    case _orders.SET_CURRENT_ORDER_ID:
      return _extends({}, state, {
        currentOrderId: action.currentOrderId
      });

    case _orders.ORDER_ASSIGNMENT_LOADING:
      return _extends({}, state, {
        isExecutingAssignment: true
      });

    case _orders.ORDER_ASSIGNMENT_DONE:
      return _extends({}, state, {
        isExecutingAssignment: false
      });

    case _orders.UPDATE_ORDER_QUEUE:
      {
        return _extends({}, state, {
          selectedOrderQueue: action.payload.queue,
          fetched: false,
          currentOrderId: null,
          beingProcessedOrderIds: []
        });
      }

    case _user.LOGOUT:
      return _extends({}, initialState);

    default:
      return state;
  }
};

var getNewOrders = function getNewOrders(state) {
  return (0, _getFilteredDealerOrders2.default)(state).filter(function (_ref2) {
    var currentTicket = _ref2.currentTicket;
    return currentTicket.queue === _status.QUEUE_INCOMING;
  });
};

var getOngoingOrders = function getOngoingOrders(state) {
  return (0, _getFilteredDealerOrders2.default)(state).filter(function (_ref3) {
    var currentTicket = _ref3.currentTicket;
    return currentTicket.queue === _status.QUEUE_BEING_DELIVERED;
  });
};

var getFilteredNewOrders = function getFilteredNewOrders(state) {
  var ordersNew = getNewOrders(state);
  var visibilityFilter = (0, _form.getIncomingOrdersDropdownValue)(state);
  var currentTime = (0, _time.getCurrentTime)(state);
  var dealers = _dealerSelectors2.default.getDealers(state);

  var laterThanTwoMinutesOrStoreIsInactive = function laterThanTwoMinutesOrStoreIsInactive(myOrder) {
    var dealer = dealers[myOrder.dealerId];
    return dealer && !dealer.isActive || (0, _orderTimeCount2.default)(currentTime, myOrder.creationTime) > 2 * 60;
  };

  switch (visibilityFilter) {
    case 'SHOW_ALL':
      return ordersNew.sort((0, _ordersSort2.default)(_status.TYPE_CANCEL_NEW_ORDER));
    case 'SHOW_AWAITING_INTERACTION':
      return ordersNew.filter(isNotCanceled).filter(laterThanTwoMinutesOrStoreIsInactive);
    default:
      return ordersNew;
  }
};

var getFilteredOngoingOrders = function getFilteredOngoingOrders(state) {
  var ongoingOrders = getOngoingOrders(state);
  var visibilityFilter = (0, _form.getOngoingOrdersDropdownValue)(state);

  var lateOrderFilter = function lateOrderFilter(myOrder) {
    var currentTime = (0, _time.getCurrentTime)(state);
    var secs = (0, _orderTimeCount2.default)(currentTime, myOrder.eta, true);

    if (secs < 0) return true;
    return false;
  };

  switch (visibilityFilter) {
    case 'SHOW_ALL':
      return ongoingOrders.sort((0, _ordersSort2.default)(_status.TYPE_CANCEL_DELIVER_ORDER));
    case 'SHOW_LATE_ORDERS':
      return ongoingOrders.filter(lateOrderFilter).sort((0, _ordersSort2.default)());
    default:
      return ongoingOrders;
  }
};

var isNotCanceled = function isNotCanceled(myOrder) {
  return myOrder.status !== _status.ORDER_STATUS_CONSUMER_CANCELLED;
};

exports.default = orders;
exports.getFilteredNewOrders = getFilteredNewOrders;
exports.getFilteredOngoingOrders = getFilteredOngoingOrders;
exports.getNewOrders = getNewOrders;
exports.getOngoingOrders = getOngoingOrders;

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ravenJs = __webpack_require__(1498);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _config = __webpack_require__(167);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_ravenJs2.default.config(_config2.default.sentry.configUrl, {
  release: _config2.default.version
}).install();

_ravenJs2.default.setTagsContext({
  version: _config2.default.version
});

var isError = function isError(x) {
  return x instanceof Error;
};

window.addEventListener('unhandledrejection', function (event) {
  var reason = event.reason;
  var message = isError(reason) ? reason.message : reason;
  var extra = { message: message };
  var stack = isError(reason) && reason.stack;

  if (stack) {
    extra.stack = stack;
  }

  var err = new Error('Unhandled promise rejection: ' + message);
  _ravenJs2.default.captureException(err, { extra: extra });
});

exports.default = _ravenJs2.default;

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _applicationinsightsJs = __webpack_require__(1304);

var _config = __webpack_require__(167);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_applicationinsightsJs.AppInsights.downloadAndSetup({ instrumentationKey: _config2.default.appInsights.instrumentationKey });

exports.default = _applicationinsightsJs.AppInsights;

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logout = exports.updateToken = exports.login = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;

var _jwtDecode2 = __webpack_require__(1364);

var _jwtDecode3 = _interopRequireDefault(_jwtDecode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// Actions
var LOGIN_START = 'chama/auth/LOGIN_START';
var LOGIN_SUCCESS = 'chama/auth/LOGIN_SUCCESS';
var LOGOUT = 'chama/auth/LOGOUT';
var AUTH_ERROR = 'chama/auth/AUTH_ERROR';
var APPLY_ROLE = 'chama/auth/APPLY_ROLE';
var APPLY_USER_DISPLAY_NAME = 'chama/auth/APPLY_USER_DISPLAY_NAME';
var APPLY_PERMISSIONS = 'chama/auth/APPLY_PERMISSIONS';

var initialState = {
  loading: false,
  success: false,
  error: null,
  chamaID: null,
  role: null,
  permissions: null,
  userDisplayName: null
};

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOGIN_START:
      return _extends({}, state, {
        loading: true,
        error: null
      });
    case LOGIN_SUCCESS:
      return _extends({}, state, {
        loading: false,
        success: true,
        uid: action.payload.uid,
        chamaID: action.payload.chamaID,
        role: action.payload.role,
        permissions: action.payload.permissions,
        userDisplayName: action.payload.displayName
      });
    case LOGOUT:
      return _extends({}, initialState);
    case AUTH_ERROR:
      return _extends({}, state, {
        loading: false,
        error: action.payload,
        success: false
      });
    case APPLY_ROLE:
      return _extends({}, state, {
        role: action.payload
      });
    case APPLY_PERMISSIONS:
      return _extends({}, state, {
        permissions: action.payload
      });
    case APPLY_USER_DISPLAY_NAME:
      return _extends({}, state, {
        userDisplayName: action.payload
      });
    default:
      return state;
  }
}

// Action creators
function startLogin() {
  return { type: LOGIN_START };
}
function onLoginSuccess(payload) {
  return { type: LOGIN_SUCCESS, payload: payload };
}
function onLoginFailure(payload) {
  return { type: AUTH_ERROR, payload: payload };
}
function onLogout() {
  return { type: LOGOUT };
}

// Actions
var login = exports.login = function login() {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState, _ref2) {
      var api = _ref2.api,
          firebaseClient = _ref2.firebaseClient;

      var _ref3, ra;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(startLogin());
              _context.prev = 1;
              _context.next = 4;
              return firebaseClient.signInWithGoogle();

            case 4:
              _ref3 = _context.sent;
              ra = _ref3.user.ra;

              // use regular Google token to ask for enriched one
              api.signInWithToken(function () {
                return ra;
              });
              _context.next = 9;
              return api.enrichToken();

            case 9:
              _context.next = 11;
              return firebaseClient.getToken(true);

            case 11:
              return _context.abrupt('return', _context.sent);

            case 14:
              _context.prev = 14;
              _context.t0 = _context['catch'](1);

              console.log(_context.t0);
              return _context.abrupt('return', dispatch(onLoginFailure(_context.t0)));

            case 18:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined, [[1, 14]]);
    }));

    return function (_x3, _x4, _x5) {
      return _ref.apply(this, arguments);
    };
  }();
};

var updateToken = exports.updateToken = function updateToken(user) {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState, _ref5) {
      var api = _ref5.api,
          firebaseClient = _ref5.firebaseClient;

      var _getState, success, uid, ra, displayName, _jwtDecode, cbRoles, chamaID, permissions;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _getState = getState(), success = _getState.auth.success;

              if (!success) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt('return', false);

            case 4:

              api.signInWithToken(function () {
                return firebaseClient.getToken();
              });

              uid = user.uid, ra = user.ra, displayName = user.displayName;
              // get user roles from token

              _jwtDecode = (0, _jwtDecode3.default)(ra), cbRoles = _jwtDecode.cb_roles, chamaID = _jwtDecode.c_id;
              // throw error if user has no roles

              if (cbRoles.length) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt('return', dispatch(onLoginFailure({ code: 'unauthorised' })));

            case 9:
              _context2.next = 11;
              return api.getPermissions();

            case 11:
              permissions = _context2.sent;
              return _context2.abrupt('return', dispatch(onLoginSuccess({
                role: cbRoles,
                uid: uid,
                chamaID: chamaID,
                permissions: processPermissions(cbRoles, permissions),
                displayName: displayName
              })));

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2['catch'](0);

              console.log(_context2.t0);
              return _context2.abrupt('return', dispatch(onLoginFailure(_context2.t0)));

            case 19:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, undefined, [[0, 15]]);
    }));

    return function (_x6, _x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var logout = exports.logout = function logout() {
  return function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState, _ref7) {
      var firebaseClient = _ref7.firebaseClient;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch(onLogout());
              firebaseClient.signOut();

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, undefined);
    }));

    return function (_x9, _x10, _x11) {
      return _ref6.apply(this, arguments);
    };
  }();
};

// Helpers
function processPermissions(role, permissions) {
  var roles = role.split('|');

  return Object.keys(permissions).reduce(function (result, key) {
    if (roles.includes(key)) {
      return [].concat(_toConsumableArray(result), _toConsumableArray(permissions[key]));
    }
    return result;
  }, []);
}

/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(140);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(141);

var _lodash4 = _interopRequireDefault(_lodash3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFilteredDealerOrders = function getFilteredDealerOrders(state) {
  var filteredAll = state.dealer.filteredAll;

  var filteredDealerIds = (0, _lodash4.default)(filteredAll);
  var ordersDict = state.orders.dict;
  var orders = ordersDict ? (0, _lodash2.default)(ordersDict) : [];

  if (filteredDealerIds.length) {
    var filterOrders = function filterOrders(order) {
      return filteredDealerIds.indexOf(order.dealerId) !== -1;
    };

    return orders.filter(filterOrders);
  }

  return orders;
};

exports.default = getFilteredDealerOrders;

/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _OpeningTimes = __webpack_require__(3405);

var _OpeningTimes2 = _interopRequireDefault(_OpeningTimes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Dealer = function () {
  function Dealer(dealerData) {
    _classCallCheck(this, Dealer);

    this.openingTimes = null;

    Object.assign(this, dealerData);
    this.openingTimes = new _OpeningTimes2.default(dealerData.openingTimes);
  }
  /**
   * @type {OpeningTimes}
   */


  _createClass(Dealer, null, [{
    key: 'getMainShopIdFromSubshopId',
    value: function getMainShopIdFromSubshopId(subshopId) {
      if (!subshopId) return false;

      var dashes = (subshopId.match(/-/g) || []).length;

      if (dashes < 2) return subshopId;

      var firstDashIndex = subshopId.indexOf('-');
      var secondDashIndex = subshopId.indexOf('-', firstDashIndex + 1);

      var mainShopId = subshopId.substring(0, secondDashIndex);

      return mainShopId;
    }
  }, {
    key: 'isSubshop',
    value: function isSubshop(shopId) {
      return (shopId.match(/-/g) || []).length > 1;
    }
  }, {
    key: 'isMainshop',
    value: function isMainshop(shopId) {
      return (shopId.match(/-/g) || []).length <= 1;
    }
  }]);

  return Dealer;
}();

exports.default = Dealer;

/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _OrderPanelSection = __webpack_require__(3453);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OrderPanelSection).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ })

},[3390]);


// WEBPACK FOOTER //
// app.5a8cca47.js